// Русский словарь платформы. Все видимые человеку тексты — только отсюда.
// Параметры подставляются по именам в фигурных скобках: {address}.
// Узел с ключами one/few/many/other — формы для склонения по числу {count}.

import { ruAccess } from './ru-access.ts';
import { ruAi, ruAiAudit, ruAiErrors, ruAiNotifications, ruBriefErrors } from './ru-ai.ts';
import { ruCabinetClientAudit, ruCabinetErrors, ruCabinetStaff } from './ru-cabinet.ts';
import { ruDadata, ruDadataAudit } from './ru-dadata.ts';
import { ruSiteConfig, ruSiteConfigAudit } from './ru-site-config.ts';
import { ruHiringAudit, ruHiringNotificationTypes, ruTeamHiring } from './ru-hiring.ts';
import { ruDocuments, ruDocumentsAudit, ruDocumentsErrors } from './ru-documents.ts';
import {
  ruFinance,
  ruFinanceAudit,
  ruFinanceErrors,
  ruFinanceNotifications,
  ruFinanceNotificationTypes,
} from './ru-finance.ts';
import {
  ruFinanceBank,
  ruFinanceRegistry,
  ruFinanceBankAudit,
  ruFinanceBankErrors,
  ruFinanceBankNotifications,
  ruFinanceBankNotificationTypes,
} from './ru-finance-bank.ts';
import {
  ruFinanceAcquiring,
  ruFinanceAcquiringAudit,
  ruFinanceAcquiringErrors,
} from './ru-finance-acquiring.ts';
import {
  ruEdo,
  ruEdoAudit,
  ruEdoClientAudit,
  ruEdoErrors,
  ruEdoNotifications,
  ruEdoNotificationTypes,
} from './ru-edo.ts';
import { ruFeedback } from './ru-feedback.ts';
import {
  ruProjectsPayment,
  ruProjectsPaymentAudit,
  ruProjectsPaymentErrors,
  ruProjectsPaymentNotifications,
  ruProjectsPaymentNotificationTypes,
} from './ru-projects-payment.ts';
import { ruPortal } from './ru-portal.ts';
import {
  ruProjectsDelivery,
  ruProjectsDeliveryAudit,
  ruProjectsDeliveryErrors,
  ruProjectsDeliveryHints,
  ruProjectsDeliveryNotifications,
} from './ru-projects-delivery.ts';
import {
  ruProjectsSupport,
  ruProjectsSupportAudit,
  ruProjectsSupportErrors,
  ruProjectsSupportLetters,
  ruProjectsSupportNotifications,
  ruProjectsSupportNotificationTypes,
  ruProjectsSupportPalette,
} from './ru-projects-support.ts';
import { ruProjects, ruProjectsAudit, ruProjectsErrors } from './ru-projects.ts';
import {
  ruProjectsClient,
  ruProjectsClientAudit,
  ruProjectsClientErrors,
  ruProjectsClientNotifications,
} from './ru-projects-client.ts';
import { ruProjectsAi, ruProjectsAiHints } from './ru-projects-ai.ts';
import {
  ruProjectsWork,
  ruProjectsWorkAudit,
  ruProjectsWorkCard,
  ruProjectsWorkErrors,
  ruProjectsWorkPalette,
  ruProjectsWorkTask,
  ruTeamPayable,
} from './ru-projects-work.ts';

export const ru = {
  app: {
    name: 'Глори.Штат',
    /** Знак: «Глори» + красная точка + «Штат». */
    logo: 'Глори',
    logoShort: 'Г',
    logoDot: '.',
    logoSuffix: 'Штат',
    /** Бренд студии для клиентов: письма клиенту, кабинет, документы. */
    studioName: 'Глори.Цифра',
    studioLogoSuffix: 'Цифра',
  },
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    close: 'Закрыть',
    done: 'Готово',
    delete: 'Удалить',
    undo: 'Отменить',
    deleted: 'Удалено',
    retry: 'Повторить',
    loading: 'Загрузка…',
    search: 'Поиск',
    history: 'История',
    archive: 'В архив',
    create: 'Создать',
    edit: 'Изменить',
    yes: 'Да',
    no: 'Нет',
  },
  ui: {
    close: 'Закрыть',
    more: 'Ещё',
    loading: 'Загрузка…',
    empty: 'Пока пусто',
    undo: 'Отменить',
    deleted: 'Удалено',
    retry: 'Повторить',
    required: 'обязательно',
    optional: 'необязательно',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    clear: 'Очистить',
    copy: 'Скопировать',
    copied: 'Скопировано',
    sortAscending: 'По возрастанию',
    sortDescending: 'По убыванию',
    undoWithin: {
      one: 'Отменить можно в течение {count} секунды',
      few: 'Отменить можно в течение {count} секунд',
      many: 'Отменить можно в течение {count} секунд',
      other: 'Отменить можно в течение {count} секунды',
    },
  },
  fields: {
    hint: 'Как это работает',
    hintFor: 'Как это работает: {label}',
    example: 'Пример',
    required: 'обязательно',
    counter: '{count} из {max}',
    emailSuggestion: 'Может быть, {email}?',
    emailInvalid: 'Проверьте адрес — в нём должны быть @ и домен, например anna@studio.ru',
    capsLock: 'Включён Caps Lock',
    tooLong: 'Слишком длинно — сократите до {max} символов',
    voiceInput: 'Голосовой ввод',
    fileDrop: 'Перетащите файл сюда или вставьте из буфера',
    fileDropMany: 'Перетащите файлы сюда или вставьте из буфера',
    fileDropActive: 'Отпустите — загрузим',
    fileChoose: 'Выбрать файл',
    fileChooseMany: 'Выбрать файлы',
    fileReplace: 'Заменить',
    fileLimit: 'До {limit}',
    fileRemove: 'Убрать файл',
    fileCancel: 'Отменить загрузку',
    fileRetry: 'Повторить',
    fileUploading: 'Загружаем {name}: {percent}',
    fileUploadFailed: 'Не удалось загрузить — проверьте соединение и попробуйте ещё раз',
    fileTypeNotAllowed: 'Такой тип файла здесь не подходит',
    fileSingleOnly: 'Сюда можно положить только один файл',
    fileOpen: 'Открыть {name}',
    selectPlaceholder: 'Выберите',
    selectSearch: 'Поиск',
    selectOptions: 'Варианты',
    selectEmpty: 'Ничего не нашли',
    selectLoading: 'Ищем…',
    selectLoadFailed: 'Не удалось загрузить список.',
    selectTypeToSearch: 'Начните вводить — покажем варианты',
    selectCreate: 'Создать «{query}»',
    selectCreateFailed: 'Не удалось создать — попробуйте ещё раз',
    selectRemove: 'Убрать «{label}»',
    datePlaceholder: 'дд.мм.гггг',
    dateRangePlaceholder: 'дд.мм.гггг – дд.мм.гггг',
    timePlaceholder: 'чч:мм',
    openCalendar: 'Открыть календарь',
    chooseTime: 'Выбрать время',
    time: 'Время',
    understood: 'Поняли так: {value}',
    dateHint: 'Например: 28.09, завтра, пт или +3д',
    dateInvalid: 'Не поняли дату — напишите, например, 28.09, завтра, пт или +3д',
    dateTooEarly: 'Не раньше {date}',
    dateTooLate: 'Не позже {date}',
    dateRangeHint: 'Например: 1.09–30.09 или 28–30.09',
    dateRangeInvalid: 'Не поняли период — напишите, например, 1.09–30.09',
    timeHint: 'Например: 9:30, 930 или 9ч',
    timeInvalid: 'Не поняли время — напишите, например, 9:30',
    presetToday: 'Сегодня',
    presetTomorrow: 'Завтра',
    presetNextWeek: 'Через неделю',
    presetMonthEnd: 'Конец месяца',
    rangeThisWeek: 'Эта неделя',
    rangeLastWeek: 'Прошлая неделя',
    rangeThisMonth: 'Этот месяц',
    rangeLastMonth: 'Прошлый месяц',
    rangeThisQuarter: 'Этот квартал',
    rangeLastQuarter: 'Прошлый квартал',
    rangeThisYear: 'Этот год',
    rangeLastYear: 'Прошлый год',
    moneyInvalid: 'Не поняли сумму — напишите, например, 120 000, 120к или =1200*3',
    moneyHint: 'Можно: 120к, 1,2м, =1200*3',
    percentInvalid: 'Не поняли процент — напишите, например, 40 или 12,5',
    multiplierInvalid: 'Не поняли коэффициент — напишите, например, 1,3',
    hoursInvalid: 'Не поняли время — напишите, например, 1,5, 1:30 или 90м',
    hoursHint: 'Можно: 1,5, 1:30, 90м, 1ч 30м',
    numberInvalid: 'Не поняли число',
    numberInteger: 'Нужно целое число',
    numberNegative: 'Отрицательное значение здесь не подходит',
    numberTooSmall: 'Не меньше {min}',
    numberTooLarge: 'Не больше {max}',
    phonePlaceholder: '+7 (999) 123-45-67',
    phoneCountry: 'Страна: {country}',
    phoneCountries: 'Страны',
    phoneTooShort: 'Не хватает цифр в номере',
    phoneTooLong: 'Слишком много цифр — проверьте номер',
    phoneWrongLength: 'Неверное количество цифр — проверьте номер',
    phoneInvalid: 'Такого номера не бывает — проверьте код и цифры',
    phoneCopy: 'Скопировать номер',
    phoneCopied: 'Номер скопирован',
    phoneCall: 'Позвонить',
    phoneWhatsApp: 'Написать в WhatsApp',
    richToolbar: 'Оформление текста',
    richHeading2: 'Заголовок',
    richHeading3: 'Подзаголовок',
    richBold: 'Жирный',
    richItalic: 'Курсив',
    richStrike: 'Зачёркнутый',
    richBulletList: 'Маркированный список',
    richOrderedList: 'Нумерованный список',
    richLink: 'Ссылка',
    richLinkAddress: 'Адрес ссылки',
    richLinkPlaceholder: 'glory.studio или anna@studio.ru',
    richLinkInvalid: 'Не похоже на адрес — например, glory.studio',
    richLinkApply: 'Применить',
    richUnlink: 'Убрать ссылку',
    richInsertSearch: 'Найти',
    richInsertEmpty: 'Ничего не нашлось',
    richUndo: 'Отменить',
    richRedo: 'Повторить',
    employeePlaceholder: 'Выберите сотрудника',
    employeeInvited: 'приглашён',
    employeeInactive: 'отключён',
    avatarChoose: 'Выбрать фото',
    avatarUpload: 'Загрузить фото',
    avatarReplace: 'Заменить',
    avatarRemove: 'Убрать',
    avatarHint: 'JPG, PNG или WebP до {limit} — можно перетащить на кружок',
    avatarNotImage: 'Нужна картинка: JPG, PNG или WebP',
    avatarFailed: 'Не удалось подготовить фото — попробуйте другое',
    avatarUploading: 'Загружаем фото',
    avatarCropTitle: 'Кадрирование',
    avatarCropLead: 'Перетащите фото и выберите масштаб — в кружке то, что увидят коллеги',
    avatarZoom: 'Масштаб',
    suggestions: 'Подсказки',
    suggestUnavailable: 'Подсказки недоступны — введите вручную',
    companyHint: 'Название или ИНН — реквизиты подставятся сами',
    divisionHint: 'Введите код — «Кем выдан» подставится сам',
    companyPlaceholder: 'Название или ИНН',
    companyPickOrInn: 'Выберите компанию из подсказок или введите ИНН',
    companyInactive: 'не действует',
    innPlaceholder: 'ИНН',
    innShort: 'ИНН {inn}',
    kppShort: 'КПП {kpp}',
    bankPlaceholder: 'БИК или название банка',
    bankPickOrBic: 'Выберите банк из подсказок или введите БИК',
    bicPlaceholder: 'БИК',
    bicShort: 'БИК {bic}',
    corrShort: 'к/с {account}',
    accountPlaceholder: '20 цифр',
    addressPlaceholder: 'Город, улица, дом',
  },
  auth: {
    brandLine: 'Заявки, расчёты, договоры и деньги студии — в одном месте',
    loginTitle: 'Вход',
    loginLead: 'Войдите, чтобы продолжить работу в Глори.Штат',
    email: 'Email',
    password: 'Пароль',
    signIn: 'Войти',
    or: 'или',
    signInWithPasskey: 'Войти с ключом доступа',
    passkeyHint: 'Отпечаток, лицо или PIN устройства — без пароля',
    twoFactorTitle: 'Код подтверждения',
    twoFactorLead: 'Откройте приложение-аутентификатор и введите 6 цифр для Глори.Штат',
    backupCodeLead: 'Введите один из резервных кодов, которые вы сохранили при включении проверки',
    code: 'Код',
    backupCode: 'Резервный код',
    verify: 'Подтвердить',
    useBackupCode: 'Нет доступа к приложению — ввести резервный код',
    useTotp: 'Ввести код из приложения',
    trustDevice: 'Не спрашивать код на этом устройстве 30 дней',
    back: 'Назад',
    signOut: 'Выйти',
    sessionExpired: 'Сеанс завершён — войдите снова',
    inviteTitle: 'Приглашение в Глори.Штат',
    invitedBy: '{name} приглашает вас в команду',
    invitedAnonymous: 'Вас приглашают в команду',
    inviteRoles: 'Роль',
    invitePosition: 'Должность',
    inviteExpires: 'Ссылка действует до {date}',
    yourName: 'Как вас зовут',
    yourNameHint: 'Имя и фамилия — так вас увидят коллеги и клиенты в документах',
    newPassword: 'Придумайте пароль',
    newPasswordHint: 'Не короче {min} символов. Можно фразой: «синий-кит-пьёт-чай»',
    repeatPassword: 'Повторите пароль',
    passwordsMismatch: 'Пароли не совпадают',
    createAccount: 'Создать учётную запись',
    toLogin: 'Ко входу',
    passkeyOfferTitle: 'Входить без пароля',
    passkeyOfferText:
      'Ключ доступа (passkey) — вход по отпечатку, лицу или PIN этого устройства. Надёжнее пароля, и ничего не нужно запоминать.',
    addPasskey: 'Добавить ключ доступа',
    later: 'Позже',
    passkeyAdded: 'Ключ доступа добавлен',
    welcome: 'Добро пожаловать, {name}',
    forgotPassword: 'Забыли пароль?',
    forgotTitle: 'Сброс пароля',
    forgotLead: 'Пришлём на ваш email ссылку, по которой можно задать новый пароль',
    sendResetLink: 'Прислать ссылку',
    resetSentTitle: 'Проверьте почту',
    resetSentLead:
      'Если {email} есть в Глори.Штат, на него пришло письмо со ссылкой. Она действует час и срабатывает один раз',
    resetSentHint: 'Письма нет несколько минут — проверьте «Спам» или запросите ссылку ещё раз',
    sendAgain: 'Прислать ещё раз',
    resetTitle: 'Новый пароль',
    resetLead: 'После сохранения сеансы на других устройствах завершатся',
    saveNewPassword: 'Сохранить пароль',
    resetDone: 'Пароль изменён — войдите с новым паролем',
    resetNoToken: 'В ссылке нет кода сброса — откройте её из письма целиком или запросите новую',
    requestNewLink: 'Запросить новую ссылку',
  },
  security: {
    title: 'Безопасность',
    lead: 'Как вы входите в Глори.Штат и где открыт ваш сеанс',
    devices: {
      title: 'Устройства и секретные чаты',
      lead: 'Ключ сквозного шифрования и браузеры, где открываются секретные чаты и сквозные звонки',
      hint: {
        title: 'Что такое ключ шифрования',
        text: 'Секретные чаты и сквозные звонки шифруются на ваших устройствах — их не прочитает даже администратор сервера. Ключ создаётся один раз и записывается фразой из 12 слов. Новое устройство подтверждается этой фразой или с уже подтверждённого устройства',
        example: 'Потеряли ноутбук — отключите его здесь: новые сообщения он уже не прочитает',
      },
      browser: 'Браузер',
      noKey: 'Ключа ещё нет. Создайте его, чтобы писать в секретные чаты и звонить со сквозным шифрованием',
      unavailable:
        'Этот браузер не умеет хранить ключи (частный режим или старая версия) — секретные чаты здесь не откроются',
      createKey: 'Создать ключ',
      keyCreated: 'Ключ создан, устройство подтверждено',
      phraseTitle: 'Фраза восстановления',
      phraseLead:
        'Запишите эти 12 слов по порядку и храните в надёжном месте. Только по ним можно вернуть доступ к секретным чатам на новом устройстве — сервер их не знает и не восстановит',
      phraseCopied: 'Фраза скопирована',
      phraseSaved: 'Я записал(а) фразу',
      replaceWarning:
        'Новый ключ заменит прежний: все ваши устройства отключатся, а история секретных чатов и пароли сейфа, доступные только по старому ключу, будут потеряны',
      checkTitle: 'Проверка фразы',
      checkLead: 'Введите слова с указанными номерами',
      wordNumber: 'Слово № {number}',
      checkWrong: 'Слова не совпадают с фразой — проверьте запись',
      showAgain: 'Показать фразу',
      restoreTitle: 'Подтвердить фразой',
      restoreLead: 'Введите 12 слов фразы восстановления через пробел',
      phrase: 'Фраза восстановления',
      wordsCount: 'Слов: {count} из {total}',
      phraseWrong: 'Фраза не подходит — проверьте слова и их порядок',
      approveThis: 'Подтвердить устройство',
      approved: 'Устройство подтверждено',
      pendingTitle: 'Это устройство ещё не подтверждено',
      pendingLead:
        'Введите фразу восстановления или откройте этот раздел на подтверждённом устройстве и подтвердите это — коды на обоих экранах должны совпасть',
      enterPhrase: 'Ввести фразу',
      check: 'Проверить',
      lostPhrase: 'Нет фразы и других устройств',
      thisDevice: 'это устройство',
      waiting: 'ждёт подтверждения',
      added: 'Добавлено {date}',
      approve: 'Подтвердить',
      approveTitle: 'Подтвердить «{name}»?',
      approveLead:
        'Сравните шесть цифр с теми, что видны на экране нового устройства. Совпадают — подтверждайте; нет — это не ваше устройство',
      codeMatches: 'Цифры совпадают',
      codeDiffers: 'Не совпадают',
      revoke: 'Отключить',
      revokeTitle: 'Отключить «{name}»?',
      revokeLead:
        'Устройство не получит ключей новых сообщений, а при следующем входе его ключи сотрутся. Секретные чаты начнут новый ключ без него',
      revoked: 'Устройство отключено',
      failed: 'Не получилось — попробуйте ещё раз',
    },
    required: {
      title: 'Включите защиту входа',
      lead: 'Студия требует от админов второй шаг входа: ключ входа (passkey) или код из приложения. Пока защита не включена, работа в платформе закрыта',
      continue: 'Продолжить',
      stillRequired: 'Защита ещё не включена — добавьте ключ входа или включите код из приложения',
      logout: 'Выйти',
    },
    policy: {
      title: 'Защита входа',
      lead: 'Требования ко входу для всех сотрудников студии',
      adminTwoFactor: 'Обязательная 2FA для админов',
      adminTwoFactorHint:
        'Админ без ключа входа или кода из приложения после входа попадёт на экран настройки защиты и не сможет работать, пока её не включит',
      saved: 'Защита входа сохранена',
    },
    encryption: {
      title: 'Шифрование данных',
      lead: 'Сообщения, паспорт, СНИЛС и счёт сотрудников лежат в базе шифровкой мастер-ключа',
      hint: {
        title: 'Мастер-ключ',
        text: 'Ключ хранится в секрете сервера, а не в базе: дамп базы или бэкап без него ничего не раскрывает. После смены ключа платформа сама перешифровывает данные раз в час',
        example: 'Старую версию ключа можно убрать из секрета, когда здесь не останется записей на ней',
      },
      active: 'Активный ключ — {version}',
      done: 'Все данные зашифрованы активным ключом',
      pending: 'Ждут перешифрования: {count}',
      plain: 'ещё не зашифровано',
      legacy: 'старый ключ',
      version: 'ключ {version}',
    },
    passwordSection: 'Пароль',
    passwordLead: 'После смены пароля сеансы на других устройствах завершатся',
    currentPassword: 'Текущий пароль',
    changePassword: 'Сменить пароль',
    passwordChanged: 'Пароль изменён, другие сеансы завершены',
    passkeysSection: 'Ключи доступа',
    passkeysLead:
      'Вход по отпечатку, лицу или PIN устройства. Ключ хранится на устройстве или в менеджере паролей',
    passkeysEmpty: 'Ключей пока нет — добавьте, чтобы входить без пароля',
    passkeyAdded: 'Добавлен {date}',
    passkeyUnnamed: 'Ключ доступа',
    passkeyDeleted: 'Ключ доступа удалён',
    passkeyName: 'Название ключа',
    deletePasskey: 'Удалить ключ',
    twoFactorSection: 'Двухфакторная проверка',
    twoFactorLead: 'При входе по паролю Глори.Штат спросит ещё и код из приложения-аутентификатора',
    twoFactorOn: 'Включена',
    twoFactorOff: 'Выключена',
    enableTwoFactor: 'Включить',
    disableTwoFactor: 'Выключить',
    confirmWithPassword: 'Подтвердите паролем',
    scanQr:
      'Отсканируйте код в приложении-аутентификаторе (Яндекс Ключ, Google Authenticator, 1Password) и введите 6 цифр из него',
    secretKey: 'Ключ для ручного ввода',
    backupCodesTitle: 'Резервные коды',
    backupCodesLead:
      'Сохраните их в надёжном месте: каждый код срабатывает один раз, если телефона с приложением не окажется под рукой. Больше мы их не покажем.',
    copyCodes: 'Скопировать коды',
    codesSaved: 'Я сохранил коды',
    twoFactorEnabled: 'Двухфакторная проверка включена',
    twoFactorDisabled: 'Двухфакторная проверка выключена',
    sessionsSection: 'Активные сеансы',
    sessionsLead: 'Устройства, на которых выполнен вход. Незнакомый сеанс — завершите его и смените пароль',
    currentSession: 'Этот сеанс',
    sessionStarted: 'Вход {date}',
    endSession: 'Завершить',
    endOtherSessions: 'Завершить все другие',
    sessionEnded: 'Сеанс завершён',
    otherSessionsEnded: 'Другие сеансы завершены',
    unknownDevice: 'Неизвестное устройство',
    deviceOn: '{browser}, {os}',
    continue: 'Продолжить',
    lastActive: 'Активен {date}',
    ipAddress: 'IP {ip}',
    codesCopied: 'Коды скопированы',
    secretCopied: 'Ключ скопирован',
    mailSection: 'Рабочая почта',
    mailLead:
      'Почта в Thunderbird, Apple Mail или на телефоне входит по паролю приложения — не по паролю от Глори.Штат. Отдельный пароль для каждой программы',
    mailNone: 'Рабочего ящика у вас пока нет — его создаёт администратор в настройках почты',
    mailPending: 'Ящик создаётся на почтовом сервере — пароль приложения можно будет создать через минуту',
    mailBlocked: 'Ящик заблокирован — обратитесь к администратору',
    mailFailed: 'Ящик не создался — администратор уже знает и повторит',
    sharedMailboxes: 'Общие ящики',
    appPasswords: 'Пароли приложений',
    appPasswordsEmpty: 'Паролей пока нет — создайте, чтобы подключить почтовую программу',
    newAppPassword: 'Новый пароль',
    appPasswordName: 'Для какой программы',
    appPasswordNameHint: 'Чтобы потом узнать и отозвать: «Thunderbird на ноутбуке», «Почта на iPhone»',
    createAppPassword: 'Создать пароль',
    appPasswordReady: 'Пароль для «{name}»',
    appPasswordOnce: 'Скопируйте его в почтовую программу сейчас — больше мы его не покажем',
    copyPassword: 'Скопировать пароль',
    passwordCopied: 'Пароль скопирован',
    revokeAppPassword: 'Отозвать',
    appPasswordRevoked: 'Пароль «{name}» отозван — программа с ним больше не войдёт',
    appPasswordCreated: 'Создан {date}',
  },
  files: {
    defaultName: 'файл',
  },
  notifications: {
    title: 'Уведомления',
    settingsTitle: 'Уведомления',
    matrixTitle: 'Типы уведомлений',
    settingsLead: 'Что и куда присылать. Уведомления в интерфейсе приходят сразу, пока Глори.Штат открыт',
    channelInApp: 'В интерфейсе',
    channelPush: 'Push',
    channelEmail: 'Email',
    locked: 'Это уведомление нельзя отключить',
    emailInsteadOfPush:
      'Если push включён, но показать его негде — нет ни одного устройства, — уведомление придёт на email',
    sendTest: 'Отправить тестовое',
    testSent: 'Тестовое уведомление отправлено',
    empty: 'Новых уведомлений нет',
    markAllRead: 'Прочитать все',
    typeTest: 'Тестовое уведомление',
    typeTestHint: 'Проверка, что уведомления доходят до этого устройства',
    testTitle: 'Уведомления работают',
    testBody: 'Так будут выглядеть уведомления Глори.Штат',
    typeUserJoined: 'Приглашение принято',
    typeUserJoinedHint: 'Приглашение приняли: создана учётная запись',
    typeVaultRotate: 'Смените пароли',
    typeVaultRotateHint: 'Кто-то с доступом к сейфу ушёл из проекта или уволен',
    userJoinedTitle: 'В команде новый человек: {name}',
    userJoinedBody: 'Приглашение на {email} принято',
    typeMailboxCreated: 'Ящик создан',
    typeMailboxCreatedHint: 'Ваш рабочий почтовый ящик готов к работе',
    mailboxCreatedTitle: 'Ящик {address} готов',
    mailboxCreatedBody: 'Подключите почтовую программу: пароль приложения — в разделе «Безопасность»',
    typeMailNewMessage: 'Новое письмо',
    typeMailNewMessageHint:
      'Письмо пришло во входящие вашего ящика; для общих ящиков уведомления включаются отдельно — в профиле, «Почта»',
    mailNewTitle: 'Письмо от {sender}',
    mailNewMany: {
      one: 'Новое письмо ({count})',
      few: 'Новых письма: {count}',
      many: 'Новых писем: {count}',
      other: 'Новых письма: {count}',
    },
    mailNewShared: '{mailbox}: {text}',
    mailNewLast: 'Последнее — {sender}: {subject}',
    mailNewNoSubject: '(без темы)',
    typePolicyPublished: 'Новая версия политики цены',
    typePolicyPublishedHint: 'Изменились накладные, наценка, минимальная маржа или шаг округления',
    policyPublishedTitle: 'Политика цены с {date}',
    policyPublishedBody:
      'Накладные {overhead}, наценка {markup}, мин. маржа {minMargin}, округление до {step}',
    typeMailboxFailed: 'Не удалось создать ящик',
    typeMailboxFailedHint: 'Почтовый сервер не создал ящик — нужно поправить адрес или повторить',
    mailboxFailedTitle: 'Не удалось создать ящик {address}',
    mailboxFailedTaken: 'Адрес уже занят — выберите другой в настройках почты',
    mailboxFailedRejected: 'Почтовый сервер отклонил адрес — выберите другой в настройках почты',
    mailboxFailedUnavailable: 'Почтовый сервер недоступен — повторим сами, как только он ответит',
    pushTitle: 'Push-уведомления',
    pushLead:
      'Приходят, даже когда Глори.Штат закрыт. Включите на каждом компьютере и телефоне, где хотите их получать',
    pushEnable: 'Включить на этом устройстве',
    pushDisable: 'Выключить на этом устройстве',
    pushEnabled: 'Push включён на этом устройстве',
    pushDisabled: 'Push выключен на этом устройстве',
    pushFailed: 'Не удалось включить push — попробуйте ещё раз',
    pushNotConfigured: 'Push на сервере пока не настроен — уведомления приходят в интерфейс',
    pushUnsupported: 'Этот браузер не умеет получать push-уведомления',
    pushBlocked:
      'Уведомления для Глори.Штат запрещены в настройках браузера. Разрешите их для этого сайта и обновите страницу',
    pushDismissed: 'Браузер не получил разрешения — нажмите ещё раз и выберите «Разрешить»',
    pushIosInstall:
      'На iPhone push приходит только в установленное приложение: нажмите «Поделиться» → «На экран „Домой“» и откройте Глори.Штат с иконки',
    pushNoDevices: 'Push пока не включён ни на одном устройстве',
    pushThisDevice: 'Это устройство',
    pushDeviceAdded: 'Подключено {date}',
    pushLastDelivery: 'последняя доставка {date}',
    pushRemoveDevice: 'Отключить устройство',
    pushDeviceRemoved: 'Устройство отключено',
    typeMessengerDirect: 'Личное сообщение',
    typeMessengerDirectHint: 'Вам написали в личный чат',
    typeMessengerMention: 'Упоминание',
    typeMessengerMentionHint: 'Вас упомянули через @имя или @все в группе или чате объекта',
    typeMessengerReply: 'Ответ на ваше сообщение',
    typeMessengerReplyHint: 'Кто-то ответил цитатой на ваше сообщение',
    typeMessengerThread: 'Ответ в треде',
    typeMessengerThreadHint: 'Новый ответ в треде, где вы писали, упомянуты или нажали «Следить»',
    typeMessengerTaskTopic: 'Новое в теме вашей задачи',
    typeMessengerTaskTopicHint: 'Сообщение в теме задачи проекта, где вы исполнитель',
    typeMessengerMessage: 'Сообщение в группе',
    typeMessengerMessageHint: 'Любое сообщение в чате, где вы включили режим «Все»',
    typeMessengerReminder: 'Напоминание',
    typeMessengerReminderHint: 'Напоминание о сообщении, которое вы поставили через «Напомнить»',
    typeMessengerScheduledFailed: 'Отложенное сообщение не отправлено',
    typeMessengerScheduledFailedHint: 'В срок не удалось отправить ваше отложенное сообщение',
    typeProjectsCreated: 'Новый проект',
    typeProjectsCreatedHint: 'Создан проект, которым вы руководите: пора назначить исполнителей',
    typeProjectsTaskAssigned: 'Вам назначена задача',
    typeProjectsTaskAssignedHint: 'Руководитель проекта назначил вас исполнителем задачи',
    typeProjectsTaskUnassigned: 'Задача снята с вас',
    typeProjectsTaskUnassignedHint: 'Руководитель назначил на вашу задачу другого исполнителя или снял её',
    typeProjectsReview: 'Задача на проверке',
    typeProjectsReviewHint:
      'Исполнитель сдал задачу вашего проекта на проверку: примите её и подтвердите часы',
    typeProjectsAccepted: 'Задача принята',
    typeProjectsAcceptedHint: 'Руководитель принял задачу и подтвердил часы — они пойдут в выплату',
    typeProjectsReturned: 'Задача возвращена',
    typeProjectsReturnedHint: 'Руководитель вернул вашу задачу на доработку с комментарием',
    typeProjectsTimerLong: 'Таймер идёт долго',
    typeProjectsTimerLongHint:
      'Таймер работает дольше, чем задано в настройках: возможно, его забыли остановить',
    typeProjectsDueTomorrow: 'Срок задачи завтра',
    typeProjectsDueTomorrowHint: 'Утром накануне срока по вашей незакрытой задаче',
    typeProjectsStageAtRisk: 'Этап под угрозой срыва',
    typeProjectsStageAtRiskHint:
      'Утром, если этап вашего проекта попал под угрозу: задача просрочена или часы не помещаются в свободное время исполнителя',
    typeProjectsInvoiceDue: 'Пора выставить счёт по этапу',
    typeProjectsInvoiceDueHint:
      'Закрыт этап проекта, и по графику оплат заявки пришёл срок следующей доли — ответственному по сделке и руководителю',
    typeProjectsDelivered: 'Проект сдан клиенту',
    typeProjectsDeliveredHint:
      'Итоговый акт по проекту ушёл на подпись — руководителю и ответственному по сделке',
    typeProjectsFinalSigned: 'Клиент подписал итоговый акт',
    typeProjectsFinalSignedHint: 'Проект сдан: клиент подписал итоговый акт кодом или сканом',
    typeProjectsRemarks: 'Замечания клиента',
    typeProjectsRemarksHint:
      'Клиент не подписал итоговый акт и оставил замечания — в проекте появился этап доработки',
    ...ruProjectsSupportNotificationTypes,
    ...ruProjectsPaymentNotificationTypes,
    ...ruFinanceNotificationTypes,
    ...ruFinanceBankNotificationTypes,
    ...ruEdoNotificationTypes,
    typeSalesAssigned: 'Вас назначили ответственным',
    typeSalesAssignedHint: 'Вас сделали ответственным за лид или сделку',
    typeSalesInvited: 'Вас позвали в сделку',
    typeSalesInvitedHint: 'Коллега добавил вас участником сделки',
    typeSalesRepeatLead: 'Новое обращение клиента',
    typeSalesRepeatLeadHint: 'Другой сотрудник завёл лид по клиенту, за которого отвечаете вы',
    typeSalesQueueNew: 'Новый лид в очереди',
    typeSalesQueueNewHint:
      'Автоматический источник положил заявку в очередь: кто первым нажмёт «Взять», тот и ответственный',
    typeSalesQueueTimeout: 'Лид долго ждёт в очереди',
    typeSalesQueueTimeoutHint:
      'Лид в очереди ждёт дольше времени, заданного в настройках продаж (считаются рабочие минуты)',
    ...ruHiringNotificationTypes,
    typeCabinetChatWaiting: 'Клиент ждёт ответа в кабинете',
    typeCabinetChatWaitingHint:
      'Сообщение клиента в личном кабинете 4 рабочих часа без ответа — участникам переписки',
    typeProjectsClientAnswered: 'Клиент ответил в кабинете',
    typeProjectsClientAnsweredHint:
      'Клиент ответил на задание, согласовал или прислал замечания — руководителю проекта и автору пункта',
    typeSalesUnassigned: 'Сделки без ответственного',
    typeSalesUnassignedHint:
      'Сотрудника отключили, и его открытые лиды и сделки остались без ответственного: назначьте им новых',
    typeSalesStepDue: 'Наступил шаг по сделке',
    typeSalesStepDueHint:
      'В назначенный момент — например, пора позвонить клиенту. Шаг без времени напоминает в 9:00',
    typeSalesMorningDigest: 'Утренняя сводка продаж',
    typeSalesMorningDigestHint:
      'В 9:00 рабочих дней: ваши шаги на сегодня, просроченные, сделки без шага и вернувшиеся из отложенных',
    typeEstimatesReview: 'Смета на проверке',
    typeEstimatesReviewHint:
      'Менеджер отправил смету на проверку: её нужно утвердить или вернуть с замечаниями',
    typeEstimatesApproved: 'Смета утверждена',
    typeEstimatesApprovedHint: 'Админ утвердил смету, которую вы отправили на проверку',
    typeEstimatesReturned: 'Замечания к смете',
    typeEstimatesReturnedHint: 'Админ вернул смету с замечаниями — поправьте и отправьте снова',
    typeEstimatesStageRequested: 'Просят оценить этап',
    typeEstimatesStageRequestedHint: 'Менеджер просит вас оценить часы своего этапа в смете',
    typeEstimatesStageEstimated: 'Этап оценён',
    typeEstimatesStageEstimatedHint: 'Сотрудник оценил этап, который вы просили оценить',
    typeProposalsMarginSent: 'КП ушло с низкой маржой',
    typeProposalsMarginSentHint:
      'Менеджер отправил КП с маржой ниже минимальной и написал причину — посмотрите, всё ли в порядке',
    typeProposalsBelowFloorRequested: 'Просят одобрить КП в минус',
    typeProposalsBelowFloorRequestedHint:
      'Цена КП ниже себестоимости: отправить его можно только с вашего одобрения',
    typeProposalsBelowFloorApproved: 'КП в минус одобрено',
    typeProposalsBelowFloorApprovedHint: 'Админ одобрил отправку КП, которое вы просили одобрить',
    typeProposalsFirstViewed: 'Клиент смотрит КП',
    typeProposalsFirstViewedHint: 'Клиент впервые открыл КП, которое вы отправили',
    typeProposalsPackageSelected: 'Клиент выбрал пакет',
    typeProposalsPackageSelectedHint: 'Клиент выбрал пакет в вашем КП — это принятое предложение',
    typeProposalsDeclined: 'Клиент: не подходит',
    typeProposalsDeclinedHint: 'Клиент ответил на КП, что оно не подходит, и назвал причину',
    typeProposalsQuestion: 'Вопрос по КП',
    typeProposalsQuestionHint: 'Клиент задал вопрос по КП',
    typeProposalsRenew: 'Клиент просит актуальное КП',
    typeProposalsRenewHint: 'КП клиента истекло или заменено новым, и он просит обновить предложение',
    typeDocumentsAwaiting: 'Ждёт вашей подписи',
    typeDocumentsAwaitingHint: 'Очередь подписи пакета документов дошла до вас — подпись кодом из письма',
    typeDocumentsStudioSigned: 'Подписано студией — ушло клиенту',
    typeDocumentsStudioSignedHint: 'Подписант студии подписал пакет, и ссылка сама ушла другой стороне',
    typeDocumentsFirstViewed: 'Клиент открыл документы',
    typeDocumentsFirstViewedHint: 'Другая сторона впервые открыла страницу подписания',
    typeDocumentsSigned: 'Документы подписаны',
    typeDocumentsSignedHint: 'Пакет подписан всеми: кодом из письма или сканом бумажных экземпляров',
    typeDocumentsDeclined: 'Отказ от подписи',
    typeDocumentsDeclinedHint: 'Другая сторона отказалась подписать документы и назвала причину',
    typeDocumentsQuestion: 'Вопрос по документам',
    typeDocumentsQuestionHint: 'Другая сторона задала вопрос со страницы подписания',
    typeDocumentsExpiring: 'Ссылка на подпись истекает',
    typeDocumentsExpiringHint: 'Завтра истекает ссылка на подпись — продлите её или напомните о подписи',
    typeDocumentsEmployeeSigned: 'Сотрудник подписал договор или акт',
    typeDocumentsEmployeeSignedHint: 'Сотрудник подписал свой договор или акт о выплате кодом из письма',
    typeDocumentsPaperMissing: 'Нет бумажного оригинала штатного договора',
    typeDocumentsPaperMissingHint:
      'Трудовой договор подписан кодом, но скан бумажного оригинала ещё не приложен — напоминание раз в день',
    typeDocumentsContractReminder: 'Подпишите договор',
    typeDocumentsContractReminderHint:
      'Напоминание раз в день, пока вы не заполнили данные и не подписали договор со студией',
    ...ruAiNotifications,
    pushCleared: 'Прочитано на другом устройстве',
    messengerSection: 'Мессенджер',
    messengerSectionLead: 'Как сообщения из чатов показываются в push на ваших устройствах',
    hidePushText: 'Скрывать текст сообщений в push',
    hidePushTextHint:
      'В уведомлении вместо текста сообщения будет «Новое сообщение». Имя отправителя и название чата остаются видны. В самом приложении текст показывается как обычно',
  },
  team: {
    payable: ruTeamPayable,
    hiring: ruTeamHiring,
    profileTitle: 'Профиль',
    profileLead: 'Как вас видят коллеги: фото и имя стоят рядом с вашими сообщениями, сделками и задачами',
    photo: 'Фото',
    photoLead: 'Видно всем сотрудникам — в чатах, сделках, списках и журнале',
    photoSaved: 'Фото обновлено',
    photoRemoved: 'Фото убрано',
    photoOffline: 'Фото не сохранилось: нет связи с сервером — попробуйте ещё раз',
    photoHint: 'Своё фото меняет каждый — в профиле. Фото коллеги меняет администратор в его карточке',
    aboutTitle: 'О вас',
    aboutLead: 'Имя, должность, телефон и роли ведёт администратор — в «Команде»',
    openCard: 'Карточка в «Команде»',
    personalTitle: 'Личные настройки',
    phone: 'Телефон',
    invite: 'Пригласить сотрудника',
    inviteLead: 'Сотрудник получит ссылку: задаст имя и пароль и сразу войдёт с выбранными ролями',
    inviteEmail: 'Рабочий email',
    inviteName: 'Имя и фамилия',
    inviteNameHint: 'Подставится в форму — сотрудник сможет поправить',
    invitePosition: 'Должность',
    inviteRoles: 'Роли',
    sendInvite: 'Создать приглашение',
    inviteReady: 'Приглашение готово',
    inviteReadyLead:
      'Отправьте ссылку сотруднику — она действует до {date}, по ней создаётся одна учётная запись',
    inviteSentLead:
      'Письмо с приглашением уходит на {email}. Ссылка действует до {date} — её можно отправить и самому',
    inviteMailbox: 'Рабочая почта',
    inviteMailboxHint: 'Пусто — имя и фамилия латиницей',
    inviteMailboxInfo:
      'Ящик создаётся на почтовом сервере студии сразу после приглашения. Отозвали приглашение или отключили сотрудника — ящик блокируется, письма сохраняются',
    inviteMailboxExample: 'Анна Нечаева → anna.nechaeva@{domain}',
    inviteMailboxFree: 'Свободен',
    inviteLink: 'Ссылка-приглашение',
    copyLink: 'Скопировать ссылку',
    linkCopied: 'Ссылка скопирована',
    inviteAnother: 'Пригласить ещё',
    done: 'Готово',
    title: 'Команда',
    lead: 'Кто в студии, чем занимается и сколько часов в неделю у него есть на проекты',
    columnPerson: 'Сотрудник',
    columnPosition: 'Должность',
    columnSpecializations: 'Специализации',
    columnCapacity: 'На проекты в неделю',
    columnRoles: 'Роли',
    columnRate: 'Ставка',
    capacityValue: '{billable} из {total} ч',
    you: 'это вы',
    inactive: 'отключён',
    showInactive: 'Показать отключённых',
    empty: 'В команде пока никого',
    notFound: 'Такого сотрудника нет',
    notFoundText: 'Возможно, ссылка устарела. Команда — в списке',
    invitationsTitle: 'Приглашения',
    invitationsLead: 'Ещё не приняты. Отозванная ссылка перестаёт работать, ящик блокируется',
    invitationExpires: 'действует до {date}',
    revoke: 'Отозвать',
    revoked: 'Приглашение для {email} отозвано',
    tabProfile: 'Профиль',
    tabRates: 'Ставки',
    tabHistory: 'История',
    sectionProfile: 'Профиль',
    sectionWork: 'Специализации и время',
    sectionMail: 'Почта',
    email: 'Рабочий email',
    position: 'Должность',
    hiredAt: 'Работает с',
    specializations: 'Специализации',
    specializationsHint:
      'По ним сотрудника подбирают в задачи. Пока у сотрудника нет личной ставки, цена считается по плановой ставке специализации',
    specializationsEmpty: 'Не указаны',
    specializationArchived: '{name} (в архиве)',
    weeklyCapacity: 'Часов в неделю',
    billableShare: 'Доля на проекты',
    billableShareHint:
      'Какая часть рабочего времени уходит на задачи клиентов, а не на внутренние дела. Сумма этих часов по команде — делитель накладных: из неё считается накладная ставка в час',
    billableShareExample: '40 часов и 80 % — 32 часа в неделю на проекты',
    workTime: 'Рабочее время',
    capacityFact: '{hours} в неделю, на проекты — {share}',
    roles: 'Роли',
    save: 'Сохранить профиль',
    saved: 'Профиль сохранён',
    mailPersonal: 'Личный ящик',
    mailShared: 'Общие ящики',
    mailNone: 'Личного ящика нет',
    mailSettings: 'Настройки почты',
    actions: 'Действия с сотрудником',
    deactivate: 'Отключить доступ',
    changeEmail: 'Сменить почту входа',
    changeEmailTitle: 'Почта входа — {name}',
    changeEmailLead:
      'На эту почту сотрудник входит в Штат и получает уведомления. Пароль и рабочий ящик не меняются; входить нужно будет с новой почтой',
    loginEmail: 'Почта входа',
    emailChanged: '{name}: почта входа — {email}',
    deactivateTitle: 'Отключить доступ: {name}?',
    deactivateLead:
      'Сотрудник не сможет войти, его ящик заблокируется — письма сохранятся. Профиль, ставки и история остаются. Вернуть доступ можно в любой момент',
    deactivated: 'Доступ отключён: {name}',
    reactivate: 'Вернуть доступ',
    reactivated: 'Доступ возвращён: {name}',
    ratesLead:
      'Себестоимость часа работы сотрудника: по ней считается цена задач, где он исполнитель. Действующую ставку не меняют — исправление идёт новой записью',
    ratesOwnLead: 'Ваша ставка — её видите вы и администратор',
    currentRate: 'Действует сейчас',
    noRate: 'Личной ставки нет',
    noRateHint: 'В расчёте цены — плановая ставка специализации',
    planRates: 'Плановые ставки специализаций',
    newRate: 'Новая ставка с даты',
    newRateTitle: 'Новая личная ставка',
    editRateTitle: 'Будущая ставка',
    rateLead: '{name}: до этой даты действует прежняя ставка',
    rate: 'Ставка в час',
    comment: 'Комментарий',
    commentPlaceholder: 'Например, пересмотр после испытательного срока',
    historyProfile: 'Профиль и ставки',
    historyAccount: 'Вход и роли',
    historyEmployment: 'Личные данные',
    employment: {
      form: 'Форма работы',
      formNone: 'Не выбрана',
      formHint: {
        title: 'Форма работы',
        text: 'От неё зависят договор, который сотрудник подпишет после приглашения, и личные данные, которые он заполнит. Договор подписывают кодом из письма: сначала сотрудник, потом подписант студии. Штатному договору нужен ещё скан бумажного оригинала',
        example:
          'Дизайнер на НПД — «Самозанятый»: договор оказания услуг, в данных — дата постановки на учёт',
      },
      forms: {
        npd: 'Самозанятый',
        ip: 'ИП',
        gph: 'Физлицо по договору ГПХ',
        staff: 'В штате',
      },
      formsShort: {
        npd: 'НПД',
        ip: 'ИП',
        gph: 'ГПХ',
        staff: 'Штат',
      },
      fields: {
        fullName: 'ФИО полностью',
        birthDate: 'Дата рождения',
        passportNumber: 'Серия и номер паспорта',
        passportIssuedBy: 'Кем выдан',
        passportIssuedOn: 'Дата выдачи',
        passportDivisionCode: 'Код подразделения',
        address: 'Адрес регистрации',
        inn: 'ИНН',
        snils: 'СНИЛС',
        ogrnip: 'ОГРНИП',
        bankBik: 'БИК банка',
        bankName: 'Банк',
        bankAccount: 'Счёт для выплат',
        npdConfirmedOn: 'На учёте как самозанятый с',
      },
      tab: 'Документы',
      dataTitle: 'Личные данные',
      dataLead: 'Для договора по форме «{form}». Видят только сотрудник и администратор',
      dataHint: {
        title: 'Личные данные',
        text: 'Паспорт, СНИЛС и счёт хранятся в зашифрованном виде. Видят их только сам сотрудник и администратор; в «Истории» — что изменилось, без значений. Сохранять можно по частям',
        example:
          'Заполнили паспорт сегодня, счёт — завтра: договор соберётся, когда заполнено всё отмеченное',
      },
      save: 'Сохранить данные',
      saved: 'Данные сохранены',
      missing: 'Для договора не хватает: {fields}',
      complete: 'Всё нужное для договора заполнено',
      noForm: 'Форма работы не выбрана — договор появится, когда администратор её укажет',
      formSaved: 'Форма работы: {form}',
      optional: 'если есть',
      placeholders: {
        passportNumber: '4510 123456',
        passportDivisionCode: '770-001',
        snils: '123-456-789 01',
        inn: '12 цифр',
        bankBik: '04…',
        bankAccount: '20 цифр',
      },
      issues: {
        required: 'Обязательное поле',
        too_long: 'Слишком длинно — до 500 символов',
        inn_format: 'ИНН физлица — 12 цифр',
        inn_checksum: 'Неверный ИНН: не сходится контрольное число',
        inn_not_person: 'ИНН из 10 цифр — это ИНН организации; у человека — 12 цифр',
        kpp_format: 'КПП — 9 символов',
        ogrn_format: 'ОГРНИП — 15 цифр',
        ogrn_checksum: 'Неверный ОГРНИП: не сходится контрольное число',
        ogrn_not_individual: 'ОГРН из 13 цифр — это ОГРН организации; у ИП — ОГРНИП из 15 цифр',
        snils_format: 'СНИЛС — 11 цифр',
        snils_checksum: 'Неверный СНИЛС: не сходится контрольное число',
        passport_format: 'Серия и номер — 10 цифр',
        division_code_format: 'Код подразделения — 6 цифр',
        bik_format: 'БИК — 9 цифр, начинается с 04',
        account_format: 'Счёт — 20 цифр',
        account_checksum: 'Счёт не сходится с БИК — проверьте цифры',
        date_invalid: 'Такой даты нет',
        date_future: 'Дата ещё не наступила',
      },
    },
  },
  studio: {
    title: 'Реквизиты студии',
    lead: 'Идут в договоры, акты, счета и подписи писем. ИНН или название — остальное подставится само',
    sectionCompany: 'Организация',
    sectionBank: 'Банк',
    sectionSigner: 'Подписант',
    signerLead: 'Кто подписывает документы от имени студии и на каком основании',
    sectionContacts: 'Контакты',
    sectionBrand: 'Фирменный стиль',
    brandLead:
      'Цвет, логотип и шрифт Inter идут в КП и на страницу клиента. Логотип — лучше PNG или SVG на прозрачном фоне',
    brandColorHint:
      'Цвет в формате #RRGGBB: шесть символов 0–9 и A–F. Им окрашены обложка, цены и кнопки в КП',
    brandColorExample: '#E30613 — красный студии по умолчанию',
    brandSampleTitle: 'Предложение для клиента',
    brandSampleText: 'Так цвет и шрифты выглядят в КП и на странице клиента',
    brandSampleButton: 'Выбрать пакет',
    mailDomain: 'Почтовый домен',
    mailDomainHint: 'Задаётся при установке платформы: смена домена — это перенос всех ящиков и DNS',
    mailDomainNone: 'Почта не подключена',
    save: 'Сохранить реквизиты',
    saved: 'Реквизиты сохранены',
    signerBasisPlaceholder: 'Устава',
    signerBasisIndividual: 'листа записи ЕГРИП',
    positionIndividual: 'Индивидуальный предприниматель',
    legalFormHint:
      'От формы зависят реквизиты: у ИП — ИНН из 12 цифр, ОГРНИП и нет КПП; у организации — ИНН из 10 цифр, ОГРН и КПП. Перешли из ИП в ООО — смените форму и реквизиты: прежние останутся в «Истории», а подписанные документы хранят реквизиты на дату подписания',
    legalFormExample: 'ИП Иванов → ООО «Глори»: форма «Организация», новый ИНН, КПП, ОГРН и директор',
    shortNameIndividual: 'ИП Иванов Иван Иванович',
    fullNameIndividual: 'Индивидуальный предприниматель Иванов Иван Иванович',
    legalForms: {
      individual: 'ИП',
      legal: 'Организация (ООО, АО)',
    },
    signerBasisHint: 'В родительном падеже: «действует на основании Устава»',
    signerUserHint:
      'Только этот сотрудник подтверждает пакеты документов кодом из письма — за студию. ФИО и должность в документах — из полей выше',
    signerUserPlaceholder: 'Выберите сотрудника',
    picked: 'Подставили из ЕГРЮЛ: {name}',
    fields: {
      brandColor: 'Фирменный цвет',
      legalForm: 'Форма',
      fullName: 'Полное наименование',
      shortName: 'Краткое наименование',
      inn: 'ИНН',
      kpp: 'КПП',
      ogrn: 'ОГРН',
      ogrnip: 'ОГРНИП',
      legalAddress: 'Юридический адрес',
      bankBik: 'Банк (БИК)',
      bankName: 'Название банка',
      bankCorrespondentAccount: 'Корреспондентский счёт',
      bankAccount: 'Расчётный счёт',
      signerName: 'ФИО подписанта',
      signerPosition: 'Должность',
      signerBasis: 'Основание',
      email: 'Email студии',
      phone: 'Телефон',
      website: 'Сайт',
      timezone: 'Часовой пояс',
      logoFileId: 'Логотип',
      signerUserId: 'Подписант в платформе',
    },
    timezones: {
      'Europe/Kaliningrad': 'Калининград (МСК−1)',
      'Europe/Moscow': 'Москва (МСК)',
      'Europe/Samara': 'Самара (МСК+1)',
      'Asia/Yekaterinburg': 'Екатеринбург (МСК+2)',
      'Asia/Omsk': 'Омск (МСК+3)',
      'Asia/Krasnoyarsk': 'Красноярск, Новосибирск (МСК+4)',
      'Asia/Irkutsk': 'Иркутск (МСК+5)',
      'Asia/Yakutsk': 'Якутск (МСК+6)',
      'Asia/Vladivostok': 'Владивосток (МСК+7)',
      'Asia/Magadan': 'Магадан (МСК+8)',
      'Asia/Kamchatka': 'Камчатка (МСК+9)',
    },
  },
  specializations: {
    title: 'Специализации',
    lead: 'Плановые ставки — себестоимость часа, пока исполнитель не назначен: по ним считаются шаблоны каталога и первые оценки',
    leadNames: 'Направления работы студии: по ним подбираются исполнители задач',
    hint: 'Ставка на дату — последняя с датой не позже неё. Ставка, которая уже действует, не меняется: исправление — новая ставка с сегодняшней или будущей даты. Будущую можно поменять или удалить',
    hintExample:
      'Дизайн: 700 ₽/ч с 1 января, 800 ₽/ч с 1 октября — сентябрьский шаблон считается по 700, октябрьский по 800',
    create: 'Специализация',
    createTitle: 'Новая специализация',
    createLead: 'Ставку можно задать сразу или позже',
    name: 'Название',
    namePlaceholder: 'Дизайн, фронтенд, PM',
    rate: 'Плановая ставка',
    rateHint: 'Себестоимость часа: сколько студия платит за час работы',
    from: 'С даты',
    fromDate: 'с {date}',
    fromHint: 'Сегодня или позже: действующую ставку не меняют задним числом',
    newRate: 'Ставка с даты',
    newRateTitle: 'Новая плановая ставка',
    editRateTitle: 'Будущая ставка',
    rateLead: '{name}: до этой даты действует прежняя ставка',
    rateRequired: 'Укажите ставку и дату, с которой она действует',
    saveRate: 'Сохранить ставку',
    removeRate: 'Удалить ставку',
    rateSaved: 'Ставка сохранена',
    rateRemoved: 'Будущая ставка удалена',
    noRate: 'нет ставки',
    next: 'с {date} — {rate}',
    teamAverage: {
      one: 'Средняя личная — {rate}, {count} сотрудник',
      few: 'Средняя личная — {rate}, {count} сотрудника',
      many: 'Средняя личная — {rate}, {count} сотрудников',
      other: 'Средняя личная — {rate}, {count} сотрудника',
    },
    teamAverageHint:
      'Средняя действующих личных ставок сотрудников с этой специализацией. Видна только администратору',
    inEffect: 'действует',
    scheduled: 'запланирована',
    edit: 'Изменить',
    showHistory: 'Показать историю ставок',
    hideHistory: 'Скрыть историю ставок',
    historyEmpty: 'Ставок пока нет',
    more: 'Ещё',
    rename: 'Переименовать',
    renameTitle: 'Переименовать специализацию',
    archive: 'В архив',
    archived: '«{name}» в архиве',
    restore: 'Вернуть',
    restored: '«{name}» снова в справочнике',
    created: 'Специализация «{name}» добавлена',
    showArchived: 'Показать архив',
    archiveEmpty: 'В архиве пусто',
    emptyTitle: 'Специализаций пока нет',
    emptyText: 'Добавьте направления работы студии — дизайн, фронтенд, бэкенд, PM — и плановые ставки к ним',
    clientRate: 'Клиенту — {rate}',
    clientRateHint:
      'Цена часа для клиента при почасовой оплате: (ставка + накладные) × (1 + наценка), плюс налог, до рубля. Коэффициенты не учитываются',
    clientRateExample: 'Дизайн 700 ₽/ч, накладные 150 ₽/ч, наценка 100%, УСН 6%: 1 809 ₽/ч',
    clientRateMissing: 'Цена часа для клиента появится, когда будут заданы политика цены и налог',
    clientRateSetPolicy: 'Политика цены',
    clientRateSetTax: 'Налог',
  },
  pricing: {
    title: 'Цена',
    lead: 'Из чего складывается цена услуг: себестоимость часа, накладные расходы студии, наценка и налог. Меняется новой версией политики с даты — уже посчитанные сметы и КП остаются как были',
    hint: 'Час работ стоит клиенту: (ставка исполнителя + накладные) × (1 + наценка) × коэффициенты, плюс налог сверху. Итог сметы округляется вверх до шага',
    hintExample:
      'Дизайн 700 ₽/ч, накладные 150 ₽/ч, наценка 100%, УСН 6%: (700 + 150) × 2 / 0,94 = 1 809 ₽ за час',
    noAccess: 'Политику цены видят администратор и менеджер',
    policyTitle: 'Политика цены',
    policySince: 'Действует с {date}',
    policyEmptyTitle: 'Политики цены пока нет',
    policyEmptyText:
      'Без неё платформа не посчитает цену ни шаблона, ни сметы. Задайте накладные, наценку, минимальную маржу и шаг округления',
    policyEmptyReadOnly: 'Политику задаёт администратор — до этого цены не считаются',
    policyCreate: 'Задать политику',
    newVersion: 'Новая версия',
    overhead: 'Накладные',
    overheadHint:
      'Постоянные расходы студии на один оплачиваемый час: добавляются к ставке исполнителя за каждый час работ',
    overheadExample: 'Расходы 72 400 ₽ в месяц, команда работает на клиентов 416 часов — 174,04 ₽ на час',
    markup: 'Наценка',
    markupHint: 'Прибыль студии сверх полной себестоимости — ставки исполнителя и накладных',
    markupExample: 'Себестоимость часа 850 ₽, наценка 100% — до налога час стоит 1 700 ₽',
    minMargin: 'Мин. маржа',
    minMarginHint:
      'Сколько процентов выручки должно оставаться студии после налога и себестоимости. Смету с маржой ниже подтверждает администратор',
    minMarginExample: 'Выручка 122 600 ₽, остаётся 57 644 ₽ — маржа 47%: выше 30%, подтверждение не нужно',
    rounding: 'Округление',
    roundingHint: 'Итог клиенту округляется вверх до шага; разница видна в разборе цены отдельной строкой',
    roundingExample: 'Смета 122 556 ₽ при шаге 100 ₽ — клиенту 122 600 ₽',
    roundingValue: 'до {step}',
    scheduledTitle: 'С {date} — новая версия',
    scheduledSame: 'Параметры те же, изменился комментарий',
    change: '{field}: {before} → {after}',
    editScheduled: 'Изменить',
    removeScheduled: 'Отменить',
    scheduledRemoved: 'Версия с {date} отменена',
    expensesTitle: 'Постоянные расходы',
    expensesLead:
      'Аренда, сервисы, бухгалтерия — всё, что студия платит независимо от проектов. Из них считается ставка накладных',
    expensesHint:
      'Годовые расходы делятся на 12. В расчёт идут расходы, действующие на дату. Цены от добавления расхода не меняются — ставка в политике обновляется, только когда вы нажмёте «Применить»',
    expensesEmptyTitle: 'Расходов пока нет',
    expensesEmptyText:
      'Добавьте аренду, подписки, бухгалтерию — и платформа посчитает, сколько накладных приходится на час работы',
    addExpense: 'Расход',
    perMonth: 'в месяц',
    perYear: 'в год',
    monthlyShare: '{amount} в месяц',
    upcoming: 'с {date}',
    until: 'по {date}',
    ended: 'закончился {date}',
    endedToggle: {
      one: 'Закончившиеся — {count}',
      few: 'Закончившиеся — {count}',
      many: 'Закончившиеся — {count}',
      other: 'Закончившиеся — {count}',
    },
    expenseMenu: 'Действия с расходом',
    editExpense: 'Изменить',
    endExpense: 'Закончить сегодня',
    deleteExpense: 'Удалить',
    expenseDeleted: 'Расход «{name}» удалён',
    expenseEnded: 'Расход «{name}» больше не считается с завтрашнего дня',
    calcTitle: 'Расчётная ставка накладных',
    calcExpenses: 'Расходы в месяц',
    calcExpensesCount: {
      one: '{count} расход на сегодня',
      few: '{count} расхода на сегодня',
      many: '{count} расходов на сегодня',
      other: '{count} расхода на сегодня',
    },
    calcHours: 'Оплачиваемые часы команды',
    calcHoursHint:
      'Сумма по активным сотрудникам: часы в неделю × доля оплачиваемого времени × 52 недели / 12. Ёмкость и долю задают в карточках сотрудников',
    calcHoursExample: '3 человека по 40 часов, оплачиваемо 80%: 96 часов в неделю — 416 в месяц',
    calcHoursValue: '{hours} в месяц',
    calcHoursLink: 'Ёмкость команды',
    calcRate: 'Ставка накладных',
    calcNoHours:
      'У команды нет оплачиваемых часов — ставку не на что делить. Укажите часы в неделю и долю оплачиваемого времени в карточках сотрудников',
    inPolicy: 'В политике — {rate}',
    matchesPolicy: 'Совпадает с политикой',
    noPolicyYet: 'Политики ещё нет — ставка войдёт в первую версию',
    apply: 'Применить',
    applyHint: 'Создаст новую версию политики с этой ставкой накладных — остальное останется как есть',
    versionsTitle: 'Версии политики',
    versionsLead:
      'Каждая версия действует со своей даты до следующей. По прежним версиям посчитаны прошлые сметы — они не меняются',
    fromDate: 'с {date}',
    statusCurrent: 'действует',
    statusScheduled: 'запланирована',
    historyTitle: 'История изменений',
    historyLead: 'Кто и когда менял политику и постоянные расходы',
    dialogNew: 'Новая версия политики',
    dialogFirst: 'Политика цены',
    dialogApply: 'Применить расчётную ставку',
    dialogScheduled: 'Запланированная версия',
    dialogLead: 'Уже посчитанные сметы и КП не изменятся: версия действует с выбранной даты',
    overheadField: 'Накладные в час',
    suggested: 'Расчётная — {rate}',
    useSuggested: 'Подставить',
    roundingField: 'Округление итога',
    effectiveFrom: 'С даты',
    effectiveToday:
      'Начнёт действовать сразу. Исправить её можно будет только новой версией с завтрашнего дня',
    effectiveLater: 'До этой даты действует прежняя версия',
    comment: 'Комментарий',
    commentPlaceholder: 'Например, «подорожала аренда»',
    commentHint: 'Виден в версиях политики и в истории',
    changesTitle: 'Что изменится',
    changesNone: 'Значения те же, что в версии до этой даты',
    replacesScheduled: 'Заменит версию, запланированную на эту дату',
    required: 'Заполните накладные, наценку, минимальную маржу и дату',
    publish: 'Опубликовать версию',
    published: 'Политика цены с {date} опубликована',
    expenseNew: 'Новый расход',
    expenseEdit: 'Расход',
    expenseName: 'Название',
    expenseNamePlaceholder: 'Аренда офиса',
    category: 'Статья',
    amount: 'Сумма',
    period: 'За',
    activeFrom: 'Действует с',
    activeTo: 'Последний день',
    activeToHint: 'Пусто — действует дальше',
    expenseRequired: 'Заполните название, сумму и дату начала',
    saveExpense: 'Сохранить',
    expenseSaved: 'Расход «{name}» сохранён',
    periods: { month: 'месяц', year: 'год' },
    categories: {
      rent: 'Аренда и офис',
      payroll: 'Зарплаты вне проектов',
      software: 'Сервисы и подписки',
      equipment: 'Техника и оборудование',
      marketing: 'Маркетинг',
      services: 'Бухгалтерия, банк, юристы',
      taxes: 'Взносы и фиксированные налоги',
      other: 'Прочее',
    },
    categoryHints: {
      rent: 'Аренда, коммунальные, уборка',
      payroll: 'Бухгалтер, офис-менеджер — кто не работает на проекты',
      software: 'Figma, хостинг, облака, CRM',
      equipment: 'Ноутбуки, мониторы — годовой суммой или помесячно',
      marketing: 'Реклама, сайт студии, конференции',
      services: 'Обслуживание счёта, аутсорс бухгалтерии, юристы',
      taxes: 'Фиксированные взносы ИП и подобное — не налог с дохода',
      other: 'Всё, что не подошло к другим статьям',
    },
  },
  tax: {
    title: 'Налог',
    lead: 'Режим налогообложения студии: налог закладывается в цену, чтобы его не приходилось платить из маржи. Меняется новым профилем с даты — уже посчитанные сметы и КП остаются как были',
    hint: 'Налог с дохода платит студия, поэтому он добавляется к цене сверху: клиенту — нужная сумма / (1 − ставка). НДС, если он есть, добавляется к цене клиента отдельно',
    hintExample: 'До налога час стоит 1 700 ₽, УСН «Доходы» 6%: клиенту 1 700 / 0,94 = 1 809 ₽',
    noAccess: 'Налоговый профиль видят администратор и менеджер',
    profileTitle: 'Налоговый профиль',
    since: 'Действует с {date}',
    emptyTitle: 'Налоговый профиль не задан',
    emptyText:
      'Без него платформа не посчитает цену: налог закладывается в каждую строку сметы. Студии на УСН «Доходы» — 6%, без НДС',
    emptyReadOnly: 'Налоговый профиль задаёт администратор — до этого цены не считаются',
    create: 'Указать налог',
    newProfile: 'Новый профиль',
    kind: 'Режим',
    rate: 'Ставка налога',
    rateHint: 'Процент, который студия платит с дохода. Регионы могут снижать ставку',
    minRate: 'Мин. налог',
    minRateField: 'Минимальный налог',
    minRateHint:
      'При УСН «Доходы минус расходы» налог не меньше этой доли доходов, даже если прибыли нет. По закону — 1%',
    vat: 'НДС',
    vatHint:
      'На УСН НДС платят, если доходы за год больше порога: по ставке 5% или 7% без вычетов или 22% с вычетами. НДС добавляется к цене клиента',
    vatNone: 'Без НДС',
    vatWith: 'С НДС',
    vatRate: 'Ставка НДС',
    vatRateHint: 'На УСН — 5% или 7%, общая ставка — 22%',
    approximation:
      'При «доходы минус расходы» налог по строке сметы — приближение: настоящая база считается за год',
    example: 'Со 100 000 ₽ выручки налог — {amount}',
    kinds: {
      usn_income: 'УСН «Доходы»',
      usn_income_minus_expenses: 'УСН «Доходы минус расходы»',
    },
    kindHints: {
      usn_income: 'Налог с выручки, обычно 6%',
      usn_income_minus_expenses: 'Налог с разницы доходов и расходов, обычно 15%, но не меньше 1% выручки',
    },
    vatKinds: { none: 'без НДС', vat: 'с НДС' },
    scheduledTitle: 'С {date} — новый профиль',
    statusScheduled: 'запланирован',
    scheduledSame: 'Параметры те же, изменился комментарий',
    scheduledRemoved: 'Профиль с {date} отменён',
    versionsTitle: 'Профили',
    versionsLead: 'Каждый профиль действует со своей даты до следующего',
    historyTitle: 'История изменений',
    historyLead: 'Кто и когда менял налоговый профиль',
    dialogNew: 'Новый налоговый профиль',
    dialogFirst: 'Налоговый профиль',
    dialogScheduled: 'Запланированный профиль',
    dialogLead: 'Уже посчитанные сметы и КП не изменятся: профиль действует с выбранной даты',
    effectiveToday:
      'Начнёт действовать сразу. Исправить его можно будет только новым профилем с завтрашнего дня',
    effectiveLater: 'До этой даты действует прежний профиль',
    changesNone: 'Значения те же, что в профиле до этой даты',
    replacesScheduled: 'Заменит профиль, запланированный на эту дату',
    required: 'Заполните ставку налога и дату',
    publish: 'Сохранить профиль',
    published: 'Налоговый профиль с {date} сохранён',
  },
  coefficients: {
    title: 'Коэффициенты',
    lead: 'Надбавки и скидки на смету целиком: срочность, сложность, постоянный клиент. В каталоге и сметах они включаются переключателями',
    hint: 'Коэффициент умножает цену после наценки: (себестоимость + накладные) × (1 + наценка) × коэффициенты, затем налог. Несколько коэффициентов перемножаются',
    hintExample: 'Срочность ×1,3 и постоянный клиент ×0,9 вместе — цена × 1,17',
    noAccess: 'Коэффициенты видят администратор и менеджер',
    create: 'Коэффициент',
    createTitle: 'Новый коэффициент',
    editTitle: 'Коэффициент',
    name: 'Название',
    namePlaceholder: 'Срочный запуск',
    multiplier: 'Множитель',
    multiplierHint: 'Больше 1 — надбавка, меньше 1 — скидка: ×1,3 — дороже на 30%, ×0,9 — дешевле на 10%',
    description: 'Когда применять',
    descriptionPlaceholder: 'Например, «запуск меньше чем через две недели»',
    example: 'Смета 100 000 ₽ → {amount}',
    emptyTitle: 'Коэффициентов пока нет',
    emptyText:
      'Добавьте надбавки и скидки, которые студия применяет к сметам: срочность ×1,3, сложный клиент ×1,2, постоянный клиент ×0,9',
    edit: 'Изменить',
    archive: 'В архив',
    archived: '«{name}» в архиве',
    restore: 'Вернуть',
    restored: '«{name}» снова в справочнике',
    saved: 'Коэффициент «{name}» сохранён',
    more: 'Действия с коэффициентом',
    showArchived: 'Показать архив',
    archiveEmpty: 'В архиве пусто',
    required: 'Укажите название и множитель',
    save: 'Сохранить',
    raise: 'надбавка {percent}',
    discount: 'скидка {percent}',
  },
  catalog: {
    inCabinet: 'В кабинете',
    inCabinetCategoryHidden: 'В кабинете, но категория скрыта',
    cabinetShow: 'Показывать в кабинете клиента',
    cabinetHide: 'Скрыть из кабинета клиента',
    cabinetShown: 'Теперь видно в кабинете клиента',
    cabinetHidden: 'Скрыто из кабинета клиента',
    cases: {
      tab: 'Кейсы',
      title: 'Кейсы',
      back: 'Каталог',
      hint: 'Кейсы — выполненные проекты студии. Опубликованные попадают в КП: по услугам сметы КП предлагает подходящие',
      hintExample: 'В смете есть «Интернет-магазин» — в КП предложим кейс магазина для «Севера»',
      lead: 'Покажите клиенту, что студия уже делала. Пока опубликованных кейсов нет, блок «Кейсы» в КП скрыт',
      leadMember: 'Выполненные проекты студии. Опубликованные кейсы попадают в КП',
      new: 'Новый кейс',
      newTitle: 'Новый кейс',
      newLead: 'Сначала название — остальное заполните в карточке. В КП кейс попадёт после «Опубликовать»',
      titlePlaceholder: 'Интернет-магазин для «Севера»',
      create: 'Создать',
      columnCase: 'Кейс',
      columnClient: 'Клиент',
      columnYear: 'Год',
      columnStatus: 'Статус',
      statusPublished: 'Опубликован',
      statusDraft: 'Черновик',
      statusArchived: 'В архиве',
      demo: 'демо',
      demoNote: 'Демо-кейс из тестовых данных — перед настоящей отправкой КП снимите его с публикации',
      emptyTitle: 'Кейсов пока нет',
      emptyText: 'Добавьте первый кейс — после публикации он появится в КП у подходящих смет',
      emptyMember: 'Кейсов пока нет — их добавляют менеджеры и админы',
      fieldTitle: 'Название',
      fieldClient: 'Клиент',
      fieldYear: 'Год',
      hideClient: 'Скрыть название клиента в КП',
      hideClientHintTitle: 'Скрыть клиента',
      hideClientHintText: 'Клиент не разрешил называть себя — в КП кейс подписан без его названия',
      fieldSummary: 'Кратко',
      summaryHint: 'Две–три фразы: что сделали и какой результат. Это текст в КП',
      summaryExample: 'Запустили магазин за 6 недель: заказы с сайта выросли в полтора раза',
      fieldBody: 'Рассказ о проекте',
      bodyPlaceholder: 'Задача, что сделали, результат',
      fieldUrl: 'Ссылка на проект',
      urlPlaceholder: 'example.ru',
      fieldItems: 'Услуги каталога',
      itemsHintTitle: 'Услуги кейса',
      itemsHintText:
        'По ним КП подбирает кейсы: в смете взяли услугу — предложим кейсы, где она есть. Без услуг кейс в КП автоматически не предлагается',
      itemsPlaceholder: 'К каким услугам относится кейс',
      fieldCover: 'Обложка',
      coverHint: 'Одна картинка: PNG, JPEG или WebP',
      fieldGallery: 'Галерея',
      galleryHint: 'До 12 картинок',
      publish: 'Опубликовать',
      unpublish: 'Снять с публикации',
      archive: 'В архив',
      restore: 'Вернуть из архива',
      saved: 'Кейс «{name}» сохранён',
      autosaving: 'Сохраняем…',
      autosaved: 'Изменения сохраняются сами',
      autosaveTitleRequired: 'Без названия кейс не сохранится — напишите его',
      published: 'Кейс «{name}» опубликован — он может попасть в КП',
      unpublished: 'Кейс «{name}» снят с публикации',
      archived: 'Кейс «{name}» в архиве',
      restored: 'Кейс «{name}» возвращён из архива',
    },
    title: 'Каталог услуг',
    lead: 'Шаблоны услуг с нормой часов по задачам. Цена считается сама — по действующим ставкам, политике и налогу — и переходит в сметы и КП',
    leadMember: 'Услуги студии с составом работ и ценой для клиента',
    hint: 'Цена шаблона — движок по задачам: часы × плановая ставка специализации + накладные, наценка, налог, округление до шага. Меняются ставки или политика — меняется и цена шаблона. Уже отправленные сметы не меняются',
    hintExample: '«Лендинг»: 64 часа, себестоимость 57 600 ₽ — клиенту 122 600 ₽',
    searchSubtitle: 'Шаблон услуги · {category}',
    copyName: '{name} (копия)',
    newItem: 'Новая услуга',
    aiDraft: {
      open: 'Быстрый расчёт',
      title: 'Быстрый расчёт услуги',
      lead: 'Опишите услугу своими словами — ИИ составит название, описание и задачи с часами. Цена посчитается по ставкам студии',
      hint: 'ИИ опирается на специализации и похожие услуги каталога. Это черновик: перед созданием его можно поправить, после — дописать в карточке',
      description: 'Что за услуга',
      descriptionPlaceholder:
        'Например: лендинг для стоматологии — первый экран с акцией, услуги и цены, врачи, отзывы, форма записи с уведомлением в Telegram',
      category: 'Категория',
      categoryAuto: 'ИИ подберёт сам или предложит новую',
      start: 'Составить услугу',
      phases: {
        queued: 'В очереди',
        collecting: 'Смотрю каталог и специализации',
        thinking: 'ИИ составляет услугу — это до минуты',
        checking: 'Проверяю ответ',
        saving: 'Почти готово',
      },
      cancel: 'Остановить',
      failed: 'ИИ не составил услугу',
      retry: 'Попробовать ещё раз',
      name: 'Название',
      summary: 'Кратко',
      descriptionResult: 'Описание для карточки',
      tasks: 'Задачи',
      total: 'Всего {hours}',
      categoryRequired: 'Выберите категорию',
      newCategory: 'Подходящей нет — ИИ предлагает новую: «{name}». Создастся вместе с услугой.',
      newCategoryDrop: 'Не создавать',
      again: 'Составить заново',
      create: 'Создать услугу',
      created: 'Услуга «{name}» в каталоге — проверьте цену и задачи',
    },
    newItemTitle: 'Новая услуга',
    newItemLead: 'Задачи, цену и описание заполните в карточке',
    name: 'Название',
    namePlaceholder: 'Лендинг, логотип, интернет-магазин',
    category: 'Категория',
    categoryPlaceholder: 'Выберите или создайте',
    create: 'Создать',
    created: 'Услуга «{name}» создана',
    columnItem: 'Услуга',
    columnCategory: 'Категория',
    columnHours: 'Часы',
    columnPrice: 'Цена',
    columnMargin: 'Маржа',
    noPrice: 'нет цены',
    emptyTitle: 'Каталог пуст',
    emptyText:
      'Соберите шаблоны услуг студии — «Лендинг», «Логотип», «Интернет-магазин»: задачи с нормой часов, и цена посчитается сама',
    emptyMember: 'Администратор ещё не добавил услуги',
    categoriesTitle: 'Категории',
    categoriesLead: 'Группы услуг в каталоге и порядок, в котором они показываются',
    categoriesButton: 'Категории',
    categoryNew: 'Новая категория',
    categoryNamePlaceholder: 'Сайты, брендинг, поддержка',
    categoryAdd: 'Добавить',
    categoryItems: {
      one: '{count} услуга',
      few: '{count} услуги',
      many: '{count} услуг',
      other: '{count} услуги',
    },
    categoryUp: 'Выше',
    categoryDown: 'Ниже',
    categoryRename: 'Переименовать',
    categoryRemove: 'Удалить',
    categoryRemoveHint: 'Удалить можно только пустую категорию',
    categoriesEmpty: 'Категорий пока нет — добавьте первую',
    showArchived: 'Показать архив',
    archivedBadge: 'в архиве',
    tabPrice: 'Цена',
    tabTasks: 'Задачи',
    tabDescription: 'Описание',
    tabHistory: 'История',
    client: 'Клиенту',
    hours: 'Часы',
    studioKeeps: 'Студии остаётся',
    marginValue: '{amount} · {rate}',
    breakdown: 'Разбор цены',
    breakdownHint:
      'Каждая статья посчитана движком цены. «Округление» — разница до шага округления итога: она добавляется к самой дорогой строке',
    rowCost: 'Ставки исполнителей',
    rowOverhead: 'Накладные',
    rowMarkup: 'Наценка',
    rowCoefficients: 'Коэффициенты',
    rowTax: 'Налог',
    rowRounding: 'Округление',
    rowTotal: 'Итог клиенту',
    rowVat: 'в т. ч. НДС',
    coefficients: 'Коэффициенты',
    coefficientsHint:
      'Переключатели показывают, как изменится цена. В шаблоне они не сохраняются: коэффициенты выбирают в смете под конкретного клиента',
    coefficientsEmpty: 'Коэффициентов нет — их задают в настройках',
    belowMin: 'Маржа {rate} ниже минимальной {min} — в смете понадобится подтверждение администратора',
    fixedBelowCost: 'Фиксированная цена ниже себестоимости работ',
    problemsTitle: 'Цену пока не посчитать',
    problems: {
      no_policy: 'Не задана политика цены — накладные, наценка, округление',
      no_tax: 'Не задан налоговый профиль',
      no_rate: 'Нет плановой ставки у специализаций: {names}',
      no_tasks: 'Добавьте задачи — цена считается по ним',
      no_fixed_price: 'Укажите фиксированную цену',
    },
    fixProblem: 'Исправить',
    kind: 'Цена',
    kinds: { tasks: 'По задачам', fixed: 'Фиксированная' },
    kindHints: {
      tasks: 'Часы задач × ставки специализаций, накладные, наценка, налог',
      fixed: 'Цена задана заранее; задачи — только для оценки себестоимости и маржи',
    },
    fixedPrice: 'Фиксированная цена',
    fixedPriceHint: 'Цена для клиента без коэффициентов, до налога сверху не пересчитывается',
    taskTitle: 'Задача',
    taskTitlePlaceholder: 'Название задачи',
    taskSpecialization: 'Специализация',
    taskHours: 'Часы',
    taskPrice: 'Цена',
    addTask: 'Задача',
    removeTask: 'Убрать задачу',
    moveUp: 'Выше',
    moveDown: 'Ниже',
    tasksEmpty: 'Задач пока нет — добавьте первую: название, специализация, часы',
    tasksEmptyFixed: 'Задачи необязательны: по ним считается себестоимость и маржа фиксированной цены',
    tasksTotal: 'Итого',
    specializationArchived: 'в архиве',
    noSpecializations: 'Сначала добавьте специализации — по их ставкам считаются задачи',
    summary: 'Кратко',
    summaryPlaceholder: 'Одной строкой — видно в каталоге и КП',
    description: 'Описание для клиента',
    descriptionHint: 'Попадёт в КП и карточку услуги: что входит, результат, сроки',
    unsaved: 'Есть несохранённые изменения',
    save: 'Сохранить',
    discard: 'Отменить',
    saved: 'Услуга «{name}» сохранена',
    more: 'Действия с услугой',
    duplicate: 'Дублировать',
    duplicated: 'Создана копия «{name}»',
    archive: 'В архив',
    archived: 'Услуга «{name}» в архиве',
    restore: 'Вернуть из архива',
    restored: 'Услуга «{name}» снова в каталоге',
    notFound: 'Услуга не найдена',
    notFoundText: 'Возможно, её удалили или перенесли в архив',
    readOnly: 'Менять каталог могут администратор и менеджер',
    tabPdf: 'PDF',
    cardVatNone: 'НДС не облагается',
    cardVatIncluded: 'В том числе НДС {rate}',
    cardStudioFallback: 'Студия',
    pdfLead: 'Так услуга будет выглядеть в КП: описание, состав работ и цена — без внутренних ставок',
    pdfDraftNote: 'PDF собран по сохранённой версии — сохраните изменения, чтобы увидеть их здесь',
    pdfCoefficientsNote: 'С коэффициентами: {names}',
    pdfDownload: 'Скачать PDF',
    pdfRetry: 'Повторить',
    pdfPage: 'Страница {page} из {total}',
    tabChat: 'Чат',
    chatEmptyTitle: 'Обсуждение услуги',
    chatEmptyText: 'Вопросы по составу, цене и описанию — здесь. Увидят все, у кого есть каталог',
  },
  clients: {
    cabinetSource: 'Заявка из кабинета клиента',
    title: 'Клиенты',
    kinds: { legal: 'Организация', entrepreneur: 'ИП', person: 'Физлицо' },
    statuses: { prospect: 'Потенциальный', active: 'Клиент', archived: 'В архиве' },
    // Канал документов клиента (подпроект 9) — в «Истории» клиента.
    docflows: { link: 'Ссылкой на подписание', edo: 'Через ЭДО' },
    // Вид чата клиента в списке чатов.
    chatLook: { client: 'Клиент' },
    // Объединение клиентов: что переехало (для «Истории» и сообщения) и тексты окна.
    merge: {
      contacts: {
        one: '{count} контакт',
        few: '{count} контакта',
        many: '{count} контактов',
        other: '{count} контакта',
      },
      deals: {
        one: '{count} сделка',
        few: '{count} сделки',
        many: '{count} сделок',
        other: '{count} сделки',
      },
      touches: {
        one: '{count} касание',
        few: '{count} касания',
        many: '{count} касаний',
        other: '{count} касания',
      },
    },
    sources: {
      site: 'С сайта',
      email: 'Из почты',
      referral: 'По рекомендации',
      outbound: 'Наш выход',
      other: 'Другое',
    },
    channelKinds: {
      phone: 'Телефон',
      email: 'Почта',
      whatsapp: 'WhatsApp',
      max: 'MAX',
      vk: 'ВКонтакте',
      telegram: 'Telegram',
      other: 'Другое',
    },
    contactRoles: {
      primary: 'Основной',
      decisionMaker: 'Принимает решения',
      signer: 'Подписывает',
    },
    fields: {
      name: 'Название',
      inn: 'ИНН',
      kpp: 'КПП',
      ogrn: 'ОГРН',
      legalName: 'Юридическое название',
      address: 'Адрес',
      directorName: 'Руководитель',
      directorPost: 'Должность руководителя',
      directorBasis: 'Основание полномочий',
      bankBik: 'БИК банка',
      bankName: 'Банк',
      bankCorrespondentAccount: 'Корр. счёт',
      bankAccount: 'Расчётный счёт',
      source: 'Откуда пришёл',
      sourceNote: 'Уточнение',
      website: 'Сайт',
      about: 'О клиенте',
      contact: 'Контакт',
      fullName: 'ФИО',
      position: 'Должность',
      referredBy: 'Кто привёл',
    },
    emailHolder: 'контакта {name} ({client})',
    emailHolderHidden: 'клиента «{client}»',
    contactsGroup: 'Контакты',
    hint: 'Организации, ИП и физлица, с которыми студия работает или собирается работать: реквизиты, контакты, переписка и история изменений в одной карточке. Позже к клиенту привяжутся его сделки и договоры',
    hintExample:
      'ООО «Ромашка»: директор Анна, бухгалтер Пётр, чат с командой и всё, что менялось в карточке',
    lead: 'Кому мы делаем сайты, кто из команды отвечает за клиента и как с ним связаться',
    scopeAll: 'Все',
    scopeMine: 'Мои',
    statusOpen: 'В работе',
    searchPlaceholder: 'Клиент, ИНН, контакт, телефон…',
    columnClient: 'Клиент',
    columnStatus: 'Статус',
    columnResponsible: 'Ответственный',
    columnContact: 'Контакт',
    noResponsible: 'Не назначен',
    emptyTitle: 'Клиентов пока нет',
    emptyText: 'Заведите первого: организацию, ИП или физлицо. Реквизиты подтянутся по ИНН',
    emptyFilteredTitle: 'Под фильтры ничего не подходит',
    emptyFilteredText: 'Сбросьте фильтры или поищите по-другому',
    resetFilters: 'Сбросить фильтры',
    moreHint: 'Показаны первые {count} из {total} — уточните поиск, чтобы найти нужного',
    notFound: 'Такого клиента нет',
    notFoundText: 'Возможно, его удалили или он у другого сотрудника',
    open: 'Открыть',
    more: 'Ещё',
    saveFailed: 'Не удалось сохранить — проверьте связь и попробуйте ещё раз',
    tabOverview: 'Обзор',
    tabDeals: 'Сделки',
    tabChat: 'Чат',
    tabDocuments: 'Документы',
    tabHistory: 'История',
    chatEmptyTitle: 'Обсуждение клиента',
    chatEmptyText: 'Договорённости, вопросы и заметки по клиенту — здесь. Читают ответственный и менеджеры',
    makeClient: 'Сделать клиентом',
    makeProspect: 'Вернуть в потенциальные',
    archive: 'В архив',
    restore: 'Вернуть из архива',
    delete: 'Удалить',
    archivedToast: 'Клиент «{name}» в архиве',
    restoredToast: 'Клиент «{name}» возвращён из архива',
    deletedToast: 'Клиент «{name}» удалён',
    archivedBanner: 'Клиент в архиве: новых лидов и сделок у него не будет, пока его не вернут',
    // Клиент, объединённый с другим: вся работа теперь у основного.
    mergedNotice: {
      title: 'Клиент объединён с другим.',
      text: 'Контакты, сделки и касания теперь у основного клиента — работайте там.',
      withName: 'Контакты, сделки и касания теперь у «{name}» — работайте там.',
      open: 'Открыть основного',
    },
    // «Объединить клиентов»: основной + дубль.
    mergeDialog: {
      menu: 'Объединить с другим клиентом…',
      command: 'Объединить клиентов',
      title: 'Объединить клиентов',
      lead: 'Контакты, сделки и касания дубля переедут к основному клиенту. Дубль уйдёт в архив, его чат останется со ссылкой на основного',
      hint: {
        text: 'Нужно, когда один и тот же клиент завёлся дважды: например, физлицо из лида и та же организация, заведённая позже. Откатить объединение нельзя — поэтому окно сначала показывает, что переедет. Если у клиентов разные ИНН, объединить их нельзя',
        example:
          'Основной — ООО «Пекарня» с ИНН, дубль — «Игнат» без ИНН: его 2 контакта и 1 сделка перейдут к «Пекарне»',
      },
      primary: 'Основной клиент',
      primaryHint: 'Остаётся: к нему переезжают контакты, сделки и касания дубля. Его данные не меняются',
      duplicate: 'Дубль',
      duplicateHint:
        'Уходит в архив со ссылкой на основного; его карточка и чат остаются, но работа идёт у основного',
      pick: 'Найдите клиента: название, ИНН, телефон',
      change: 'Выбрать другого',
      swap: 'Поменять местами основного и дубль',
      noInn: 'ИНН не указан',
      choose: 'Выберите двух клиентов — покажем, что переедет',
      moves: 'Переедет к основному:',
      archiveNote: 'дубль уйдёт в архив',
      movesNothing:
        'У дубля нет контактов, сделок и касаний — он просто уйдёт в архив со ссылкой на основного',
      innOnlyDuplicate:
        'ИНН есть только у дубля и останется в его карточке. Если основным должен быть клиент с реквизитами, поменяйте их местами',
      innConflict:
        'У клиентов разные ИНН — объединить нельзя. Это разные организации, либо в одном из ИНН опечатка: поправьте её в карточке',
      submit: 'Объединить',
      matchAction: 'Объединить',
      done: 'Клиенты объединены: к «{name}» перенесено {what}',
      doneNothing: 'Клиенты объединены: дубль в архиве, основной — «{name}»',
      failed: 'Не удалось объединить клиентов — проверьте связь и попробуйте ещё раз',
    },
    // Вкладка «Письма» в карточке клиента.
    letters: {
      tab: 'Письма',
      title: 'Переписка',
      hint: {
        text: 'Письма с почтами контактов этого клиента — из тех ящиков, к которым есть доступ у вас. Чужие ящики вы не увидите, поэтому у коллеги список может быть другим. Цепочка открывается в разделе «Почта»',
        example: 'У контакта «Анна» указана почта anna@pekarnya.ru — здесь все письма от неё и ей',
      },
      write: 'Написать',
      openInMail: 'Открыть в «Почте»',
      to: 'Кому',
      attachment: 'Есть вложение',
      noAccessTitle: 'У вас нет доступа к почте',
      noAccessText: 'Письма клиента лежат в почте студии. Доступ к ней открывает админ',
      noEmailTitle: 'У контактов нет почты',
      noEmailText:
        'Добавьте контакту адрес — и переписка с ним появится здесь, а рядом с адресом — «Написать»',
      noEmailAction: 'Добавить почту',
      noMailboxTitle: 'Вам не открыт ни один ящик',
      noMailboxText:
        'Письма клиента лежат в ящиках студии. Попросите админа открыть вам доступ к нужному ящику',
      emptyTitle: 'Писем пока нет',
      emptyText: 'Переписки с {addresses} в ваших ящиках не нашлось. Напишите первым — письмо появится здесь',
      more: 'Показаны первые {count} из {total} цепочек — вся переписка в «Почте»',
      failed: 'Не удалось загрузить письма — проверьте связь и попробуйте ещё раз',
    },
    personToOrg: 'Это организация или ИП?',
    personToOrgText:
      'Выберите вид и введите ИНН, если он есть — название и реквизиты подтянутся, а контакт останется контактом',
    enterInn: 'Указать вид',
    changeKindMenu: {
      person: 'Сделать организацией или ИП',
      legal: 'Сделать ИП',
      entrepreneur: 'Сделать организацией',
    },
    innPrompt: {
      lead: 'Добавьте ИНН — подтянем реквизиты и защитим от дублей',
      add: 'Добавить',
    },
    innMismatch: {
      legal: 'Это ИНН ИП — 12 цифр, а клиент — организация. Поправьте ИНН или смените вид клиента',
      entrepreneur: 'Это ИНН организации — 10 цифр, а клиент — ИП. Поправьте ИНН или смените вид клиента',
    },
    sectionWork: 'Работа',
    activity: 'Лента клиента',
    sectionMain: 'Основное',
    sectionRequisites: 'Реквизиты',
    sectionAbout: 'О клиенте',
    sectionContacts: 'Контакты',
    responsible: 'Ответственный',
    responsiblePlaceholder: 'Выберите сотрудника',
    add: 'Добавить: {field}',
    addAbout: 'Добавить заметку о клиенте',
    specify: 'Указать',
    newClient: {
      title: 'Новый клиент',
      lead: 'Организация или ИП — по ИНН (можно и без него), физлицо — по телефону или почте. Остальное дозаполнится в карточке',
      kind: 'Кто это',
      personName: 'ФИО',
      personNamePlaceholder: 'Анна Смирнова',
      namePlaceholder: 'ООО «Ромашка»',
      contactPerson: 'Контактное лицо (необязательно)',
      contactName: 'ФИО контакта',
      contactNamePlaceholder: 'Анна Смирнова',
      howToReach: 'Как связаться',
      needPhoneOrEmail: 'Нужен телефон или почта — иначе с клиентом не связаться',
      requisitesLater: 'Остальные реквизиты (адрес, КПП, руководитель) — в карточке клиента',
      innLater: 'ИНН можно добавить позже, в карточке клиента: подтянутся реквизиты, а дубли отсеются',
      fieldInvalid: 'Проверьте значение поля',
      phoneInvalid: 'Не разобрать номер — проверьте цифры',
      create: 'Создать клиента',
      created: 'Клиент «{name}» создан',
    },
    kindDialog: {
      title: 'Организация или ИП',
      lead: 'Выберите вид и введите ИНН, если он есть — название и реквизиты подтянутся; контакт останется контактом',
      titleSwap: 'Сменить вид клиента',
      leadSwap: 'Ошиблись видом — поправьте. Контакты и история остаются',
      newKind: 'Новый вид',
      willClear: 'Будут очищены: {fields}',
      keepAll: 'Все реквизиты сохранятся',
      innFix: {
        legal:
          'У организации ИНН из 10 цифр, а этот — из 12. Введите ИНН организации или очистите поле: добавите его позже',
        entrepreneur:
          'У ИП ИНН из 12 цифр, а этот — из 10. Введите ИНН ИП или очистите поле: добавите его позже',
      },
      ogrnAsk: 'ОГРН не подходит новому виду — поправьте или очистите поле, добавите его позже',
      apply: 'Сохранить',
      applySwap: 'Сменить вид',
    },
    match: {
      inn: 'Такой клиент уже есть: {name} — тот же ИНН',
      email: 'Такой клиент уже есть: {name} — та же почта',
      emailContact: 'Такой клиент уже есть: {name} — эта почта у контакта {contact}',
      phone: 'Возможно, такой клиент уже есть: {name} — тот же телефон',
      phoneContact: 'Возможно, такой клиент уже есть: {name} — этот телефон у контакта {contact}',
      noAccess: 'Клиент у другого сотрудника — открыть нельзя',
    },
    addContact: 'Добавить контакт',
    addFullName: 'Указать ФИО',
    addPosition: 'Должность',
    contactsEmpty: 'Контактов пока нет — добавьте того, с кем говорите',
    contactMore: 'Действия с контактом',
    contactRolesLabel: 'Роли контакта',
    archiveContact: 'В архив',
    restoreContact: 'Вернуть',
    archivedContacts: 'Архивные контакты ({count})',
    contactArchivedToast: 'Контакт «{name}» в архиве',
    addChannel: 'Способ связи',
    removeChannel: 'Убрать',
    channelInvalid: 'Не разобрать: {kind} — проверьте значение',
    noChannels: 'Нет телефона и почты — добавьте, чтобы связаться',
    call: 'Позвонить',
    hints: {
      kind: {
        text: 'Организация — юрлицо (ООО, АО), ИП — индивидуальный предприниматель, физлицо — человек без компании. От вида зависят реквизиты. Физлицо можно потом сделать организацией или ИП, а организацию и ИП — поменять местами, если ошиблись; ИНН можно добавить позже',
        example: 'ООО «Ромашка» — организация; Иван Петров, ИП — ИП; Анна Смирнова — физлицо',
      },
      kindChange: {
        title: 'Что будет при смене вида',
        text: 'КПП и руководитель бывают только у организации: при смене на ИП они очищаются, а при смене на организацию их можно добавить потом. ИНН и ОГРН должны подходить новому виду (ИНН — 10 цифр у организации и 12 у ИП): не подходят — поправьте или очистите, добавите позже. Контакты и история остаются. Обратно в физлицо вид не меняется',
        example:
          'ООО «Ромашка» → ИП: КПП и руководитель очистятся, а ИНН из 10 цифр заменится на ИНН ИП из 12',
      },
      status: {
        title: 'Что значит статус',
        text: 'Потенциальный — ещё не работали; «Клиент» — работаем или уже работали; «В архиве» — не получает новых лидов, пока его не вернут. Сейчас статус переключается вручную, позже «Клиентом» его будет делать выигранная сделка',
      },
      source: {
        text: 'Откуда узнали о клиенте: сайт, рекомендация, наш выход. По источникам потом считается сводка продаж',
        example: 'Порекомендовал Пётр из «Ромашки» — источник «По рекомендации»',
      },
      responsible: {
        text: 'Ответственный — сотрудник, который ведёт клиента. Он видит карточку и состоит в её чате; менеджеры и админ видят всех клиентов',
        example: 'Анна ведёт «Ромашку»: карточка и чат — у неё, менеджер видит всё',
      },
      email: {
        title: 'Почта клиента уникальна',
        text: 'Один адрес — один контакт во всей базе: по нему клиент позже войдёт в свой кабинет и увидит, как идёт работа. Если адрес уже занят, платформа предложит открыть того клиента',
      },
    },
  },
  sales: {
    cabinetAuthor: 'Клиент из кабинета',
    title: 'Продажи',
    callTo: 'Позвонить: {name}, {phone}',
    phases: { lead: 'Лид', deal: 'Сделка' },
    leadStates: { queued: 'В очереди', taken: 'Взят' },
    stages: {
      new: 'Новая',
      discovery: 'Выясняем задачу',
      proposal: 'Оценка и КП',
      negotiation: 'Переговоры',
      contract: 'Договор',
    },
    outcomes: { won: 'Выиграна', lost: 'Проиграна', rejected: 'Отклонён' },
    // Вид записи в списке чатов и шапке чата: «Лид», «Сделка · Оценка и КП»; пустое название сделки — «Обращение · <клиент>».
    chatLook: { inquiry: 'Обращение', withState: '{phase} · {state}' },
    // Сводка за месяц: вкладка «Сводка» в «Продажах».
    summary: {
      noReason: 'Без причины',
      pageTitle: 'Сводка продаж',
      title: 'Сводка за месяц',
      lead: 'Сколько пришло лидов, сколько сделок выиграно и проиграно и почему — по календарным месяцам',
      hint: {
        text: 'Лиды считаются по месяцу создания, выигранные и проигранные сделки — по месяцу итога. Месяцы идут по часовому поясу студии. Сумма — по примерным бюджетам; сделка без бюджета в сумму не входит, но в количество входит',
        example:
          'Лид завели 31 октября в 23:30, сделку выиграли 2 ноября: лид — в октябре, выигрыш — в ноябре',
      },
      scopeAll: 'Вся студия',
      scopeOwn: 'Ваши записи',
      scopeOwnHint: {
        text: 'Вы видите цифры по своим лидам и сделкам и по тем, куда вас позвали, — как в списках. Цифры по всей студии видят менеджеры и админ',
      },
      month: 'Месяц',
      prevMonth: 'Предыдущий месяц',
      nextMonth: 'Следующий месяц',
      currentMonth: 'Текущий месяц',
      leads: 'Лиды',
      leadsHint: {
        text: 'Все заявки месяца: и отклонённые, и ставшие сделками. Вторичное — когда клиент уже был (у него была другая сделка или лид)',
        example: 'Анна написала в октябре и снова в феврале: в феврале её лид — вторичный',
      },
      primary: 'Первичные',
      repeat: 'Вторичные',
      won: 'Выиграно',
      lost: 'Проиграно',
      sum: 'на {sum}',
      noSum: 'бюджеты не указаны',
      previous: 'В прошлом месяце: {value}',
      previousEven: 'Как в прошлом месяце',
      bySource: 'Откуда пришли лиды',
      sourceUnset: 'Не указан',
      sourceUnsetHint: {
        text: 'У этих лидов не заполнено «Откуда». Укажите источник в карточке — сводка станет точнее',
      },
      reasons: 'Почему проиграли',
      reasonsHint: {
        text: 'Причины, которые выбирали, закрывая сделки как проигранные в этом месяце. Список причин ведёт админ в настройках продаж',
      },
      reasonsEmpty: 'Проигранных сделок в этом месяце нет',
      sourcesEmpty: 'Лидов в этом месяце нет',
      share: '{percent}',
      emptyTitle: 'За этот месяц пока пусто',
      emptyText: 'Заведите лид — он появится в сводке, а выигранные и проигранные сделки — по месяцу итога',
      emptyAction: 'Новый лид',
      failed: 'Не удалось собрать сводку — проверьте связь и попробуйте ещё раз',
    },
    workKinds: {
      fixed: 'Проект под ключ',
      tm: 'Почасово',
      subscription: 'Подписка',
      design_marketing: 'Дизайн и маркетинг',
    },
    // Как этап называется для клиента (кабинет клиента — позже).
    clientStages: {
      lead: 'Заявка получена',
      new: 'Заявка принята',
      discovery: 'Обсуждаем задачу',
      proposal: 'Готовим предложение',
      negotiation: 'Предложение у вас',
      contract: 'Ждём подписания',
      won: 'Договор подписан',
    },
    convertFields: {
      clientName: 'название клиента',
      contact: 'способ связи',
      workKind: 'вид работы',
    },
    notifications: {
      assignedTitle: 'Вас назначили ответственным: {title}',
      assignedBody: 'Клиент — {client}',
      invitedTitle: 'Вас позвали в сделку: {title}',
      invitedBody: 'Клиент — {client}',
      repeatLeadTitle: 'Новое обращение клиента {client}',
      repeatLeadBody: '{author} завёл лид «{title}»',
      queueNewTitle: 'Новый лид в очереди: {title}',
      queueNewBody: 'Кто первым нажмёт «Взять», тот и ответственный',
      queueTimeoutTitle: 'Лид ждёт уже {minutes}',
      queueTimeoutBody: '«{title}» в очереди — возьмите его или назначьте ответственного',
      stepDueTitle: 'Шаг: {step} — {deal}',
      digestTitle: 'Утренняя сводка продаж',
      unassignedTitle: 'Сделки без ответственного',
      unassignedBody: 'Отключили сотрудника «{name}»: {what} теперь без ответственного',
    },
    // Сколько записей осталось без ответственного после отключения сотрудника.
    unassigned: {
      deals: {
        one: '{count} сделка',
        few: '{count} сделки',
        many: '{count} сделок',
        other: '{count} сделки',
      },
      leads: {
        one: '{count} лид',
        few: '{count} лида',
        many: '{count} лидов',
        other: '{count} лида',
      },
    },
    // Строки утренней сводки: склонение по числу.
    digest: {
      today: {
        one: '{count} шаг на сегодня',
        few: '{count} шага на сегодня',
        many: '{count} шагов на сегодня',
        other: '{count} шага на сегодня',
      },
      overdue: {
        one: '{count} просроченный',
        few: '{count} просроченных',
        many: '{count} просроченных',
        other: '{count} просроченных',
      },
      withoutStep: {
        one: '{count} запись без шага',
        few: '{count} записи без шага',
        many: '{count} записей без шага',
        other: '{count} записи без шага',
      },
      returned: {
        one: '{count} вернулась из отложенных',
        few: '{count} вернулись из отложенных',
        many: '{count} вернулись из отложенных',
        other: '{count} вернулись из отложенных',
      },
    },
    proposalAuto: {
      touchSent: '{label} отправлено',
      stepFollowUp: 'Созвониться по КП',
      stepContract: 'Подготовить договор',
      stepDeclined: 'Разобраться с отказом: {reason}',
      stepRenew: 'Обновить КП',
    },
    documentsAuto: {
      wonNote: 'Клиент подписал: {title}',
    },
    stepKinds: {
      call: 'Звонок',
      meeting: 'Встреча',
      email: 'Письмо',
      proposal: 'Отправить КП',
      other: 'Другое',
    },
    touchKinds: { call: 'Звонок', meeting: 'Встреча', email: 'Письмо', message: 'Сообщение' },
    touchDirections: { outgoing: 'Исходящий', incoming: 'Входящий' },
    reasonKinds: { lost: 'Проигрыш', rejected: 'Отклонение лида' },
    reasonKind: 'вид причины',
    reasonsOrder: 'порядок причин',
    step: { kind: 'вид шага' },
    touch: {
      kind: 'вид касания',
      period: 'период',
      deal: 'сделка',
      client: 'клиент',
      contact: 'контакт',
    },
    nextStep: {
      title: 'Следующий шаг',
      none: 'Нет шага',
      noneText: 'Поставьте следующий шаг — например, «позвонить завтра»: система напомнит о нём вовремя',
      noneLeadText: 'Поставьте шаг — например, «перезвонить»: так лид не потеряется',
      noneQuiet: 'Шага нет',
      noneQuietText: 'Запись отложена, поэтому не подсвечивается. Шаг можно поставить заранее',
      silent: 'Запись отложена: шаг напомнит о себе только после возврата — {date}',
      set: 'Поставить шаг',
      setTitle: 'Следующий шаг',
      editTitle: 'Изменить шаг',
      dialogLead: 'Что делаем с записью дальше и когда. В назначенный момент исполнитель получит уведомление',
      save: 'Сохранить',
      edit: 'Изменить шаг',
      remove: 'Удалить шаг',
      done: 'Выполнено',
      doneTitle: 'Шаг выполнен',
      doneLead: '«{title}» — запишите итог и, если нужно, сразу поставьте следующий шаг',
      move: 'Перенести',
      moveTitle: 'Перенести шаг',
      moveLead: 'Сейчас — {date}. Выберите новый день',
      kind: 'Вид шага',
      what: 'Что сделать',
      placeholders: {
        call: 'Например, позвонить и уточнить бюджет',
        meeting: 'Например, встреча по задаче',
        email: 'Например, отправить письмо с вопросами',
        proposal: 'Например, отправить КП',
        other: 'Что нужно сделать',
      },
      date: 'Срок',
      time: 'Время',
      assignee: 'Исполнитель',
      assigneeDefault: 'Ответственный за запись',
      result: 'Итог',
      resultPlaceholder: 'Чем закончилось (необязательно)',
      summary: 'Сводка: кто, кому, о чём договорились',
      summaryNote: 'Из неё появится касание в журнале — разговор не потеряется',
      summaryPlaceholder: 'Например: позвонила Анна, обсудили бюджет, договорились созвониться в пятницу',
      whatNext: 'Что дальше?',
      noNext: 'Без следующего шага',
      otherDate: 'Другая дата',
      presets: { tomorrow: 'Завтра', in3days: 'Через 3 дня', inWeek: 'Через неделю' },
      today: 'Сегодня',
      tomorrow: 'Завтра',
      yesterday: 'Вчера',
      overdue: 'Просрочен',
      toast: {
        set: 'Шаг поставлен: {date}',
        done: 'Шаг выполнен',
        doneNext: 'Шаг выполнен · следующий: {date}',
        rescheduled: 'Шаг перенесён: {date}',
        removed: 'Шаг удалён',
      },
    },
    touchLog: {
      recordCall: 'Записать звонок',
      record: 'Записать касание',
      callTitle: 'Записать звонок',
      callLead: 'Кому звонили и о чём договорились. Если звонок по сделке, сразу поставьте следующий шаг',
      recordTitle: 'Записать касание',
      lead: 'Звонок, встреча, письмо или сообщение — со сводкой «кто, кому, о чём договорились»',
      editTitle: 'Изменить касание',
      save: 'Сохранить',
      client: 'Клиент',
      who: 'Кому',
      whoPlaceholder: 'Найдите клиента или контакт: имя, телефон, почта',
      kind: 'Вид касания',
      direction: 'Направление',
      when: 'Когда',
      contact: 'Контакт',
      contactPlaceholder: 'Контакт (необязательно)',
      deal: 'Сделка',
      noDeal: 'Без сделки',
      summary: 'Сводка',
      summaryPlaceholder: 'Кто, кому, о чём договорились',
      noSummary: 'Без сводки',
      fromStep: 'из выполненного шага',
      today: 'Сегодня',
      yesterday: 'Вчера',
      edit: 'Изменить касание',
      remove: 'Удалить касание',
      hidden: 'Касаний, которые вам не видны: {count}',
      filterWho: 'Кто записал',
      filterKind: 'Вид',
      filterPeriod: 'Период',
      emptyTitle: 'Касаний пока нет',
      emptyText:
        'Здесь будут звонки, встречи, письма и сообщения со сводками. Запишите первый разговор — и его не придётся вспоминать',
      emptyDealText: 'По этой сделке ещё не звонили и не писали. Запишите разговор — он останется в журнале',
      emptyClientText:
        'С этим клиентом ещё не общались или это не записано. Запишите звонок — он останется в журнале',
      emptyFilteredTitle: 'Под фильтры ничего не подходит',
      emptyFilteredText: 'Сбросьте фильтры или расширьте период',
      toast: {
        recorded: 'Касание записано',
        callRecorded: 'Звонок записан',
        callAndStep: 'Звонок записан, следующий шаг поставлен',
        removed: 'Касание удалено',
      },
    },
    callReturn: {
      question: 'Вернулись из звонка? Запишите итог, пока помните',
      record: 'Записать итог звонка',
      dismiss: 'Закрыть',
    },
    settingsPage: {
      title: 'Настройки продаж',
      hint: 'Причины проигрыша и отклонения, таймер очереди лидов, рабочие часы и названия этапов. Видит только тот, кто управляет продажами',
      hintExample: 'Добавили причину «Нет бюджета» — она появилась в окне «Проиграна»',
      queue: {
        title: 'Очередь лидов',
        lead: 'Если лид из очереди никто не берёт, менеджеры получат напоминание «Лид ждёт уже N минут»',
        minutes: 'Напомнить через',
        unit: 'мин',
      },
      hours: {
        title: 'Рабочие часы',
        lead: 'В них идёт таймер очереди; рабочие дни — по производственному календарю студии',
        from: 'Начало дня',
        to: 'Конец дня',
        timeZone: 'Часовой пояс студии: {zone}',
      },
      stages: {
        title: 'Названия этапов',
        lead: 'Так этапы называются у нас. Удалить и переставить их нельзя; клиент видит свои названия',
        forClient: 'Клиент видит: «{title}»',
        reset: 'Вернуть название «{title}»',
      },
      reasons: {
        lostTitle: 'Причины проигрыша',
        lostLead: 'Предлагаются в окне «Проиграна»',
        rejectedTitle: 'Причины отклонения лида',
        rejectedLead: 'Предлагаются в окне «Отклонить»',
        add: 'Добавить',
        addLabel: 'Новая причина',
        addPlaceholder: 'Новая причина — например, «Нет бюджета»',
        up: 'Выше: {title}',
        down: 'Ниже: {title}',
        archive: 'В архив: {title}',
        archived: 'Причина «{title}» в архиве',
        restore: 'Вернуть',
        restored: 'Причина «{title}» снова предлагается',
        archivedTitle: 'В архиве',
      },
    },
    chat: {
      entity: 'Сделка',
    },
    hint: 'Лиды и сделки студии: заявка не теряется, пока не стала договором. Лид — заявка, которую ещё нужно прояснить; когда ясно, что работа будет, он становится сделкой и идёт по этапам воронки до итога',
    hintExample:
      'Позвонила Анна из пекарни — вы вносите её лидом одной строкой; после разговора нажимаете «В сделку» и ведёте по этапам до «Выиграна»',
    tabLeads: 'Лиды',
    tabPipeline: 'Воронка',
    process: {
      title: 'Путь сделки',
      hint: 'Бриф, смета, КП и договор — по порядку. Текущий шаг отмечен, его кнопка — главная на карточке; готовые шаги — с галочкой. Бриф можно пропустить и сразу завести смету',
      hintExample:
        'Смета утверждена → «Открыть КП» и отправить клиенту; клиент выбрал пакет → «Открыть договор» и отправить на подпись',
      step: 'Шаг {n}',
      done: 'Готово',
      lead: 'Бриф, смета, КП и договор появятся, когда лид станет сделкой',
      mismatch: 'Сделка на этапе «{stage}», а КП клиенту ещё не отправлено',
      mismatchAction: 'Открыть КП',
      nav: 'Путь сделки',
      toDeal: 'Сделка',
    },
    quickCalc: {
      title: 'Быстрый расчёт',
      open: 'Быстрый расчёт',
      hint: 'Один экран от заявки до КП: ИИ собирает бриф, вы отвечаете на вопросы, ИИ считает смету, вы утверждаете и отправляете КП. Каждый шаг можно открыть полностью',
      hintExample: 'Лид «Сайт для пекарни» → бриф за минуту → 4 ответа → смета с тремя пакетами → КП клиенту',
      steps: {
        deal: 'Сделка',
        brief: 'Бриф',
        answers: 'Ответы',
        estimate: 'Смета',
        proposal: 'КП',
      },
      stepOf: 'Шаг {n} из {total}',
      next: 'Дальше',
      back: 'Назад',
      openFull: 'Открыть полностью',
      leadTitle: 'Лид станет сделкой',
      leadText: 'Бриф, смета и КП заводятся у сделки. Переведём лид в сделку — недостающее спросим здесь же',
      convert: 'Сделать сделкой и продолжить',
      briefTitle: 'Бриф по заявке',
      briefEmpty: 'ИИ прочитает заявку, касания, письма и сообщения клиента и соберёт бриф с вопросами',
      briefCollect: 'Собрать бриф',
      briefReady: 'Бриф собран. Проверьте главное и переходите к ответам',
      answersTitle: 'Ответы на вопросы',
      answersLead:
        'Выберите вариант, напишите свой ответ или отметьте «Спросить клиента». Утвердить можно и с вопросами без ответа — смета учтёт их как допущения',
      approveBrief: 'Утвердить бриф и считать смету',
      briefApproved: 'Бриф утверждён',
      estimateTitle: 'Смета',
      estimateEmpty:
        'ИИ разложит работу на этапы и задачи с часами по утверждённому брифу — получатся три пакета с ценами и сроками',
      estimateCollect: 'Посчитать смету',
      estimateLead: 'Цены пакетов и сроки. Поправить задачи, часы и Гант — на странице сметы',
      proposalTitle: 'Коммерческое предложение',
      proposalLead: 'Смета готова — соберите КП: тексты для клиента, оплата, отправка ссылкой',
      proposalOpen: 'Открыть КП и отправить',
      proposalSent: 'КП отправлено клиенту — дальше ждём выбора пакета',
      notEditable: 'Сделку ведёт другой менеджер — шаги можно смотреть, но не менять',
      closed: 'Сделка закрыта — расчёт только для просмотра',
      startTitle: 'Быстрый расчёт без лида',
      startLead:
        'Кто клиент и что нужно — этого хватит, чтобы начать. Заведём лид, переведём в сделку и откроем расчёт',
      startName: 'Клиент',
      startNamePlaceholder: 'Имя или название компании',
      startContact: 'Телефон или почта',
      startTitleField: 'Проект',
      startTitlePlaceholder: 'Например, «Сайт для пекарни»',
      startDescription: 'Что нужно клиенту',
      startDescriptionPlaceholder:
        'Своими словами: задача, что есть сейчас, сроки, бюджет, пожелания — всё, что известно',
      startDescriptionHint: 'Описание станет касанием в сделке — из него ИИ соберёт бриф',
      startSubmit: 'Начать расчёт',
      startNeedName: 'Укажите клиента',
      startNeedContact: 'Нужен телефон или почта',
      startNeedDescription: 'Опишите, что нужно клиенту',
      startNeedWorkKind: 'Выберите вид работы',
    },
    activity: 'Лента сделки',
    tabOverview: 'Обзор',
    tabChat: 'Чат',
    tabTouches: 'Касания',
    tabSummary: 'Сводка',
    tabHistory: 'История',
    newLead: 'Новый лид',
    paletteGroup: 'Сделки',
    repeat: 'Вторичное',
    take: 'Взять',
    toDeal: 'В сделку',
    reject: 'Отклонить',
    reopen: 'Вернуть в работу',
    resumeNow: 'Вернуть из отложенных',
    delete: 'Удалить',
    more: 'Ещё',
    specify: 'Указать',
    resetFilters: 'Сбросить фильтры',
    saveFailed: 'Не удалось сохранить — проверьте связь и попробуйте ещё раз',
    moreHint: 'Показаны первые {count} из {total} — уточните фильтры, чтобы найти нужное',
    noResponsible: 'Без ответственного',
    noResponsibleShort: 'Не назначен',
    noBudget: 'Бюджет не указан',
    budgetPlaceholder: 'Например, 300 000',
    participants: 'Участники',
    noParticipants: 'Никого не звали',
    notFound: 'Такой записи нет',
    notFoundText: 'Возможно, её удалили или она у другого сотрудника',
    noContact: 'У записи нет контакта — добавьте его в карточке клиента',
    openClient: 'Открыть клиента',
    stageStrip: 'Этап',
    columnWho: 'Кто',
    columnNeed: 'Что нужно',
    columnSource: 'Откуда',
    columnResponsible: 'Ответственный',
    columnAge: 'Висит',
    columnDeal: 'Сделка',
    columnStage: 'Этап',
    columnInStage: 'На этапе',
    columnNextStep: 'Следующий шаг',
    age: {
      one: '{count} день',
      few: '{count} дня',
      many: '{count} дней',
      other: '{count} дня',
    },
    sectionLead: 'Лид',
    sectionDeal: 'Сделка',
    sectionPeople: 'Люди',
    sectionContact: 'Контакт',
    sectionDates: 'Даты',
    fields: {
      title: 'Название',
      client: 'Клиент',
      workKind: 'Вид работы',
      budget: 'Примерный бюджет',
      source: 'Откуда пришёл',
      sourceNote: 'Уточнение',
      responsible: 'Ответственный',
      contact: 'Контакт сделки',
    },
    dates: { created: 'Создан', taken: 'Взят', stage: 'На этапе с' },
    leadNotice: 'Это лид.',
    leadNoticeText:
      'Заявка, которую нужно прояснить. Когда станет ясно, что работа будет, нажмите «В сделку» — откроются этапы',
    queueNotice: 'Лид в очереди.',
    queueNoticeText: 'Его ещё никто не взял: кто первым нажмёт «Взять», тот и ответственный',
    chatEmptyTitle: 'Обсуждение сделки',
    chatEmptyText:
      'Договорённости, вопросы и заметки — здесь. Читают ответственный, участники и менеджеры; смена этапа и итог попадают в чат сами',
    filters: {
      queue: 'Очередь',
      mine: 'Мои',
      all: 'Все',
      responsible: 'Ответственный',
      workKind: 'Вид работы',
      closed: 'Закрытые',
      unassigned: 'Без ответственного',
    },
    view: { label: 'Вид', board: 'Доска', table: 'Таблица' },
    leads: {
      state: 'Состояние',
      states: { open: 'В работе', postponed: 'Отложенные', rejected: 'Отклонённые' },
      inQueue: 'В очереди: {count}',
      emptyTitle: 'Лидов пока нет',
      emptyText: 'Введите первого строкой выше: имя и телефон или почта — остальное дозаполнится позже',
      emptyQueueTitle: 'Очередь пуста',
      emptyQueueText:
        'Сюда будут попадать заявки автоматических источников, например с формы на сайте: кто первым нажмёт «Взять», тот и ответственный. Пока лиды заводятся вручную — строкой выше',
      emptyFilteredTitle: 'Под фильтры ничего не подходит',
      emptyFilteredText: 'Сбросьте фильтры или заведите новый лид строкой выше',
    },
    pipeline: {
      emptyTitle: 'Сделок пока нет',
      emptyText:
        'Сделка вырастает из лида: заведите лид, а когда станет ясно, что работа будет, нажмите «В сделку» — она появится здесь на этапе «Новая»',
      emptyFilteredTitle: 'Под фильтры ничего не подходит',
      emptyFilteredText: 'Сбросьте фильтры — возможно, у этих людей и видов работы сделок пока нет',
      noOpen: 'Открытых сделок нет — отложенные и закрытые ниже',
      emptyUnassignedTitle: 'Сделок без ответственного нет',
      emptyUnassignedText:
        'У каждой открытой сделки есть ответственный. Если сотрудника отключат, его сделки появятся здесь, а вы получите уведомление',
    },
    board: {
      moveTo: 'Перевести на этап',
      next: 'Дальше',
      lastStage: 'Последний этап',
      inStage: 'Дней на этапе',
      emptyColumn: 'Здесь пусто — перетащите сюда сделку',
      more: 'Ещё {count} — уточните фильтры',
      sum: 'Сумма: {sum}',
      noSum: 'Бюджет не указан',
      swipe: 'Этапы листаются свайпом',
      draggable: 'карточку можно перетащить',
      dragInstructions:
        'Карточку сделки можно перетащить в другой этап мышью или пальцем. С клавиатуры — кнопки «Дальше» и «Перевести на этап» на карточке',
      announceStart: 'Взяли карточку «{title}»',
      announceOver: 'Карточка «{title}» над этапом «{stage}»',
      announceDrop: 'Карточка «{title}» перенесена на этап «{stage}»',
      announceCancel: 'Перенос карточки «{title}» отменён',
    },
    postponed: {
      title: 'Отложенные',
      until: 'Отложена до {date}',
      resume: 'Вернуть',
      note: '— в этот день сделка сама вернётся на доску',
    },
    closed: { title: 'Закрытые', empty: 'Закрытых сделок пока нет' },
    postpone: {
      title: 'Отложить до…',
      menu: 'Отложить до…',
      lead: 'Когда вернуться к записи? В этот день она сама вернётся на доску',
      leadMove: 'Сейчас отложена до {date}. Выберите новую дату',
      date: 'Дата',
      submit: 'Отложить',
      presets: { tomorrow: 'Завтра', in3: 'Через 3 дня', week: 'Через неделю', month: 'Через месяц' },
    },
    close: {
      reason: 'Причина',
      note: 'Комментарий',
      notePlaceholder: 'Что важно запомнить (необязательно)',
      lost: {
        title: 'Сделка проиграна',
        lead: 'Почему «{title}» не состоялась? Причина нужна для сводки: по ней видно, что мешает продавать',
        submit: 'Проиграна',
      },
      rejected: {
        title: 'Отклонить лид',
        lead: 'Почему «{title}» не подходит? Клиент останется потенциальным, а лид можно вернуть в работу',
        submit: 'Отклонить',
      },
    },
    convert: {
      title: 'Сделать сделкой',
      lead: 'Не хватает пары данных — заполните их здесь, не уходя со страницы',
      clientName: 'Название клиента',
      howToReach: 'Как связаться',
      channelHint: 'Нужен телефон или почта',
      needChannel: 'Укажите телефон или почту',
      needWorkKind: 'Выберите вид работы',
      pickWorkKind: 'Выберите вид работы',
      afterwards: 'Лид станет сделкой на этапе «Новая»; чат, история и бюджет сохранятся',
      submit: 'В сделку',
    },
    invite: {
      title: 'Позвать в сделку',
      lead: 'Сотрудник увидит сделку и её клиента, окажется в чате сделки и получит уведомление',
      placeholder: 'Выберите сотрудника',
      nobody: 'Звать некого: все доступные сотрудники уже в сделке',
      add: 'Позвать',
      remove: 'Убрать: {name}',
    },
    clientDeals: {
      noOpen: 'Открытых лидов и сделок нет',
      all: 'Все лиды и сделки · {count}',
      newTitle: 'Название нового лида',
      newPlaceholder: 'Что нужно клиенту (необязательно)',
      hint: 'Лид для этого клиента. Если у него уже есть сделки, новый лид будет вторичным обращением. Название можно не писать — возьмётся имя клиента',
      hintExample: 'У «Ромашки» идёт сайт, а теперь просят логотип — заведите второй лид «Логотип»',
      emptyTitle: 'Сделок у клиента пока нет',
      emptyText: 'Заведите лид: он появится в «Лидах», а потом станет сделкой',
      hidden: 'Сделок клиента, которые вам не видны: {count}',
    },
    toast: {
      won: 'Сделка «{title}» выиграна',
      wonPending: 'Отмечаем «{title}» выигранной — вернуть её в работу потом сможет только админ',
      lost: 'Сделка «{title}» проиграна',
      rejected: 'Лид «{title}» отклонён',
      reopened: '«{title}» возвращена в работу',
      postponed: 'Отложено до {date}',
      deleted: 'Удалено: «{title}»',
      taken: 'Лид «{title}» у вас',
      converted: '«{title}» стала сделкой',
      participantRemoved: '{name} больше не в сделке',
    },
    quick: {
      title: 'Новый лид',
      name: 'Имя',
      contact: 'Телефон или почта',
      source: 'Откуда',
      add: 'Добавить',
      hint: 'Введите, кто обратился и как с ним связаться: лид сразу закреплён за вами, а клиент-физлицо создаётся сам. Если такой телефон или почта уже есть у клиента, система спросит, не вторичное ли это обращение',
      hintExample: 'Анна, +7 912 345-67-89, «По рекомендации» — и Enter',
      created: 'Лид «{name}» создан',
      queued: 'Лид «{name}» передан менеджерам — его возьмут из очереди',
      open: 'Открыть',
      emailTaken: 'Эта почта уже у клиента «{name}» — привяжите лид к нему',
      repeatQuestion: 'Это вторичное обращение «{name}»?',
      noAccess: 'Клиента ведёт другой сотрудник — вы видите только название; он получит уведомление',
      yesRepeat: 'Да, вторичное',
      noNew: 'Нет, новый клиент',
      joined: 'Вторичное обращение: {name}',
      unjoin: 'Отменить',
      restoreClient: 'Вернуть клиента и завести лид',
    },
    hints: {
      stages: {
        text: 'Этапы одинаковы у всех сделок: «Новая» → «Выясняем задачу» → «Оценка и КП» → «Переговоры» → «Договор». Щёлкните по этапу, чтобы перевести сделку — вперёд или назад. Итог — «Выиграна» или «Проиграна» — ставится с любого этапа',
        example: 'Созвонились и выяснили задачу — «Выясняем задачу»; отправили КП — «Оценка и КП»',
      },
      stage: {
        new: 'Заявка принята, сделка заведена, но с клиентом ещё не говорили по существу',
        discovery: 'Выясняем, что нужно клиенту: задачу, сроки, примерный бюджет',
        proposal: 'Оцениваем работу и готовим коммерческое предложение',
        negotiation: 'Предложение у клиента: обсуждаем цену, сроки и условия',
        contract: 'Договорились — оформляем и ждём подписания договора',
      },
      phases: {
        title: 'Лид и сделка',
        text: 'Лид — заявка, которую ещё нужно прояснить. Когда ясно, что работа будет, он становится сделкой — это та же запись: чат, история и бюджет сохраняются. У сделки есть этапы и итог',
        example: 'Позвонил клиент — это лид. Обсудили задачу и бюджет — «В сделку»',
      },
      repeat: {
        text: 'Вторичное — обращение клиента, у которого уже есть другая сделка или лид. Так видно повторные заказы и то, что клиент возвращается',
        example: 'У «Ромашки» сделан сайт, а через полгода они просят логотип — это вторичное обращение',
      },
      budget: {
        text: 'Прикидка до коммерческого предложения: по ней видно, сколько денег в каждом этапе воронки. Точная сумма появится в КП. Видят все, у кого есть доступ к сделке',
        example: 'Клиент говорит «около 300 тысяч» — впишите 300 000',
      },
      workKind: {
        text: 'Что именно заказывают: проект под ключ, почасовая работа, подписка на сопровождение или дизайн и маркетинг. Нужен, чтобы лид стал сделкой',
        example:
          'Сайт с нуля — «Проект под ключ»; поддержка сайта за фиксированную сумму в месяц — «Подписка»',
      },
      noResponsible: {
        text: 'У записи нет ответственного — например, он уволился. Назначить нового может менеджер или админ',
      },
      unassigned: {
        text: 'Открытые сделки, у которых нет ответственного: сотрудника отключили, и сделки остались без хозяина. Откройте сделку и назначьте нового ответственного — до этого шаги по ней никому не напоминают',
        example:
          'Менеджера отключили — его 5 сделок собрались здесь, админ получил уведомление «Сделки без ответственного»',
      },
      queue: {
        text: 'В очередь попадают заявки автоматических источников, например с формы на сайте, и лиды отключённого сотрудника. Кто первым нажмёт «Взять», тот становится ответственным и за лид, и за клиента',
        example: 'Пришла заявка с сайта — Анна нажала «Взять» раньше Ивана, лид теперь у Анны',
      },
      postpone: {
        text: 'Отложенная запись уходит с доски вниз, в «Отложенные». В назначенный день она сама вернётся на доску. Отложить можно только на дату позже сегодняшней',
        example: 'Клиент просит вернуться к разговору после отпуска — «Отложить до…» и дата выхода',
      },
      reason: {
        text: 'Причина — из готового списка: по ней в сводке видно, почему мы теряем сделки. Комментарий можно не писать',
        example: 'Клиент ушёл к другим студиям — «Выбрали других»',
      },
      contact: {
        text: 'С кем по этой сделке разговариваем. Выберите другого человека из контактов клиента; новых контактов добавляйте в карточке клиента',
        example: 'В «Ромашке» директор Анна и бухгалтер Пётр: по договору — Пётр, по задаче — Анна',
      },
      access: {
        title: 'Кто видит сделку',
        text: 'Сделку видят ответственный, участники и менеджеры с админом. Участник видит ещё и клиента сделки. Позвать коллегу может ответственный или менеджер',
        example:
          'Анна ведёт сделку и зовёт дизайнера Петра: он видит сделку, клиента и чат сделки, но не другие сделки клиента',
      },
      noStep: {
        text: 'Открытая запись без следующего шага подсвечивается и попадает в утреннюю сводку. Шаг не обязателен, но так ничего не забывается. Отложенные записи и лиды в очереди не подсвечиваются',
        example:
          'Поговорили с клиентом — сразу поставьте «Позвонить в пятницу»: в пятницу придёт напоминание',
      },
      nextStep: {
        text: 'Что делаем с записью дальше и когда. В назначенный момент исполнитель получит уведомление. Шаг без времени напомнит в 9:00 своего дня, а просроченным станет после конца дня',
        example: 'Отправили КП — шаг «Позвонить и узнать впечатление» через 3 дня',
      },
      nextAfterDone: {
        text: 'После выполненного шага сразу предлагаем следующий — так запись не остаётся без шага. Выберите «Завтра», «Через 3 дня» или «Через неделю» — остальное подставится само. Следующий шаг можно не ставить',
        example: 'Созвонились — «Через 3 дня»: в этот день позвоните ещё раз',
      },
      stepMoment: {
        text: 'Срок шага — день и, по желанию, время по часовому поясу студии. Быстрые даты считаются от сегодняшнего дня',
        example: 'Сегодня вторник: «Через 3 дня» — это пятница',
      },
      stepTime: {
        text: 'Время необязательно. Без него шаг на весь день: напоминание придёт в 9:00, а просроченным он станет только после конца дня',
        example: 'Созвон в 15:30 — укажите время; «связаться на этой неделе» — оставьте пустым',
      },
      stepSummary: {
        text: 'Сводка звонка или встречи: кто, кому, о чём договорились. Из неё сам появится пункт в журнале касаний. Можно оставить пустой, но со сводкой через месяц разговор вспомнить легче',
        example: 'Анна из пекарни: бюджет до 300 тысяч, КП пришлём в четверг',
      },
      touchSummary: {
        text: 'Кто, кому, о чём договорились — несколькими словами. По сводке видно, что обсуждали, без поиска по чатам и почте',
        example: 'Позвонил Анне: хотят сайт с каталогом, договорились о встрече в четверг',
      },
      callTarget: {
        text: 'Введите имя, телефон или почту — найдём клиента или контакт среди тех, кого вы видите. Если у клиента одна открытая сделка, звонок запишется к ней',
        example: 'Введите «Анна» или «912 345» и выберите из списка',
      },
      touches: {
        text: 'Журнал звонков, встреч, писем и сообщений со сводками. Сотрудник видит касания по своим клиентам и сделкам, менеджер — все',
        example: 'Позвонили клиенту — «Записать звонок» и пара слов о договорённостях',
      },
      touchAccess: {
        text: 'Касание видно тому, кто видит его клиента или сделку: ответственному, участникам, менеджерам и админу',
        example: 'Анна ведёт сделку и записала звонок — Пётр, которого не звали в сделку, его не увидит',
      },
      queueTimer: {
        text: 'Если лид в очереди никто не взял дольше этого времени, менеджеры получат напоминание. Считаются только рабочие минуты: по рабочим дням календаря студии и в рабочие часы',
        example: '30 минут: лид пришёл в 18:50 — напомним в 10:20 следующего рабочего дня',
      },
      workHours: {
        text: 'В эти часы идёт таймер очереди лидов. Вне них, в выходные и праздники по календарю студии время не считается',
        example: '10:00–19:00: лид, пришедший в субботу, начнёт ждать в понедельник с 10:00',
      },
      stageNames: {
        text: 'Этапы можно переименовать под студию, но не удалить и не переставить. Клиент в кабинете видит свои названия этапов — они не меняются',
        example: '«Оценка и КП» → «Считаем и готовим КП»: клиент по-прежнему увидит «Готовим предложение»',
      },
      reasonsAdmin: {
        text: 'Причины предлагаются в окнах «Проиграна» и «Отклонить». Порядок можно менять. Архивная причина больше не предлагается, но остаётся у сделок, которые уже закрыты с ней',
        example: 'Убрали «Другое» в архив — у старых проигранных сделок оно по-прежнему видно',
      },
    },
  },
  access: ruAccess,
  ai: ruAi,
  dadata: ruDadata,
  siteConfig: ruSiteConfig,
  documents: ruDocuments,
  edo: { ...ruEdo, notifications: ruEdoNotifications },
  feedback: ruFeedback,
  finance: {
    ...ruFinance,
    bank: ruFinanceBank,
    acquiring: ruFinanceAcquiring,
    registry: ruFinanceRegistry,
    notifications: { ...ruFinanceNotifications, ...ruFinanceBankNotifications },
  },
  vault: {
    tab: 'Доступы',
    title: 'Сейф доступов',
    lead: 'Логины и пароли к сайтам, хостингу и сервисам клиента. Шифруются на устройствах — сервер их не знает',
    hint: {
      title: 'Сейф доступов',
      text: 'Логин, пароль и заметка шифруются на ваших устройствах ключом сейфа; его знают только люди с доступом: участники проекта, ответственный за клиента и админы. Каждое «Показать» и «Копировать» пароля попадает в журнал',
      example: 'Доступ в админку сайта клиента: название, адрес, логин, пароль',
    },
    add: 'Добавить',
    added: 'Запись добавлена',
    save: 'Сохранить',
    saved: 'Запись сохранена',
    newTitle: 'Новая запись',
    editTitle: 'Изменить запись',
    dialogLead: 'Логин, пароль и заметка зашифруются на этом устройстве',
    fields: {
      title: 'Название',
      url: 'Адрес входа',
      login: 'Логин',
      password: 'Пароль',
      passwordKeep: 'Новый пароль (пусто — оставить прежний)',
      note: 'Заметка',
    },
    generate: 'Придумать пароль',
    passwordRequired: 'Укажите пароль',
    show: 'Показать пароль',
    hide: 'Скрыть пароль',
    copy: 'Копировать пароль',
    copied: 'Пароль скопирован',
    edit: 'Изменить',
    remove: 'Удалить',
    deleted: 'Запись «{title}» удалена',
    noLogin: 'без логина',
    empty: 'Записей пока нет',
    emptyManage: 'Записей пока нет — добавьте первый доступ',
    noAccess: 'Сейф видят участники проекта, ответственный за клиента и админы',
    undecryptable: 'Не удалось расшифровать: ключа этой записи нет на устройстве',
    noKey: 'Ключа сейфа нет на этом устройстве — откройте сейф позже или на другом устройстве',
    staleReader:
      'Состав доступа изменился: сейф обновит ключ, когда его откроет тот, кто его ведёт. До тех пор записи только для чтения',
    rotated: 'Ключ сейфа обновлён: ушедшие больше не прочитают новые пароли',
    failed: 'Не получилось — попробуйте ещё раз',
    gateTitle: 'Подтвердите это устройство',
    gateLead: 'Пароли сейфа расшифровываются только на подтверждённом устройстве',
    journal: 'Журнал',
    journalTitle: 'Кто открывал пароли',
    journalLead: 'Последние 100 «Показать» и «Копировать»',
    journalEmpty: 'Пароли ещё никто не открывал',
    notifications: {
      rotateTitle: 'Смените пароли в сейфе доступов',
      rotateBody: 'Человек с доступом к сейфу ушёл из проекта или уволен — смените пароли: {titles}',
    },
  },
  projects: {
    ...ruProjects,
    ...ruProjectsWork,
    ...ruProjectsDelivery,
    ...ruProjectsSupport,
    ...ruProjectsAi,
    ...ruProjectsClient,
    payment: ruProjectsPayment,
    notifications: {
      ...ruProjects.notifications,
      ...ruProjectsWork.notifications,
      ...ruProjectsDeliveryNotifications,
      ...ruProjectsSupportNotifications,
      ...ruProjectsPaymentNotifications,
      ...ruProjectsClientNotifications,
    },
    hints: { ...ruProjects.hints, ...ruProjectsDeliveryHints, ...ruProjectsAiHints },
    card: { ...ruProjects.card, ...ruProjectsWorkCard },
    task: { ...ruProjects.task, ...ruProjectsWorkTask },
    palette: { ...ruProjects.palette, ...ruProjectsWorkPalette, ...ruProjectsSupportPalette },
  },
  /** Страница КП для клиента (`apps/portal`): берёт его через `@glory/i18n/portal`. */
  portal: ruPortal,
  cabinet: ruCabinetStaff,
  estimates: {
    title: 'Смета',
    packages: { b: 'Базовый', o: 'Оптимальный', m: 'Максимум' },
    kinds: { labor: 'По часам', fixed: 'Готовая цена' },
    startAfter: 'После предыдущего',
    startWith: 'Вместе с «{stage}»',
    saveFailed: 'Не удалось сохранить — проверьте связь и попробуйте ещё раз',
    tab: 'Сметы',
    term: '≈ {weeks}',
    statuses: { draft: 'Черновик', review: 'На проверке', approved: 'Утверждена' },
    shortPackages: { b: 'Б', o: 'О', m: 'М' },
    page: {
      title: 'Смета',
      tabTable: 'Смета и сроки',
      tabHistory: 'История',
      toPipeline: 'К воронке',
    },
    empty: {
      title: 'У сделки ещё нет сметы',
      text: 'Смета — этапы, работы и часы; из неё считаются три пакета с ценой и срок. Начните с услуги из каталога или соберите этапы вручную',
      readOnly: 'Сметы пока нет. Завести её может ответственный за сделку или менеджер продаж',
      leadTitle: 'Смету заводят у сделки',
      leadText: 'Сначала переведите лид в сделку — тогда здесь появится смета',
      create: 'Завести смету',
      toDeal: 'К карточке',
    },
    block: {
      title: 'Смета',
      lead: 'Смета заводится у сделки: сначала «В сделку»',
      none: 'Сметы пока нет — заведите её, и сделка перейдёт на этап «Оценка и КП»',
      noneReadOnly: 'Сметы пока нет',
      open: 'Открыть смету',
    },
    table: {
      label: 'Смета: этапы и работы',
      colTask: 'Работа',
      colSpecialization: 'Специализация',
      colHours: 'Часы',
      colPackages: 'Пакеты',
      colAssignee: 'Исполнитель',
      colDays: 'Дни',
      colCost: 'Себест.',
      assignee: 'Исполнитель работы № {number}',
      assigneePlaceholder: 'Кто',
      notOwnSpec: '{name}: не его специализация',
      notOwnSpecTitle: 'Исполнитель не той специализации',
      notOwnSpecText:
        'У сотрудника {name} в карточке нет специализации «{spec}». Работу посчитаем по его ставке, но проверьте: возможно, нужен другой исполнитель или стоит добавить ему специализацию',
      away: '{name} отсутствует во время работы',
      awayTitle: {
        vacation: 'Исполнитель будет в отпуске',
        sick: 'Исполнитель будет на больничном',
        day_off: 'У исполнителя отгул',
      },
      awayText:
        'Если начать сегодня, работа по плану идёт {taskFrom} — {taskTo}, а {name} отсутствует {fromOn} — {toOn}. Выберите другого исполнителя или сдвиньте работу',
      days: 'Длительность работы № {number}, рабочих дней',
      daysRange: 'дни {from}–{to}',
      cost: 'Себестоимость работы № {number}',
      planTask: 'План задачи…',
      collapse: 'Свернуть этап «{title}»',
      expand: 'Развернуть этап «{title}»',
      emptyTitle: 'Этапов пока нет',
      emptyText:
        'Добавьте этап и работы в нём или разверните услугу из каталога — норма часов подставится сама',
      emptyReadOnly: 'В смете пока нет этапов',
      stageEmpty: 'В этапе пока нет работ — добавьте первую строкой ниже',
      taskTitle: 'Название работы № {number}',
      specialization: 'Специализация работы № {number}',
      specializationPlaceholder: 'Специализация',
      hours: 'Часы работы № {number}',
      marks: 'Пакеты',
      mark: 'В пакет «{name}»',
      dragTask: 'Перетащить работу «{title}»',
      dragStage: 'Перетащить этап «{title}»',
      stageTitle: 'Название этапа № {number}',
      fixedBadge: 'Готовая цена · {price}',
      taskMenu: 'Действия с работой',
      stageMenu: 'Действия с этапом',
      toFixed: 'Готовая цена…',
      toLabor: 'Считать по часам',
      moveUp: 'Выше',
      moveDown: 'Ниже',
      moveToStage: 'Перенести в этап',
      removeTask: 'Удалить работу',
      requestStage: 'Оценить этап…',
      moveStageUp: 'Этап выше',
      moveStageDown: 'Этап ниже',
      removeStage: 'Удалить этап',
      requestOpen: 'Оценивает: {name}',
      requestDone: 'Оценил: {name}',
      newStage: 'Название нового этапа',
      newStagePlaceholder: 'Новый этап — например, «Дизайн»',
      addStage: 'Добавить этап',
      newTaskTitle: 'Новая работа в этапе «{stage}»',
      newTaskPlaceholder: 'Новая работа',
      newTaskSpecialization: 'Специализация новой работы в этапе «{stage}»',
      newTaskHours: 'Часы новой работы в этапе «{stage}»',
      addTask: 'Добавить',
    },
    toast: { taskRemoved: 'Работа «{title}» удалена', stageRemoved: 'Этап «{title}» удалён' },
    panel: {
      title: 'Пакеты',
      recommended: '★ Рекомендуем',
      noPrice: 'Цена не посчитана',
      emptyPackage: 'В пакете нет работ — отметьте «{mark}» у нужных работ',
      fill: 'Заполнить',
      floor: 'Пол',
      optimum: 'Оптимум',
      ceiling: 'Потолок',
      sliderLabel: 'Цена пакета «{name}»',
      priceInput: 'Цена пакета «{name}», сумма',
      margin: 'Маржа {rate} · {amount}',
      belowFloor: 'Ниже пола: работаем в минус. Отправить такое КП без одобрения админа нельзя',
      belowMin: 'Маржа ниже минимальной ({min}): при отправке КП понадобится причина',
      correction: 'Корректировка {value}',
      toOptimum: 'К оптимуму',
      problems: {
        no_policy: 'Не задана политика цены.',
        no_tax: 'Не задан налог.',
        no_rate: 'У специализаций нет плановой ставки: {names}.',
      },
      hourlyTitle: 'Клиентские ставки в час',
      hourlyEmpty: 'Добавьте работы — появятся ставки',
      hourlyNote:
        'Почасовая сделка: клиент увидит ставки по специализациям и объём «от–до». Ставки видны тем, кто видит деньги',
    },
    controls: {
      packages: 'Пакеты · {count}',
      packagesTitle: 'Какие пакеты предлагаем',
      include: 'Включить пакет «{name}»',
      packageName: 'Название пакета «{name}»',
      recommend: 'Рекомендуем',
      coefficients: 'Коэффициенты · {count}',
      coefficientsTitle: 'Коэффициенты сметы',
      coefficientsEmpty: 'В справочнике нет действующих коэффициентов',
    },
    hints: {
      packages: {
        title: 'Б / О / М — пакеты',
        text: 'Три пакета предложения: Базовый, Оптимальный, Максимум. У каждой работы отметьте, в какие пакеты она входит. Более глубокая работа в старшем пакете — отдельная строка только с «М». Часы правятся в одном месте — цены всех пакетов пересчитываются сразу',
        example: 'Макет — Б О М, анимации — только О М: Базовый дешевле на анимации',
      },
      fork: {
        title: 'Пол, оптимум, потолок',
        text: 'Пол — цена без наценки и коэффициентов: себестоимость, накладные и налог; ниже — работаем в минус. Оптимум — по политике цены и коэффициентам сметы. Потолок — оптимум плюс заданная доля (в настройках сметы). Цену внутри вилки выбираете вы: ползунком или суммой',
        example: 'Пол 1 540 000 ₽, оптимум 2 120 000 ₽, потолок 2 756 000 ₽ (+30 %)',
      },
      correction: {
        title: 'Корректировка',
        text: 'Разница между вашей ценой и оптимумом записывается коэффициентом «Корректировка»: ×1,10 — на 10 % выше оптимума. Движок пересчитывает цену по нему, итог показан после округления',
        example: 'Оптимум 2 120 000 ₽, вы поставили 2 332 000 ₽ — корректировка ×1,10',
      },
      margin: {
        title: 'Маржа',
        text: 'Что остаётся студии после налогов и полной себестоимости, в процентах от выручки без НДС. Минимальная по политике цены — {min}: ниже неё при отправке КП понадобится причина',
        example: 'Выручка 1 000 000 ₽, остаётся 400 000 ₽ — маржа 40 %',
      },
      review: {
        title: 'Проверка админом',
        textRequired:
          'Перед отправкой КП смета проходит проверку админа: он утверждает её или возвращает с замечаниями. Правка состава, часов, цены, исполнителей или плана возвращает утверждённую смету в черновик, тексты КП для клиента — нет. Проверяющий может править и утверждать сам',
        textOptional:
          'Проверка админом сейчас необязательна: смету можно отправить на проверку, но КП уйдёт и без неё. Правка состава, часов, цены, исполнителей или плана возвращает утверждённую смету в черновик, тексты КП для клиента — нет',
        example: 'Менеджер собрал смету → «На проверку» → админ утвердил → КП можно отправлять',
      },
      schedule: {
        title: 'Как считается срок',
        text: 'Срок считается по задачам пакета. Длительность задачи — часы ÷ продуктивный день ({hours} ч), вверх до дня, или вручную. Задача начинается после своих предшествующих (связи «после») плюс сдвиг. Этап — от первой его задачи до последней. Срок пакета — конец последней задачи; клиенту в КП — в рабочих днях с запасом, вверх до целой недели (16 дней — «20 рабочих дней»)',
        example: 'Макет 48 ч → 8 дней; вёрстка после макета начнётся на 9-й день',
      },
      links: {
        title: 'Связи «после»',
        text: 'Задача не начнётся, пока не закончатся те, от которых она зависит. Связь: потяните от точки на конце полосы к другой полосе или добавьте в «Плане задачи». Стрелку можно выделить кликом и удалить клавишей Delete. Задача не из пакета пропускается: её место занимают её предшествующие',
        example: 'Вёрстка после макета, тестирование после вёрстки и разработки',
      },
      days: {
        title: 'Дней: из часов или вручную',
        text: 'Обычно длительность считается из часов. Если работа тянется дольше, чем её часы (ждём ответа клиента, согласование), задайте дни вручную — или потяните правый край полосы. «Из часов» в плане задачи возвращает расчёт',
        example: 'Согласование макета — 2 часа работы, но 5 дней ожидания',
      },
      byAssignees: {
        title: 'Цена от исполнителя',
        text: 'Исполнители назначаются сами, когда задача появляется в смете: свободнее по этой смете, при равенстве — дешевле. У задачи с исполнителем себестоимость и цена клиенту считаются от его личной ставки, без исполнителя — от плановой ставки специализации. Смена исполнителя пересчитывает цену',
        example:
          'Плановая ставка дизайнера 1 200 ₽/ч, у Морозова — 1 500 ₽/ч: с Морозовым задача дороже и для клиента',
      },
      coefficients: {
        text: 'Коэффициенты из справочника: срочность, сложность, скидка. Применяются ко всей смете, цену пересчитывает движок',
        example: '«Срочно» ×1,3: все пакеты дороже на 30 %',
      },
      hourly: {
        title: 'Клиентские ставки',
        text: 'Ставка специализации в час для клиента: себестоимость, накладные, наценка и налог — тем же движком, что цена. Коэффициенты сметы учитываются',
      },
    },
    gantt: {
      label: 'Гант сметы',
      package: 'Пакет для сроков',
      noTerm: 'Срок не посчитать — в пакете нет работ',
      term: 'Срок: {weeks}',
      week: 'Неделя {number}',
      weekdays: 'Пн,Вт,Ср,Чт,Пт',
      bar: 'Задача «{title}»: дни {from}–{to}',
      barHint:
        'Тяните полосу — сдвиг, правый край — длительность, точку — к другой полосе для связи «после». Стрелки ← → — сдвиг на день, с Shift — на неделю, Enter — план задачи',
      resize: 'Длительность задачи «{title}»',
      linkFrom: 'Связь «после» от задачи «{title}»: перетащите на другую полосу',
      overlap: '{name} в эти дни занят другой задачей',
      notInPackage: 'Не в пакете',
      stageBar: 'Этап «{title}»: дни {from}–{to}',
      link: '«{task}» после «{after}»',
      linkSelf: 'Задачу нельзя связать саму с собой',
      linkRemoved: 'Связь снята: «{task}» после «{after}»',
      linkAdded: 'Связь: «{task}» после «{after}»',
    },
    planDialog: {
      title: 'План задачи',
      lead: '«{title}»: исполнитель, сроки и связи',
      assignee: 'Исполнитель',
      assigneeHint: 'Цена задачи считается от его личной ставки',
      lag: 'Сдвиг после предшествующих',
      lagHint: 'Рабочих дней после конца самой поздней предшествующей задачи',
      duration: 'Длительность',
      durationHint: 'Пусто — из часов: {days}',
      fromHours: 'Из часов',
      daysUnit: 'раб. дн.',
      after: 'После задач',
      afterEmpty: 'Предшествующих нет — задача начинается с начала проекта (плюс сдвиг)',
      addAfter: 'Добавить предшествующую задачу',
      addAfterPlaceholder: 'Выберите задачу',
      removeAfter: 'Убрать связь с «{title}»',
      done: 'Готово',
    },
    fixedPrice: {
      title: 'Готовая цена',
      lead: 'Работа «{title}» продаётся по фиксированной цене; часы остаются оценкой себестоимости',
      label: 'Цена клиенту',
      hint: 'Без коэффициентов сметы — их движок применит сам. Часы работы нужны для себестоимости и срока',
    },
    catalog: {
      open: 'Из каталога',
      title: 'Добавить услугу из каталога',
      lead: 'Услуга станет этапом сметы со своими работами и часами. Это копия: правка каталога смету не меняет',
      search: 'Найти услугу',
      empty: 'В каталоге пока нет услуг.',
      toCatalog: 'Открыть каталог',
      nothing: 'Ничего не нашли — измените запрос',
      added: 'Услуга «{name}» добавлена в смету',
    },
    request: {
      title: 'Оценить этап «{stage}»',
      lead: 'Сотрудник получит уведомление и увидит только задачи и часы этого этапа — без денег. Ответ вернётся в смету',
      pick: 'Кого попросить',
      placeholder: 'Выберите сотрудника',
      nobody: 'Некого просить: все уже оценивают этот этап',
      sent: 'Попросили оценить: {name}',
    },
    review: {
      submit: 'На проверку',
      approve: 'Утвердить',
      return: 'Вернуть…',
      returnTitle: 'Вернуть с замечаниями',
      returnLead: 'Автор увидит замечания и получит уведомление; смета вернётся в черновик',
      noteLabel: 'Что поправить',
      notePlaceholder: 'Например: добавьте тестирование в этап «Вёрстка»',
      submitted: 'Смета отправлена на проверку',
      approved: 'Смета утверждена',
      returned: 'Смета возвращена с замечаниями',
      waiting: 'Отправил {name} · {at}',
      approvedBy: 'Утвердил {name} · {at}',
      remarks: 'Замечания: {name}',
      openRequests: 'Открытых запросов «Оценить этап»: {count} — оценка может измениться',
    },
    list: {
      title: 'Сметы',
      filter: 'Какие сметы показать',
      filters: { review: 'На проверке', mine: 'Мои', all: 'Все' },
      hint: 'Сметы, которые вам видны. «На проверке» — очередь админа: утвердить или вернуть с замечаниями',
      hintExample: 'Менеджер отправил смету — она появилась здесь, админ открыл её и утвердил',
      submitted: 'Отправил {name} · {at}',
      updated: 'Изменена {at}',
      empty: {
        review: {
          title: 'На проверке ничего нет',
          text: 'Когда менеджер отправит смету на проверку, она появится здесь',
        },
        mine: {
          title: 'У ваших сделок нет смет',
          text: 'Откройте сделку и заведите смету — она появится здесь',
        },
        all: { title: 'Смет пока нет', text: 'Смета заводится в карточке сделки' },
      },
    },
    requests: {
      title: 'Оценить этап',
      hint: 'Менеджер просит вас оценить часы своего этапа. Вы видите только задачи и часы этапа — без цен',
      hintExample: 'Менеджер попросил оценить «Вёрстку»: вы поправили часы и нажали «Готово»',
      emptyTitle: 'Запросов нет',
      emptyText: 'Когда менеджер попросит оценить этап, он появится здесь и придёт уведомление',
      from: 'Сделка «{deal}» · просит {name}',
      open: 'Ждёт оценки',
      done: 'Сдано',
      back: 'К запросам',
      goneTitle: 'Запрос не найден',
      goneText: 'Возможно, смету очистили или запрос предназначен другому сотруднику',
      onlyHours: 'Вы видите только задачи и часы этапа',
      onlyHoursTitle: 'Только часы',
      onlyHoursText:
        'Цены, ставки и маржа вам не показываются. Можно менять часы, добавлять и убирать работы этапа, написать комментарий и нажать «Готово»',
      onlyHoursExample: 'Вёрстка: 12 ч → вы поставили 16 ч и написали «Нужна адаптация под планшет»',
      doneAt: 'Оценка сдана {at}',
      tasks: 'Работы этапа',
      noTasks: 'В этапе пока нет работ — добавьте первую ниже',
      total: 'Итого',
      newTitle: 'Новая работа этапа',
      newSpecialization: 'Специализация новой работы',
      newHours: 'Часы новой работы',
      comment: 'Комментарий менеджеру',
      commentPlaceholder: 'Что учли, чего не хватает, о чём спросить',
      complete: 'Готово',
      sent: 'Оценка отправлена менеджеру',
    },
    settings: {
      title: 'Смета и КП',
      review: {
        title: 'Проверка админом',
        lead: 'Нужна ли проверка сметы перед отправкой КП',
        label: 'Проверка админом обязательна',
        on: 'Смета уходит в КП только после утверждения админом',
        off: 'Проверка по желанию: КП можно отправить и без неё',
      },
      price: {
        title: 'Цена',
        lead: 'Верхняя граница шкалы цены над оптимумом',
        ceiling: 'Потолок над оптимумом',
      },
      schedule: {
        title: 'Сроки',
        lead: 'Сколько часов рабочего дня уходит на работу — остальное созвоны и рутина',
        day: 'Продуктивный день',
      },
      history: 'История настроек',
    },
    today: {
      all: 'Показать все',
      review: {
        title: 'Сметы на проверке',
        hint: 'Сметы, которые менеджеры отправили на проверку: откройте, поправьте при необходимости и утвердите или верните с замечаниями',
        example: 'Менеджер отправил смету сайта — она здесь, пока вы её не утвердите',
      },
      requests: {
        title: 'Оценить этап',
        hint: 'Менеджеры просят вас оценить часы своего этапа. Вы видите только задачи и часы — без цен; «Готово» возвращает оценку в смету',
        example: 'Просят оценить «Вёрстку»: поправили часы, нажали «Готово» — менеджер получил уведомление',
      },
    },
    palette: {
      review: 'Сметы на проверке',
      list: 'Сметы',
      requests: 'Мои запросы на оценку этапа',
      settings: 'Настройки сметы',
      open: 'Открыть смету',
    },
    notifications: {
      reviewTitle: 'Смета на проверке: {deal}',
      reviewBody: 'Отправил {author}',
      approvedTitle: 'Смета утверждена: {deal}',
      approvedBody: 'Проверил {reviewer}',
      returnedTitle: 'Замечания к смете: {deal}',
      returnedBody: '{note}',
      stageRequestedTitle: 'Оцените этап «{stage}»',
      stageRequestedBody: 'Сделка «{deal}»: {author} просит оценить часы',
      stageEstimatedTitle: 'Этап «{stage}» оценён',
      stageEstimatedBody: '{assignee} оценил этап сделки «{deal}»',
    },
  },
  proposals: {
    studioFallback: 'Студия',
    title: 'КП',
    saveFailed: 'Не удалось сохранить КП — повторите',
    draftLabel: 'Черновик',
    openEstimate: 'Открыть смету',
    problemsLead: 'КП пока не собрать — исправьте то, что подсказано ниже, и оно появится справа',
    pdfRange: 'от {from} до {to}',
    statuses: {
      draft: 'Не отправлено',
      sent: 'Отправлено',
      viewed: 'Клиент смотрел',
      selected: 'Клиент выбрал пакет',
      declined: 'Клиент отказался',
      expired: 'Истекло',
    },
    empty: {
      title: 'Сначала смета',
      text: 'КП собирается из утверждённой сметы: этапы, работы и цены берутся из неё. Заведите смету — и здесь появятся тексты для клиента',
      toEstimate: 'Перейти к смете',
      leadTitle: 'КП — у сделки',
      leadText: 'Лид сначала переводят в сделку — тогда можно завести смету и собрать КП',
    },
    block: {
      title: 'КП',
      lead: 'КП собирается у сделки: сначала переведите лид в сделку',
      noEstimate: 'Сначала смета — КП собирается из неё',
      notSent: 'Ещё не отправляли клиенту',
      open: 'Открыть КП',
      validUntil: 'Действует до {date}',
    },
    tabs: {
      texts: 'Тексты',
      composition: 'Состав',
      versions: 'Версии',
      versionsCount: 'Версии · {count}',
      history: 'История',
    },
    hints: {
      page: {
        title: 'Как собирается КП',
        text: 'КП строится из сметы: этапы, пакеты, цены и сроки берутся оттуда. Здесь вы пишете то, что прочтёт клиент, добавляете поддержку, график оплат и кейсы. Часов, ставок и внутренних задач клиент не увидит нигде',
        example: 'В смете «Дизайн — 12 ч», в КП — «Дизайн: макеты ключевых страниц», срок «15 рабочих дней»',
      },
      preview: {
        title: 'Что увидит клиент',
        text: 'Сводка и PDF строятся из одних данных. Отправленная версия замораживается: правка после отправки — новая версия, старая помечается «Заменена»',
      },
      validity: {
        title: 'Срок действия КП',
        text: 'Сколько дней клиент может выбрать пакет по этим ценам. В «Действует до» для конкретного КП можно поставить свою дату',
      },
      range: {
        title: '«От–до» для почасовых',
        text: 'У почасовых сделок клиент видит объём и итог «от–до»: часы сметы, умноженные на эти коэффициенты. Ставки в КП не пишутся',
        example: '100 часов при ×0,8…×1,2 — «от 80 до 120 часов»',
      },
      supportRate: {
        title: 'Ставка поддержки',
        text: 'Цена тарифа = часы в месяц × клиентская ставка этой специализации. Не выбрана — берём среднюю плановую ставку по команде',
        example: '10 часов × 3 000 ₽/ч = 30 000 ₽ в месяц',
      },
      yearly: {
        title: 'Скидка за год',
        text: 'Если клиент платит за год вперёд, цена года — 12 месяцев со скидкой. Менеджер может поправить цену в КП',
        example: '30 000 ₽ в месяц, скидка 10 % — год стоит 324 000 ₽ вместо 360 000 ₽',
      },
      burn: {
        title: 'Сгорание часов',
        text: 'Через сколько месяцев непотраченные часы поддержки сгорают. Условие уходит в КП и дальше — в подписку',
        example: '2 месяца: часы января можно потратить до конца февраля',
      },
      followup: {
        title: 'Шаг после отправки',
        text: 'После отправки КП у сделки появляется шаг «Созвониться по КП» через столько рабочих дней — если у сделки нет другого открытого шага',
        example: 'Отправили в понедельник, 2 рабочих дня — шаг на среду',
      },
      tariffs: {
        title: 'Тарифы поддержки',
        text: 'В тарифе — только часы в месяц. Цену считает движок по ставке поддержки, год — со скидкой. Менеджер выбирает, какие тарифы предложить клиенту, и может поправить цену в конкретном КП',
        example: '5, 10 и 20 часов в месяц',
      },
      byStages: {
        title: '«По этапам»',
        text: 'Доля оплаты каждого этапа пропорциональна стоимости его работ в расчёте. Своих долей у такого шаблона нет',
        example: 'Дизайн стоит вдвое больше вёрстки — и платится вдвое больше',
      },
    },
    client: {
      understanding: 'Понимание задачи',
      understandingPlaceholder: 'Своими словами: что нужно клиенту, зачем и как мы это решим',
      understandingHintTitle: 'Понимание задачи',
      understandingHintText:
        'Первое, что читает клиент: короткий рассказ о том, как студия поняла задачу. Без жаргона, с выгодами клиента. Это текст для клиента, а не внутренняя заметка',
      understandingHintExample:
        'Вам нужен магазин, где покупатель оформляет заказ за минуту. Мы соберём каталог, корзину и оплату, подключим доставку',
      stageTitle: 'Название для клиента',
      stageResult: 'Что вы получите',
      stageResultPlaceholder: 'Например, готовые макеты всех страниц',
      stageDescription: 'Описание этапа',
      stageDescriptionPlaceholder: 'Что происходит на этом этапе и что это даст клиенту',
      stageHintTitle: 'Этап для клиента',
      stageHintText:
        'Своё название (пусто — внутреннее), результат и продающее описание. Внутренние названия работ и часы клиент не увидит — только пункты «что входит», которые вы отметили',
      stageHintExample: 'Внутри «Макет главной — 12 ч», для клиента — «Дизайн: понятный первый экран»',
      stageHidden: 'Скрыть в КП',
      stageHiddenHint:
        'Технический этап клиент в КП не видит: ни этапом, ни в графике оплат. Его часы и цена остаются в сумме пакета и расходятся по остальным этапам',
      stageHiddenExample:
        '«Управление проектом» — работа идёт весь проект, отдельным этапом клиенту она не нужна',
      stageHiddenNote: 'Этап скрыт в КП: цена в сумме пакета, в этапах и графике оплат его нет',
      includes: 'Что входит · {count}',
      includesHintTitle: 'Что входит',
      includesHintText:
        'Отмеченные работы попадают в КП пунктами «что входит» — под своей подписью. Неотмеченные клиенту не видны',
      includesShow: 'Показать клиенту: {task}',
      includesLabel: 'Подпись для клиента: {task}',
      markAll: 'Отметить все',
      clearAll: 'Снять все',
      discount: 'Скидка выгодой',
      discountLabel: 'Название скидки',
      discountPlaceholder: 'Например, как постоянному клиенту',
      discountHintTitle: 'Скидка для клиента',
      discountHintText:
        'Если цена пакета ниже оптимума, клиент видит выгоду: старая цена зачёркнута, рядом «−10 % …». Назовите причину скидки. Пусто — скидка клиенту не показывается',
      discountHintExample: '−10 % как постоянному клиенту',
    },
    ai: {
      generate: 'Сгенерировать',
      hintTitle: 'Текст от ИИ',
      hintUnderstanding:
        'ИИ напишет «Понимание задачи» по брифу сделки и смете. Текст встанет в поле — правьте как обычно; «Отменить» в уведомлении вернёт прежний',
      hintStage:
        'ИИ напишет для клиента название этапа, описание, «что получите» и пункты «что входит». «Отменить» в уведомлении вернёт прежний текст',
      generateAll: 'Заполнить всё с ИИ',
      hintAll:
        'ИИ напишет весь клиентский слой разом: «Понимание задачи», названия и описания этапов, «что получите» и пункты «что входит». Уже написанное заменится — «Отменить» в уведомлении вернёт всё как было',
      generating: 'Пишу…',
      applied: 'Текст от ИИ вставлен',
      appliedAll: 'Клиентский слой заполнен ИИ',
      failed: 'ИИ не смог написать текст. Попробуйте ещё раз или напишите вручную',
      noStageText: 'ИИ не написал текст для этого этапа. Попробуйте ещё раз или напишите вручную',
    },
    support: {
      title: 'Поддержка после запуска',
      hintTitle: 'Поддержка после запуска',
      hintText:
        'Клиент выбирает тариф в КП: часы поддержки в месяц, оплата за месяц или за год. «Не нужно» — блок скрыт. Условия подписки — часы, цены и сгорание — сохраняются в КП данными',
      hintExample: '10 часов в месяц — 30 000 ₽, за год — 324 000 ₽',
      emptyTitle: 'Тарифов поддержки пока нет',
      emptyText: 'Тарифы — только часы в месяц, цену посчитает движок. Их заводит админ в настройках КП',
      toSettings: 'К настройкам КП',
      none: 'Не нужно: блок «Поддержка» клиенту не показывается',
      offered: 'Клиенту предлагается тарифов: {count}',
      offer: 'Предложить тариф {name}',
      hours: '{count} ч в месяц',
      price: '{month} в месяц · {year} в год',
      noPrice: 'нет ставки',
      monthField: 'Цена за месяц',
      yearField: 'Цена за год',
      reset: 'Сбросить к расчёту',
      lowMargin: 'Маржа ниже минимальной — при отправке понадобится причина',
      belowFloor: 'Цена ниже себестоимости — отправить сможет админ или после его одобрения',
      notNeeded: 'Не нужно',
      burnNote: {
        one: 'Неиспользованные часы сгорают через {count} месяц',
        few: 'Неиспользованные часы сгорают через {count} месяца',
        many: 'Неиспользованные часы сгорают через {count} месяцев',
        other: 'Неиспользованные часы сгорают через {count} месяца',
      },
    },
    payment: {
      title: 'График оплат',
      hintTitle: 'График оплат',
      hintText:
        'Шаблон делит цену выбранного пакета на доли; суммы в рублях считаются до копейки и сходятся с ценой. Шаблоны заводит админ в настройках КП',
      hintExample: '30 / 40 / 30: предоплата, оплата по ходу, оплата при запуске',
      show: 'Показывать график оплат клиенту',
      on: 'Клиент увидит, когда и сколько платить по каждому пакету',
      off: 'Условия оплаты в КП не показываются',
      template: 'Шаблон',
      noSchedule: 'График не собрать: нужен шаблон и цена пакета',
    },
    cases: {
      title: 'Кейсы',
      hintTitle: 'Кейсы в КП',
      hintText:
        'Показываем опубликованные кейсы студии: по услугам сметы — подходящие сами, или выберите вручную (не больше шести). Нет опубликованных — блок скрыт',
      emptyTitle: 'Опубликованных кейсов пока нет',
      emptyText: 'Блок «Кейсы» в КП скрыт. Добавьте и опубликуйте кейс — он появится здесь',
      toCatalog: 'К кейсам',
      auto: 'По услугам сметы',
      manual: 'Выбрать вручную',
      suggested: 'подходит',
    },
    validity: {
      title: 'Срок действия',
      hintTitle: 'Действует до',
      hintText:
        'После этой даты клиент уже не выберет пакет — только попросит актуальное КП. Не выбрали — день отправки плюс срок из настроек',
      until: 'Действует до',
      reset: 'По умолчанию',
      byDefault: 'по умолчанию: {date}',
    },
    preview: {
      title: 'Предпросмотр',
      tabSummary: 'Что увидит клиент',
      tabPdf: 'PDF',
      clientPage: 'Страница клиента',
      clientPageHint:
        'Откроется страница КП так, как её увидит клиент по ссылке. Ссылка действует 30 минут, открытия по ней не считаются, ответы не отправляются',
      clientPageFailed: 'Не удалось открыть страницу клиента',
      draft: 'Черновик',
      cover: '{client} · действует до {date}',
      noUnderstanding: 'Понимание задачи пока не написано',
      recommended: 'Рекомендуем',
      term: '{days}',
      noIncludes: 'Пункты «что входит» не отмечены',
      more: 'и ещё {count}',
      stages: 'Этапы',
      noStages: 'Этапов нет',
      support: 'Поддержка после запуска',
      noCases: 'кейсов нет',
      cases: 'кейсов: {count}',
      manager: 'менеджер: {name}',
      noManager: 'менеджера нет',
      discount: '−{percent} {label}',
      discountPlain: '−{percent}',
      notReady: 'КП пока не собрать — смотрите подсказки на странице',
      pdfLead: 'Так выглядит документ, если отправить КП сейчас. Пометка «Черновик» исчезнет после отправки',
      pdfDownload: 'Скачать',
      pdfRetry: 'Повторить',
    },
    send: {
      button: 'Отправить',
      buttonNew: 'Отправить новую версию',
      title: 'Отправить КП',
      lead: 'Версия замораживается: после отправки её не изменить, правка — новая версия',
      numberOnSend: 'Номер появится при отправке',
      validUntil: 'действует до {date}',
      support: 'Поддержка: тарифов — {count}',
      how: 'Как отправить',
      viaMail: 'Письмом',
      viaLink: 'Ссылкой',
      mailNote:
        'Откроется письмо для {email} с готовым текстом, ссылкой и PDF — останется проверить и отправить',
      linkNote: 'Получите ссылку на страницу КП: пришлите её сами — в мессенджер или в письме',
      noMailbox: 'Почта не подключена или нет ящика для отправки — отправьте ссылку сами',
      noEmail: 'У контакта сделки нет почты — отправьте ссылку сами',
      sendMail: 'Отправить письмом',
      sendLink: 'Получить ссылку',
      notReady: 'КП пока не собрать — исправьте то, что подсказано на странице',
      reviewNote:
        'Смета должна быть утверждена в нынешней версии — правка состава, часов, цены, исполнителей или плана после проверки возвращает её в черновик',
      openEstimate: 'Открыть смету',
      floorNote:
        'Цена пакета или тарифа ниже себестоимости. Админ разрешает такую отправку именно для этой версии сметы',
      floorRequest: 'Запросить одобрение',
      floorWaiting: 'Запрос отправлен админу — ждём одобрения',
      floorOwn: 'Цена ниже себестоимости — вы можете отправить сами',
      floorApproved: 'Админ одобрил отправку в минус для этой версии сметы',
      requested: 'Запрос отправлен админам',
      reason: 'Причина низкой маржи',
      reasonLead: 'Маржа ниже минимальной: напишите, почему так — админ получит уведомление',
      reasonLeadMargin: 'Маржа {rate} % — ниже минимальной. Напишите причину — админ получит уведомление',
      reasonPlaceholder: 'Например, постоянный клиент, берём ради портфолио',
      reasonHintTitle: 'Почему нужна причина',
      reasonHintText:
        'КП с маржой ниже минимальной менеджер отправляет сам, но с причиной — админ видит её в уведомлении и в версии КП',
      reasonHintExample: 'Постоянный клиент: берём по сниженной цене, чтобы закрепить годовой контракт',
      openRequests: {
        one: 'Открыт запрос «Оценить этап» — часы могут измениться',
        few: 'Открыто запросов «Оценить этап»: {count} — часы могут измениться',
        many: 'Открыто запросов «Оценить этап»: {count} — часы могут измениться',
        other: 'Открыто запросов «Оценить этап»: {count} — часы могут измениться',
      },
      sentMail: '{label} отправлено — проверьте письмо и отправьте',
      doneTitle: '{label} отправлено',
      doneLead: 'Ссылка на страницу КП. Покажем её один раз — потом новую можно создать в «Версиях»',
      link: 'Ссылка на КП',
      copy: 'Скопировать',
      copied: 'Ссылка скопирована',
      copiedNote: 'Ссылка уже в буфере обмена',
      copyFailed: 'Не удалось скопировать — выделите ссылку и скопируйте вручную',
      onceNote: 'Скопируйте ссылку сейчас: в базе остаётся только её хэш',
    },
    mail: {
      subject: 'Коммерческое предложение {label} — {project}',
      greeting: 'Здравствуйте, {name}!',
      greetingPlain: 'Здравствуйте!',
      intro: 'Отправляем коммерческое предложение по проекту «{project}» — {label}.',
      open: 'Открыть предложение',
      openNote: 'На странице можно выбрать пакет, задать вопрос и скачать PDF.',
      pdf: 'PDF с предложением — во вложении.',
      valid: 'Предложение действует до {date}.',
      call: 'Если удобнее обсудить голосом — позвоните: {phone}.',
    },
    approval: {
      title: 'Запрос на КП в минус.',
      text: 'Менеджер просит разрешить отправку КП с ценой ниже себестоимости. Одобрение действует для нынешней версии сметы',
      approve: 'Одобрить',
      approved: 'Отправка в минус одобрена',
    },
    views: {
      none: 'Клиент ещё не открывал',
      some: 'Открыто {times}, последний раз — {last}',
      times: { one: '{count} раз', few: '{count} раза', many: '{count} раз', other: '{count} раза' },
      devices: { phone: 'с телефона', tablet: 'с планшета', desktop: 'с компьютера' },
    },
    decision: {
      selected: 'Выбрал пакет «{name}»',
      selectedSupport: 'Выбрал поддержку',
      declined: 'Не подходит',
      declinedBecause: 'Не подходит: {reason}',
    },
    versions: {
      emptyTitle: 'КП ещё не отправляли',
      emptyText: 'Отправьте КП — здесь появятся версии, просмотры клиента и его ответы',
      superseded: 'Заменена',
      sent: '{at} · {who} · {via}',
      pdf: 'PDF',
      validUntil: 'Действует до',
      marginReason: 'Причина низкой маржи:',
      byClient: 'выбрал клиент',
      byStaff: 'отметил {name} со слов клиента',
      decisionTariff: 'поддержка «{name}», {billing}',
      billingMonth: 'за месяц',
      billingYear: 'за год',
      questions: {
        one: '{count} вопрос',
        few: '{count} вопроса',
        many: '{count} вопросов',
        other: '{count} вопроса',
      },
      renews: {
        one: '{count} просьба об актуальном КП',
        few: '{count} просьбы об актуальном КП',
        many: '{count} просьб об актуальном КП',
        other: '{count} просьбы об актуальном КП',
      },
      link: 'Ссылка от {at} · {who}',
      revoke: 'Отозвать',
      revoked: 'Ссылка отозвана — клиент увидит «Предложение отозвано»',
      revokedBadge: 'отозвана',
      newLink: 'Новая ссылка',
      linkCopied: 'Новая ссылка скопирована',
      markSelected: 'Отметить выбор клиента',
      markDeclined: 'Не подходит',
      markTitle: 'Отметить выбор клиента',
      markLead:
        'Клиент ответил по телефону или в чате — отметьте его выбор. Это то же принятое предложение, что и выбор на странице',
      markPackage: 'Пакет',
      markTariff: 'Поддержка',
      markNoTariff: 'Не нужно',
      markTariffOption: '{name} · {month} в месяц',
      markSubmit: 'Отметить',
      marked: 'Выбор клиента отмечен',
      declineTitle: 'Клиенту не подходит',
      declineLead: 'Сделка не проигрывается — менеджеру появится шаг «Разобраться с отказом»',
      declineReason: 'Причина',
      declineNote: 'Что сказал клиент',
      declineSubmit: 'Отметить отказ',
      declinedMarked: 'Отказ отмечен',
    },
    activity: {
      title: 'Активность',
      sent: 'Отправлено {version} · {via}',
      firstViewed: 'Клиент впервые открыл {version}',
      selected: 'Клиент выбрал «{package}»',
      selectedByStaff: '{who} отметил выбор «{package}» со слов клиента',
      declined: 'Клиент: не подходит — {reason}',
      declinedByStaff: '{who} отметил: не подходит — {reason} (со слов клиента)',
      question: 'Вопрос клиента: {text}',
      renew: 'Клиент просит актуальное КП вместо {version}',
      linkCreated: 'Создана ссылка на {version}',
      linkRevoked: 'Отозвана ссылка на {version}',
    },
    palette: {
      cases: 'Кейсы',
      settings: 'Настройки КП',
      open: 'Открыть КП',
    },
    settings: {
      title: 'Смета и КП',
      hintTitle: 'Настройки сметы и КП',
      hintText:
        'Параметры сметы (проверка админом, потолок цены), параметры КП, тарифы поддержки и шаблоны графика оплат. Цвет и логотип для КП — в «Реквизитах студии»',
      history: 'История настроек',
      archive: 'В архив',
      restore: 'Вернуть из архива',
      moveUp: 'Выше',
      moveDown: 'Ниже',
      archivedBadge: 'в архиве',
      showArchived: 'Показать архивные',
      tabs: {
        estimate: 'Смета',
        proposal: 'КП',
        tariffs: 'Тарифы поддержки',
        payment: 'График оплат',
      },
      params: {
        validity: 'Срок действия КП',
        validityLead: 'Сколько дней клиент может выбрать пакет по этим ценам',
        validDays: 'Срок действия',
        hourly: 'Почасовые сделки',
        hourlyLead:
          'Клиент видит объём и итог «от–до»: часы сметы умножаются на эти коэффициенты. Ставки в КП не пишутся',
        rangeLow: 'Нижняя граница',
        rangeHigh: 'Верхняя граница',
        support: 'Поддержка и подписка',
        supportLead: 'Цена тарифа = часы в месяц × клиентская ставка поддержки; год — со скидкой',
        specialization: 'Ставка поддержки по специализации',
        averageRate: 'Средняя по команде',
        yearlyDiscount: 'Скидка за год вперёд',
        burnMonths: 'Часы сгорают через',
        automation: 'После отправки',
        automationLead: 'Что делает сделка сама и какой график оплат предлагается по умолчанию',
        followup: 'Созвониться по КП через',
        defaultTemplate: 'График оплат по умолчанию',
        about: 'О студии',
        aboutLead:
          'Короткий текст в конце КП — кто вы и чем занимаетесь. Контакты, логотип и цвет берутся из реквизитов',
        aboutLabel: 'Текст «О студии»',
        aboutPlaceholder: 'Мы — студия, которая делает сайты и сервисы для бизнеса',
      },
      tariffs: {
        title: 'Тарифы поддержки',
        lead: 'Часы в месяц — цену посчитает движок. Менеджер выбирает тарифы для КП и может поправить цену',
        rateSpecialization: 'Цена считается по клиентской ставке выбранной специализации',
        rateAverage:
          'Цена считается по средней плановой ставке команды — специализацию можно выбрать в параметрах КП',
        noRate: 'Цену не посчитать: нужны политика цены, налог и плановые ставки специализаций',
        name: 'Название тарифа',
        hours: 'Часы в месяц',
        noPrice: 'нет цены',
        emptyTitle: 'Тарифов пока нет',
        emptyText: 'Добавьте тарифы — например, на 5, 10 и 20 часов в месяц',
        addTitle: 'Новый тариф',
        newName: 'Название',
        newPlaceholder: '10 ч',
        add: 'Добавить',
        created: 'Тариф «{name}» добавлен',
        archived: 'Тариф «{name}» в архиве',
      },
      templates: {
        title: 'Шаблоны графика оплат',
        lead: 'Доли от цены пакета: когда и сколько платит клиент. Суммы в рублях — до копейки',
        name: 'Название шаблона',
        default: 'по умолчанию',
        byStages: 'По этапам',
        byStagesNote: 'Доля каждого этапа пропорциональна стоимости его работ — своих долей у шаблона нет',
        partLabel: 'Подпись',
        partShare: 'Доля',
        partWhen: 'Когда',
        partStage: 'Этап №',
        triggers: {
          signing: 'При подписании',
          stage_start: 'Со стартом этапа',
          launch: 'При запуске',
          monthly: 'Ежемесячно',
        },
        removePart: 'Убрать долю',
        addPart: 'Добавить долю',
        sum: 'Сумма долей: {sum}',
        saved: 'Шаблон «{name}» сохранён',
        emptyTitle: 'Шаблонов пока нет',
        emptyText: 'Добавьте шаблон — например, «50 / 50»',
        addTitle: 'Новый шаблон',
        newName: 'Название',
        newPlaceholder: '50 / 50',
        add: 'Добавить',
        firstPart: 'Предоплата',
        created: 'Шаблон «{name}» добавлен — доли поправьте в карточке',
        archived: 'Шаблон «{name}» в архиве',
      },
    },
    problems: {
      no_estimate: 'у сделки нет сметы',
      empty: 'в смете нет работ',
      package_price: 'не посчитана цена пакета «{package}»',
      no_support_offer: 'не выбран тариф поддержки',
      support_rate: 'не посчитать ставку поддержки',
    },
    via: {
      mail: 'письмом',
      link: 'ссылкой',
    },
    supportOnly: 'Поддержка',
    declineReasons: {
      expensive: 'Дорого',
      terms: 'Сроки не подходят',
      chose_others: 'Выбрали других',
      changed_mind: 'Передумали',
      other: 'Другое',
    },
    responseKinds: {
      selected: 'Выбор пакета',
      declined: 'Не подходит',
      question: 'Вопрос по КП',
      renew_requested: 'Просьба об актуальном КП',
    },
    notifications: {
      marginSentTitle: 'КП ушло с маржой {rate} — {deal}',
      marginSentBody: '{sender}: {reason}',
      belowFloorRequestedTitle: 'Одобрите КП в минус — {deal}',
      belowFloorRequestedBody: '{author} просит разрешения отправить КП с ценой ниже себестоимости',
      belowFloorApprovedTitle: 'КП в минус одобрено — {deal}',
      belowFloorApprovedBody: '{reviewer} разрешил отправить КП',
      packageSelectedTitle: 'Клиент выбрал пакет «{package}»',
      packageSelectedBody: '{deal} · {total}',
      packageSelectedByStaffBody: '{deal} · отметил {staff} со слов клиента',
      declinedTitle: 'Клиент: не подходит — {reason}',
      declinedByStaffBody: '{deal} · отметил {staff} со слов клиента',
      firstViewedTitle: 'Клиент смотрит КП — {deal}',
      firstViewedBody: '{label}: первое открытие',
      questionTitle: 'Вопрос по КП — {deal}',
      questionStageBody: 'Про этап «{stage}»: {text}',
      renewTitle: 'Клиент просит актуальное КП — {deal}',
      renewBody: '{label} истекло или заменено — пришлите свежую версию',
    },
    public: {
      ogTitle: 'Предложение для {client} — {studio}',
      ogDescription: '{project} · действует до {date}',
      ogFallbackTitle: 'Коммерческое предложение',
      ogFallbackDescription: 'Откройте ссылку, чтобы посмотреть предложение',
      pdfDraftName: 'КП-черновик',
    },
    pdf: {
      discount: '−{percent} {label}',
      discountPlain: '−{percent}',
      workDays: {
        one: '{count} рабочий день',
        few: '{count} рабочих дня',
        many: '{count} рабочих дней',
        other: '{count} рабочего дня',
      },
      range: 'от {from} до {to}',
      dayRange: 'Рабочие дни {from}–{to}',
      daysByPackage: '{package}: дни {days}',
      vatIncluded: 'Цены указаны с учётом НДС {rate}',
      vatNone: 'Студия не облагается НДС — цены указаны без НДС',
      supportIntro:
        'После запуска мы остаёмся рядом: часы поддержки в месяц — на правки, доработки и развитие проекта',
      supportBurn: {
        one: 'Неиспользованные часы сгорают через {count} месяц. Оплата вперёд — за месяц или за год',
        few: 'Неиспользованные часы сгорают через {count} месяца. Оплата вперёд — за месяц или за год',
        many: 'Неиспользованные часы сгорают через {count} месяцев. Оплата вперёд — за месяц или за год',
        other: 'Неиспользованные часы сгорают через {count} месяца. Оплата вперёд — за месяц или за год',
      },
      supportNoBurn: 'Оплата вперёд — за месяц или за год',
      supportHours: '{count} ч в месяц',
      supportSaving: 'Экономия {amount} в год',
      paymentTemplate: 'График оплаты: «{name}»',
      whenSigning: 'при подписании договора',
      whenStage: 'со стартом этапа «{stage}»',
      whenStagePlain: 'со стартом этапа',
      whenLaunch: 'при запуске',
      whenMonthly: 'ежемесячно',
    },
  },
  calendar: {
    title: 'Производственный календарь',
    lead: 'Праздники, переносы выходных и сокращённые дни по постановлениям Правительства РФ. По ним считаются сроки, ёмкость команды и норма часов',
    hint: 'Выходные — суббота и воскресенье. Праздник, выпавший на выходной, переносится; рабочий день перед праздником на час короче. Администратор может поправить любой день под студию',
    hintExample: '30 апреля 2026 — предпраздничный день: 7 часов вместо 8',
    year: 'Год',
    prevYear: 'Предыдущий год',
    nextYear: 'Следующий год',
    noOfficial:
      'Официального календаря на {year} год в системе нет: выходные — только суббота и воскресенье. Переносы Правительство утверждает осенью предыдущего года',
    workingDays: 'Рабочих дней',
    daysOff: 'Выходных и праздников',
    norm: 'Норма часов',
    normHint: 'При 40-часовой неделе: 8 часов в рабочий день, 7 — в предпраздничный',
    legend: 'Обозначения',
    legendHoliday: 'Праздник или перенос',
    legendWeekend: 'Выходной',
    legendShort: 'На час короче',
    legendWorkday: 'Рабочий выходной',
    legendChanged: 'Изменено студией',
    legendToday: 'Сегодня',
    editHint: 'Нажмите на день, чтобы сделать его рабочим, сокращённым или выходным',
    exceptionsTitle: 'Праздники и переносы',
    exceptionsLead: 'Дни, которые отличаются от обычной недели',
    exceptionsEmpty: 'В этом году все недели обычные',
    changed: 'изменено студией',
    official: 'По постановлению — {type}',
    normsTitle: 'Норма рабочего времени',
    normsLead: 'По месяцам при 40-часовой неделе — из неё считаются ёмкость команды и загрузка',
    columnMonth: 'Месяц',
    columnWorking: 'Рабочих',
    columnOff: 'Выходных',
    columnHours: 'Часов',
    total: 'За год',
    historyTitle: 'История изменений',
    historyLead: 'Кто и когда менял дни этого года',
    types: { work: 'Рабочий', short: 'Сокращённый', off: 'Выходной' },
    typesLower: { work: 'рабочий день', short: 'на час короче', off: 'выходной' },
    typeHints: {
      work: '8 часов — обычный рабочий день',
      short: '7 часов — на час короче, как перед праздником',
      off: 'Не входит в сроки и норму часов',
    },
    now: 'Сейчас — {type}',
    dayType: 'Какой это день',
    note: 'Подпись',
    notePlaceholder: 'Например, «День студии»',
    noteHint: 'Видна всем в списке праздников',
    noteWeekendHint: 'Без подписи — обычный выходной',
    save: 'Сохранить',
    toOfficial: 'Как в постановлении',
    toDefault: 'Как в обычную неделю',
    saved: '{date} — {type}',
  },
  messenger: {
    clientBadge: 'клиент',
    title: 'Сообщения',
    studioTitle: 'Студия',
    savedTitle: 'Избранное',
    today: 'Сегодня',
    yesterday: 'вчера',
    seenJustNow: 'был(а) только что',
    seenToday: 'был(а) в {time}',
    seenYesterday: 'был(а) вчера в {time}',
    seenOn: 'был(а) {date}',
    yesterdayTitle: 'Вчера',
    system: 'Система',
    unknownPerson: 'Неизвестный сотрудник',
    untitled: 'Без названия',
    pushInTopic: '«{chat}», тема «{topic}»',
    pushReply: '{author} ответил(а) в {chat}',
    pushThread: '{author} в треде {chat}',
    pushIn: '{author} в {chat}',
    callE2ee: 'Сквозной звонок',
    callE2eeHint:
      'Сквозной звонок: звук и видео шифруются на устройствах, без записи. Нужно подтверждённое устройство у каждого участника',
    callE2eeOn: 'Сквозное шифрование включено — нажмите, чтобы выключить',
    callE2eeBadge: 'Сквозной',
    callE2eeBadgeHint:
      'Сквозной звонок: звук, видео и экран шифруются на устройствах участников — сервер их не слышит и не видит, запись недоступна',
    pushHidden: 'Новое сообщение',
    secret: {
      toggle: 'Секретный чат',
      toggleLead: 'Сквозное шифрование: текст и файлы видят только участники',
      hint: {
        title: 'Секретный чат',
        text: 'Сообщения шифруются на устройствах участников — сервер хранит только шифровку. Поэтому в секретном чате нет поиска на сервере, ИИ, отложенных сообщений и текста в уведомлениях. Новый участник видит переписку с момента входа',
        example: 'Обсудить зарплату или пароль от клиента',
      },
      badge: 'Секретный чат',
      headerHint: 'Секретный чат: сквозное шифрование',
      preview: 'Зашифрованное сообщение',
      opening: 'Расшифровывается…',
      undecryptable: 'Не удалось расшифровать: ключа этого сообщения нет на устройстве',
      fileTooLarge: 'В секретный чат — файлы до 200 МБ',
      fileKeyLost: 'Ключ файла потерян — прикрепите файл заново',
      fileFailed: 'Не удалось расшифровать файл',
      forwardFiles: 'В секретный чат пересылается только текст — файлы прикрепите заново',
      gateSetup: 'Создайте ключ шифрования',
      gatePending: 'Подтвердите это устройство',
      gateUnavailable: 'Этот браузер не умеет хранить ключи',
      gateLead:
        'Секретный чат открывается только на подтверждённом устройстве: ключи сообщений хранятся на нём, а не на сервере',
      gateAction: 'Открыть «Устройства»',
    },
    digestUnread: {
      one: '{count} непрочитанное',
      few: '{count} непрочитанных',
      many: '{count} непрочитанных',
      other: '{count} непрочитанных',
    },
    digestChats: {
      one: '{count} чате',
      few: '{count} чатах',
      many: '{count} чатах',
      other: '{count} чатах',
    },
    digestTitle: '{unread} в {chats}',
    digestChatLine: '{chat}: {count}',
    digestMoreChats: {
      one: 'и ещё {count} чат',
      few: 'и ещё {count} чата',
      many: 'и ещё {count} чатов',
      other: 'и ещё {count} чата',
    },
    scheduledFailedTitle: 'Отложенное сообщение не отправлено',
    scheduledFailedBody: '«{text}» — {reason}',
    reminderTitle: 'Напоминание',
    reminderBody: '{author}: {text}',
    reminderBodyIn: '{author} в {chat}: {text}',
    reminderDeleted: 'Сообщение, о котором вы просили напомнить, удалено',
    reminderHidden: 'Сообщение, о котором вы просили напомнить',
    sendLater: 'Отправить позже',
    sendLaterHint:
      'Сообщение уйдёт в назначенное время от вашего имени, даже если платформа будет закрыта. До отправки его можно изменить или отменить',
    laterHour: 'Через час',
    laterTomorrow: 'Завтра утром',
    laterMonday: 'В понедельник',
    laterPick: 'Выбрать дату и время…',
    laterAt: 'Когда',
    scheduleConfirm: 'Отложить',
    scheduleChangeConfirm: 'Перенести',
    scheduleInPast: 'Это время уже прошло — выберите момент в будущем',
    scheduleOffline: 'Без связи отложить сообщение не получится — подключитесь к сети и попробуйте снова',
    scheduleFailed: 'Не удалось отложить сообщение — попробуйте ещё раз',
    scheduledToast: 'Сообщение уйдёт {time}',
    scheduledTitle: 'Отложенные сообщения',
    scheduledCount: 'Отложенные: {count}',
    scheduledLoadFailed: 'Отложенные не загрузились — повторить',
    scheduledAt: 'Уйдёт {time}',
    scheduledFailedAt: 'Не ушло · было назначено на {time}',
    scheduledFailedUnknown: 'Причина неизвестна — попробуйте отправить сейчас',
    scheduledFiles: {
      one: '{count} вложение',
      few: '{count} вложения',
      many: '{count} вложений',
      other: '{count} вложения',
    },
    scheduledEditing: 'Изменение отложенного сообщения',
    scheduledEditText: 'Изменить текст',
    scheduledEditTime: 'Изменить время',
    scheduledEditCancel: 'Не менять',
    scheduledSendNow: 'Отправить сейчас',
    scheduledSentNow: 'Сообщение отправлено',
    scheduledCancel: 'Отменить отправку',
    scheduledCanceled: 'Отправка отменена',
    scheduledTextSaved: 'Текст сохранён',
    remindTitle: 'Напомнить о сообщении',
    remindHint: 'В назначенное время придёт уведомление со ссылкой на это сообщение',
    remindConfirm: 'Напомнить',
    remindSet: 'Напомню {time}',
    remindFailed: 'Не удалось поставить напоминание — попробуйте ещё раз',
    remindOffline: 'Без связи напоминание не поставить — подключитесь к сети и попробуйте снова',
    remindMark: 'Напомню {time}',
    remindCancel: 'Снять напоминание',
    remindCancelled: 'Напоминание снято',
    searchMessages: 'Поиск по сообщениям',
    searchHint:
      'Ищет слова в сообщениях чатов, где вы участник: по началу слова и любой его форме, без различия «е» и «ё». Текст хранится зашифрованным, поэтому слова с опечатками не находятся. Чужие личные переписки недоступны никому, даже администратору; удалённое не находится',
    searchClearFilter: 'Снять фильтр',
    searchWhere: 'Где',
    searchWhereIn: 'В: {chat}',
    searchWholeChat: 'Весь чат',
    searchPickChat: 'Найти чат',
    searchAuthor: 'От кого',
    searchAuthorBy: 'От: {name}',
    searchPickAuthor: 'Найти сотрудника',
    searchPeriod: 'Когда',
    periodDay: 'За сутки',
    periodWeek: 'За неделю',
    periodMonth: 'За месяц',
    periodYear: 'За год',
    periodBetween: '{from} — {to}',
    periodSince: 'С {date}',
    periodUntil: 'До {date}',
    periodFrom: 'С',
    periodTo: 'По',
    periodApply: 'Применить',
    searchHas: 'Вложения',
    hasFile: 'Файлы',
    hasImage: 'Фото',
    hasVideo: 'Видео',
    hasVoice: 'Голосовые',
    hasLink: 'Ссылки',
    searchReset: 'Сбросить фильтры',
    searchPromptTitle: 'Найдите сообщение',
    searchPromptText:
      'Введите слова (от двух букв) или выберите чат или автора. Ищем только в чатах, где вы участник',
    searchFailed: 'Не удалось выполнить поиск — попробуйте ещё раз',
    searchNoneTitle: 'Ничего не найдено',
    searchNoneText:
      'Проверьте написание или снимите часть фильтров. Поиск идёт только по вашим чатам и не находит удалённое',
    searchNoneShort: 'Нет',
    searchMore: 'Показать ещё',
    searchInChat: 'Поиск в этом чате',
    searchOlder: 'Раньше (Enter)',
    searchNewer: 'Позже (Shift+Enter)',
    searchClose: 'Закрыть поиск (Esc)',
    searchPosition: '{index} из {total}',
    searchPositionMore: '{index} из {total}+',
    searchMinChars: 'Введите хотя бы две буквы',
    searchInMessages: 'Искать «{query}» в сообщениях',
    commandFind: 'Искать в сообщениях «{query}»',
    commandWrite: 'Написать {name}',
    paletteDirect: 'Личный чат',
    paletteGroup: 'Группа',
    paletteEntity: 'Чат объекта',
    callMissedFrom: 'Пропущенный звонок от {name}',
    callOutgoingDuration: 'Исходящий звонок · {duration}',
    callIncomingDuration: 'Входящий звонок · {duration}',
    callDurHours: '{hours} ч',
    callDurMinutes: '{minutes} мин',
    callDurSeconds: '{seconds} с',
    callAudio: 'Аудиозвонок',
    callVideo: 'Видеозвонок',
    callJoin: 'Присоединиться',
    callConnecting: 'Подключение к звонку…',
    callConnected: 'Звонок подключён',
    callYou: 'Вы',
    callParticipant: 'Участник',
    callSettings: 'Устройства и качество',
    callMediaError:
      'Не удалось включить устройство. Проверьте разрешения браузера и выберите доступный микрофон или камеру.',
    callRetry: 'Повторить подключение',
    callLeave: 'Выйти из звонка',
    callMicrophone: 'Микрофон',
    callCamera: 'Камера',
    callSpeakers: 'Динамики',
    callDevice: 'Устройство {count}',
    callQuality: 'Качество видео',
    callScreenQuality: 'Качество демонстрации экрана',
    callQualityAuto: 'Авто',
    callQualityLow: 'Низкое',
    callQualityStandard: 'Стандартное',
    callQualityHigh: 'Высокое',
    callReconnecting: 'Восстанавливаем соединение…',
    callConnectionFailed: 'Не удалось подключиться к звонку',
    callInProgress: 'Идёт звонок · {count}',
    callEnableMic: 'Включить микрофон',
    callDisableMic: 'Выключить микрофон',
    callEnableCamera: 'Включить камеру',
    callDisableCamera: 'Выключить камеру',
    callShareScreen: 'Демонстрация экрана',
    callStopSharing: 'Остановить демонстрацию',
    callEnd: 'Завершить звонок',
    callFullscreen: 'Развернуть звонок',
    callWindowed: 'Свернуть звонок',
    callRinging: 'Звоним…',
    callWaiting: 'Ожидаем ответа…',
    callIncoming: 'Входящий звонок',
    callAccept: 'Ответить',
    callDeclineAction: 'Отклонить',
    callDeclined: 'Звонок отклонён',
    callCancelled: 'Звонок отменён',
    callNoAnswer: 'Нет ответа',
    callNoAnswerNotice: 'Никто не ответил — звонок завершён',
    callAlreadyEnded: 'Звонок уже завершён',
    callMovedToOtherDevice: 'Звонок продолжается на другом устройстве',
    callBusyHint: 'Вы уже в звонке — сначала завершите его',
    callDeclinedByPeer: 'Звонок отклонён',
    callDeclinedByMe: 'Вы отклонили звонок',
    callJoinOngoing: 'Присоединиться к звонку',
    callParticipants: 'В звонке · {count}',
    callRecord: 'Записать звонок',
    callStopRecord: 'Остановить запись',
    callRecording: 'Идёт запись · {duration}',
    callRecordingName: 'Запись звонка',
    callRecordingFailed: 'Не удалось сохранить запись звонка',
    callRecordingSavedLocally: 'Запись не отправилась в чат — файл сохранён на компьютер',
    callRecordingSent: 'Запись звонка добавлена в чат',
    callRecordingUnsupported: 'Запись звонка недоступна в этом браузере',
    callRecordingBy: '{name} записывает звонок',
    callPrejoinTitle: 'Перед звонком',
    callPrejoinJoin: 'Войти в звонок',
    callCameraPreview: 'Предпросмотр камеры',
    callAudioBlocked: 'Нажмите, чтобы включить звук',
    callQualityPoor: 'Плохое соединение',
    callGroup: 'Групповой звонок',
    callScreenShareBy: 'Экран: {name}',
    callYouSharing: 'Вы показываете экран',
    callHideSelf: 'Скрыть своё видео',
    callShowSelf: 'Показать своё видео',
    callLeft: 'Вы вышли из звонка',
    callReconnected: 'Соединение восстановлено',
    callDeviceDefault: 'Системное устройство',
    callDeviceSwitchFailed: 'Не удалось переключить устройство — проверьте, что оно подключено',
    callRecordBadge: 'ЗАПИСЬ',
    callRecorderUnknown: 'Участник',
    callCallerUnknown: 'Сотрудник',
    callAudioOnly: 'Только звук',
    callConnectShort: 'Подключение…',
    callReconnectingShort: 'Переподключение…',
    callNoConnection: 'Нет соединения',
    callPin: 'Закрепить',
    callUnpin: 'Открепить',
    callCollapse: 'Свернуть в полоску',
    callRestore: 'Развернуть окно',
    callFullscreenTrue: 'На весь экран',
    callExitFullscreen: 'Выйти из полноэкранного режима',
    callYouBadge: 'Вы',
    callSettingsSound: 'Звук',
    callSettingsMic: 'Микрофон',
    callSettingsDevices: 'Устройства',
    callSettingsQuality: 'Качество',
    callVolume: 'Громкость собеседников',
    callMicVolume: 'Громкость микрофона',
    callVolumeOf: 'Громкость: {name}',
    callMuteForMe: 'Заглушить для себя',
    callUnmuteForMe: 'Включить звук',
    callMicLevel: 'Уровень',
    callMicTooQuiet: 'Микрофон не передаёт звук — проверьте, что выбран нужный и он не выключен в системе',
    callMicTooLoud: 'Звук перегружен: отодвиньте микрофон или скажите тише',
    callVoiceMode: 'Режим микрофона',
    callVoiceModeHint:
      'Стандарт — подходит всем, особенно без наушников. Шумная комната — нейросетевой шумодав для офиса, клавиатуры и кафе. Студия — для хорошего микрофона и наушников: подкаст, музыка, звук демонстрации.',
    callVoiceStandard: 'Стандарт',
    callVoiceStrong: 'Шумная комната',
    callVoiceStudio: 'Студия / музыка',
    callVoiceStudioHint: 'Только в наушниках — иначе будет эхо',
    callVoiceStrongUnavailable: 'Браузер не умеет нейросетевой шумодав: работает обычное шумоподавление',
    callPushToTalk: 'Push-to-talk',
    callPushToTalkHint: 'Микрофон включается, пока удерживаешь пробел',
    callReaction: 'Реакция',
    callQualityHint:
      'Качество твоей камеры: так тебя видят собеседники. Выше разрешение — чётче картинка и больше трафика.',
    callScreenQualityHint:
      'Качество твоей трансляции экрана: так её видят зрители. По умолчанию — высокое; «Максимум» отдаёт зрителям родное разрешение твоего экрана.',
    callScreenMode: 'Характер демонстрации',
    callScreenModeHint:
      'Текст и код — при плохой сети падает частота кадров, буквы остаются чёткими. Видео и движение — падает разрешение, движение остаётся плавным.',
    callScreenText: 'Текст и код',
    callScreenMotion: 'Видео и движение',
    callScreenScaleHint: 'Показывайте окно или экран в масштабе 100 % — так текст чётче у зрителей',
    callShareScreenHint: 'Показать экран. Для лучшей чёткости — окно или экран в масштабе 100 %',
    callScreenMaxQuality: 'Максимальное качество демонстрации',
    callStats: 'Статистика звонка',
    callStatCodec: 'Кодек',
    callStatSize: 'Разрешение',
    callStatFps: 'Кадры',
    callStatFpsValue: '{value} к/с',
    callStatBitrate: 'Битрейт',
    callStatLoss: 'Потеряно пакетов',
    callStatLatency: 'Задержка',
    callStatLatencyValue: '{rtt} мс, дрожание {jitter} мс',
    callStatLimit: 'Ограничено: {reason}',
    callStatNone: '—',
    callStatMbps: '{value} Мбит/с',
    callStatKbps: '{value} кбит/с',
    callQualityLoweredCpu: 'Качество камеры снижено: компьютер перегружен',
    callQualityLoweredNetwork: 'Качество камеры снижено: слабая сеть',
    callQualityRestore: 'Вернуть',
    callCameraLow: 'Низкое · 360p',
    callCameraStandard: 'Стандартное · 720p',
    callCameraHigh: 'Высокое · 1080p',
    callScreenLow: 'Низкое · 720p, 10 к/с',
    callScreenStandard: 'Стандартное · 1080p, 15 к/с',
    callScreenHigh: 'Высокое · 1080p, 30 к/с',
    callScreenMax: 'Максимум · родное разрешение',
    callConnectionExcellent: 'Отличное соединение',
    callConnectionGood: 'Хорошее соединение',
    callConnectionPoor: 'Плохое соединение',
    callConnectionLost: 'Соединение потеряно',
    callConnectionUnknown: 'Соединение устанавливается',
    callScreenFullscreen: 'Развернуть демонстрацию на весь экран',
    callRecordingStarted: 'Идёт запись звонка: {name}',
    callRecordingBusy: 'Запись уже идёт: {name}',
    callPeerBusy: 'Абонент занят',
    callDeclinedNotice: 'Звонок отклонён',
    callMissedWhileBusy: 'Пропущенный от {name} — вы были в другом звонке',
    callBusyHistoryMine: 'Вы были заняты — пропущенный от {name}',
    callBusyHistoryPeer: 'Абонент был занят',
    callDeclinedByAll: 'Все отклонили звонок',
    callOtherDevice: 'Другое ваше устройство',
    callEndForAll: 'Завершить для всех',
    callAnswerAudioOnly: 'Ответить без видео',
    callChooseDevice: 'Выбрать устройство',
    callFlipCamera: 'Сменить камеру',
    callMore: 'Ещё',
    callPeople: 'Участники',
    callMicOff: 'Микрофон выключен',
    callSharingScreen: 'Показывает экран',
    callTileActions: 'Действия: {name}',
    callWindowLabel: 'Звонок: {title}',
    callVoiceStandardHint: 'Подходит всем, особенно без наушников',
    callVoiceStrongHint: 'Убирает клавиатуру, гул офиса и кафе',
    callPushToTalkActive: 'Говорите — микрофон включён',
    callPushToTalkIdle: 'Удерживайте пробел, чтобы говорить',
    callScreenMaxQualityOn: 'Демонстрация — в максимальном качестве',
    callConnectionFailedHint: 'Проверьте интернет и попробуйте ещё раз',
    callRecordingKept:
      'Запись не отправилась — она сохранена в браузере, отправьте её позже из карточки внизу слева',
    callRecordingLimit: 'Запись остановлена: файл дошёл до предела 2 ГБ. Начните новую, чтобы продолжить',
    callRecordingMemoryOnly:
      'Браузер не даёт сохранять запись на диск: не закрывайте вкладку до конца записи',
    callRecordingTrayTitle: 'Запись звонка не отправлена',
    callRecordingSendToChat: 'Отправить в чат',
    callRecordingDownload: 'Скачать',
    callRecordingDelete: 'Удалить',
    callRecordingDeleteConfirm: 'Удалить запись насовсем?',
    callRecordingLater: 'Позже',
    callRecordingSending: 'Отправляем запись · {percent}%',
    callRecordingCancelSend: 'Отменить отправку',
    callRecordingNoChat: 'Чат этой записи недоступен — скачайте её',
    panelBack: 'Назад к чату',
    keysTitle: 'Горячие клавиши',
    keysHint: 'Работают на компьютере; в чужих полях ввода и пока открыто окно — нет',
    keysNextChat: 'Соседний чат в списке',
    keysEditLast: 'Изменить своё последнее сообщение (в пустом поле)',
    keysEscape: 'Закрыть поиск, панель, правку или ответ — по очереди',
    keysSearchChat: 'Поиск в этом чате',
    keysPalette: 'Поиск по платформе и команды',
    keysSend: 'Отправить; с Shift — новая строка',
    eventGroupCreated: '{by} создаёт группу «{title}»',
    eventGroupRenamed: '{by} меняет название: «{from}» → «{to}»',
    eventMemberAdded: '{by} добавляет в группу: {user}',
    eventMemberRemoved: '{by} исключает из группы: {user}',
    eventMemberLeft: '{user} покидает группу',
    eventMemberLeftOwner: '{user} покидает группу. Теперь владелец — {owner}',
    eventMemberJoined: 'Новый участник: {user}',
    eventUnknown: 'Событие в чате',
    chats: 'Чаты',
    searchChats: 'Поиск по чатам',
    searchNothing: 'Таких чатов нет',
    newChat: 'Новый чат',
    listFailed: 'Список чатов не загрузился — проверьте связь',
    emptyListTitle: 'Здесь будет вся переписка команды',
    emptyListText:
      'Напишите коллеге или соберите группу — сообщения приходят мгновенно, на компьютере и телефоне',
    typing: 'печатает…',
    typingName: '{name} печатает…',
    typingMany: 'печатают несколько человек…',
    you: 'Вы',
    youSuffix: '(вы)',
    notSent: 'Не отправлено',
    notSentBecause: 'Не отправлено: {reason}',
    discard: 'Убрать',
    noMessages: 'Сообщений пока нет',
    savedHint: 'Заметки и пересланное себе',
    deletedMessage: 'Сообщение удалено',
    muted: 'Без звука',
    pinned: 'Закреплён',
    stateSending: 'Отправляется',
    stateFailed: 'Не отправлено',
    stateSent: 'Доставлено',
    stateRead: 'Прочитано',
    edited: 'изменено',
    newMessages: 'Новые сообщения',
    toBottom: 'К последним сообщениям',
    loadFailed: 'Сообщения не загрузились — проверьте связь',
    sendFailed: 'Не удалось отправить — проверьте связь',
    formatting: 'Форматирование',
    send: 'Отправить',
    tooLong: 'на {count} символов длиннее лимита',
    code: 'Код',
    codeBlock: 'Блок кода',
    quote: 'Цитата',
    online: 'в сети',
    deactivated: 'сотрудник отключён',
    savedSubtitle: 'только вы',
    privateHint: 'Личная переписка: её видят только участники, даже администратор — нет',
    info: 'Сведения',
    offline: 'Нет связи — сообщения отправятся, когда она появится',
    offlineQueued: 'Нет связи — отправим, когда появится',
    placeholder: 'Сообщение для «{title}»',
    placeholderSaved: 'Заметка себе',
    cannotWrite: 'Писать в этот чат нельзя',
    cannotWriteDeactivated: 'Сотрудник отключён — написать ему нельзя, переписка остаётся',
    savedEmptyTitle: 'Избранное — только для вас',
    savedEmptyText: 'Заметки, ссылки и пересланные сообщения: всё под рукой на компьютере и телефоне',
    directEmptyTitle: 'Напишите {name}',
    directEmptyText: 'Сообщение придёт сразу — и на компьютер, и на телефон',
    groupEmptyTitle: 'Здесь начнётся переписка группы',
    groupEmptyText: 'Первое сообщение увидят все участники',
    toChats: 'К чатам',
    backToList: 'Вернуться к списку',
    failNetworkTitle: 'Нет связи с сервером',
    failNetworkText: 'Проверьте подключение и повторите — то, что уже загружено, останется на экране',
    partFailed: 'Не удалось загрузить часть экрана — обновите страницу',
    failKickedTitle: 'Вас исключили из чата',
    failKickedText:
      'Чат пропал из списка, а его сообщения вам больше недоступны. Остальные переписки на месте',
    failNotMemberTitle: 'Вы не участник этого чата',
    failNotMemberText: 'Попросите участника добавить вас — тогда чат появится в списке',
    failGoneTitle: 'Чат удалён или недоступен',
    failGoneText: 'Возможно, ссылка устарела или чат убрали. Нужные переписки — в списке',
    failThreadGoneTitle: 'Тред не нашёлся',
    failThreadGoneText: 'Исходное сообщение удалено или тред перенесён — вернитесь к чату',
    failForbiddenTitle: 'Нет доступа',
    failForbiddenText: 'Для этого чата не хватает прав. Если это ошибка — напишите администратору',
    failOtherTitle: 'Не получилось загрузить',
    failOtherText: 'Что-то пошло не так — повторите. Если не помогает, обновите страницу',
    listStale: 'Не удалось обновить список — показываем сохранённый',
    listOffline: 'Нет связи — показываем сохранённые чаты, новое подтянется само',
    feedOlderFailed: 'Не удалось загрузить историю выше',
    feedNewerFailed: 'Не удалось загрузить новые сообщения',
    membersFailed: 'Не удалось загрузить участников',
    pinsFailed: 'Не удалось загрузить закреплённые',
    peopleFailed: 'Не удалось загрузить список сотрудников',
    foldersFailed: 'Не удалось загрузить папки',
    threadsFailed: 'Не удалось загрузить треды',
    topicEmptyTitle: 'В теме пока нет сообщений',
    topicEmptyText: 'Напишите первым — тему видят все участники чата',
    topicEmptyClosed: 'Тема закрыта: писать в неё нельзя, пока её не откроют',
    entityEmptyTitle: 'Здесь будет переписка по объекту',
    entityEmptyText:
      'Обсуждайте вопросы и решения прямо здесь — история останется у объекта, а участники узнают о новом сразу',
    entityCatalogItemEmptyTitle: 'Здесь будет переписка по услуге',
    entityClientEmptyTitle: 'Здесь будет переписка по клиенту',
    entityDealEmptyTitle: 'Здесь будет переписка по сделке',
    writeInGeneral: 'Написать в «Общее»',
    mediaTitle: 'Фото, файлы и ссылки',
    mediaHint:
      'Вложения и ссылки из всех тем и тредов чата, новые сверху. Удалённые сообщения здесь не показываются',
    mediaTabMedia: 'Фото и видео',
    mediaTabFiles: 'Файлы',
    mediaTabLinks: 'Ссылки',
    mediaEmptyTitle: 'Фото и видео пока нет',
    mediaEmptyText: 'Всё, что отправят в этот чат, соберётся здесь — на компьютере и на телефоне',
    filesEmptyTitle: 'Файлов пока нет',
    filesEmptyText: 'Документы и файлы из переписки будут здесь — скачать можно в один клик',
    linksEmptyTitle: 'Ссылок пока нет',
    linksEmptyText: 'Ссылки из сообщений соберутся здесь, чтобы не искать их по ленте',
    mediaFailed: 'Не удалось загрузить список',
    mediaMoreFailed: 'Не удалось загрузить ещё',
    mediaMore: 'Загружаем ещё…',
    mediaToMessage: 'Перейти к сообщению',
    mediaOpenVideo: 'Видео: открыть сообщение',
    topicReopened: 'Тема открыта',
    pickTitle: 'Выберите чат',
    pickText: 'Слева — все переписки. Новый чат — кнопкой с карандашом или через ⌘K',
    searchPeople: 'Найти сотрудника',
    people: 'Сотрудники',
    peopleNothing: 'Никого не нашли',
    neverSeen: 'ещё не заходил(а)',
    directChat: 'Личный',
    groupChat: 'Группа',
    groupTitle: 'Название группы',
    groupTitlePlaceholder: 'Например, «Дизайн» или «Запуск сайта»',
    createGroup: 'Создать группу',
    createGroupWith: 'Создать группу: {count}',
    groupAvatar: 'Аватар группы',
    groupAvatarFailed: 'Не удалось изменить аватар',
    groupAvatarRemoved: 'Аватар группы убран',
    rename: 'Переименовать',
    addMembers: 'Добавить участников',
    addCount: 'Добавить: {count}',
    leave: 'Выйти из группы',
    leaving: 'Выходите из «{title}»',
    memberActions: 'Действия с участником',
    makeAdmin: 'Сделать администратором',
    makeMember: 'Снять права администратора',
    makeOwner: 'Передать владение',
    removeMember: 'Исключить из группы',
    roleOwner: 'владелец',
    roleAdmin: 'админ',
    members: {
      one: '{count} участник',
      few: '{count} участника',
      many: '{count} участников',
      other: '{count} участника',
    },
    peopleCount: {
      one: '{count} человек',
      few: '{count} человека',
      many: '{count} человек',
      other: '{count} человека',
    },
    emojiSearch: 'Найти эмодзи',
    emojiNothing: 'Такого эмодзи нет',
    emojiRecent: 'Недавние',
    emojiSmileys: 'Смайлики',
    emojiPeople: 'Люди',
    emojiNature: 'Животные и природа',
    emojiFood: 'Еда и напитки',
    emojiTravel: 'Путешествия',
    emojiActivities: 'Досуг',
    emojiObjects: 'Предметы',
    emojiSymbols: 'Символы',
    emojiFlags: 'Флаги',
    reactWith: 'Реакция {emoji}',
    addReaction: 'Другая реакция',
    reply: 'Ответить',
    replyInThread: 'Ответить в треде',
    moreActions: 'Ещё',
    forward: 'Переслать',
    pin: 'Закрепить',
    unpin: 'Открепить',
    remind: 'Напомнить',
    copyText: 'Копировать текст',
    copyLink: 'Скопировать ссылку',
    linkCopied: 'Ссылка скопирована',
    editHistory: 'История правок',
    whoRead: 'Кто прочитал',
    edit: 'Изменить',
    delete: 'Удалить',
    deleteSoftHint: 'Администратор сможет посмотреть удалённое сообщение',
    pinnedMessage: 'Закреплено',
    showMessage: 'Показать',
    showDeleted: 'Показать',
    forwardedFrom: 'Переслано от {name}',
    forwardedFromIn: 'Переслано от {name} из «{chat}»',
    lastReply: 'последний в {time}',
    replies: {
      one: '{count} ответ',
      few: '{count} ответа',
      many: '{count} ответов',
      other: '{count} ответа',
    },
    eventMessagePinned: '{by} закрепляет сообщение',
    forwardTitle: 'Переслать в чат',
    forwardedTo: 'Переслано в «{title}»',
    versionUntil: 'Версия {number} · до {date}',
    versionCurrent: 'Сейчас · изменено {date}',
    versionCurrentPlain: 'Сейчас',
    deletedTitle: 'Удалённое сообщение',
    deletedLead: 'Видно только администратору: участники видят «Сообщение удалено»',
    deletedMeta: 'Автор: {author} · удалил(а): {by} · {date}',
    nobodyRead: 'Ещё никто не прочитал',
    emoji: 'Эмодзи',
    mentionHint: 'Кого упомянуть',
    mentionAllHint: 'всех в чате',
    notInChat: 'не в чате',
    messageDeleted: 'Сообщение удалено',
    editing: 'Изменение сообщения',
    replyTo: 'Ответ {name}',
    cancelReply: 'Отменить ответ',
    cancelEdit: 'Отменить изменение',
    thread: 'Тред',
    threadEmpty: 'Ответов пока нет — начните обсуждение.',
    placeholderThread: 'Ответить в треде',
    mentionAll: 'все',
    follow: 'Следить',
    unfollow: 'Не следить',
    followHint: 'Ответы в треде будут приходить в «Треды» и уведомлениями',
    pinnedTitle: 'Закреплённые',
    pinsEmpty: 'Закрепите важное из меню сообщения — оно будет здесь и над лентой.',
    pinsCount: {
      one: '{count} закреплённое',
      few: '{count} закреплённых',
      many: '{count} закреплённых',
      other: '{count} закреплённого',
    },
    draft: 'Черновик:',
    threads: 'Треды',
    threadsHint: 'Треды, где вы писали, упомянуты или нажали «Следить»',
    threadsEmptyTitle: 'Тредов пока нет',
    threadsEmptyText: 'Ответьте в треде или нажмите «Следить» — обсуждение появится здесь.',
    threadIn: 'в «{title}»',
    openThread: 'Открыть тред',
    threadRootDeleted: 'Исходное сообщение удалено',
    mentionedOutsiders: '{names} не в чате — упоминание не придёт',
    addToChat: 'Добавить в чат',
    attach: 'Прикрепить файлы',
    attachHint: 'Файлы до 2 ГБ, фото и видео. Можно перетащить в чат или вставить из буфера',
    dropFiles: 'Отпустите, чтобы прикрепить',
    sendAsFile: 'Без сжатия',
    sendAsFileHint: 'Фото и видео уйдут файлами — в исходном качестве',
    removeAttachment: 'Убрать',
    uploadFailed: 'Не загрузилось',
    uploadRetry: 'Повторить загрузку',
    uploading: 'Загружается…',
    tooManyAttachments: 'Не больше 10 вложений в сообщении',
    fileTooLarge: '«{name}» больше 2 ГБ — такой файл не отправить',
    attachmentImage: 'Фото',
    attachmentVideo: 'Видео',
    attachmentFile: 'Файл',
    attachmentVoice: 'Голосовое сообщение',
    attachmentsCount: {
      one: '{count} вложение',
      few: '{count} вложения',
      many: '{count} вложений',
      other: '{count} вложения',
    },
    recordVoice: 'Записать голосовое',
    recording: 'Запись',
    cancelRecording: 'Удалить запись',
    sendVoice: 'Отправить голосовое',
    micDenied: 'Нет доступа к микрофону — разрешите его в настройках браузера',
    micUnsupported: 'Браузер не умеет записывать звук',
    micNotFound: 'Микрофон не найден — подключите его и попробуйте снова',
    micDisconnected: 'Микрофон отключился — запись остановлена',
    voiceRecordFailed: 'Не удалось записать голосовое — попробуйте ещё раз',
    voiceSending: 'Отправляем голосовое…',
    voiceProcessing: 'Голосовое обрабатывается — сейчас можно будет послушать',
    voicePlayFailed: 'Не удалось воспроизвести — попробуйте скачать',
    play: 'Слушать',
    pause: 'Пауза',
    speed: 'Скорость',
    listened: 'Прослушано',
    download: 'Скачать',
    processing: 'Обрабатывается…',
    processingFailed: 'Не удалось сделать превью — файл можно скачать',
    videoUnsupported: 'Браузер не может показать это видео — скачайте его',
    galleryPosition: '{index} из {total}',
    galleryPrev: 'Предыдущее',
    galleryNext: 'Следующее',
    zoom: 'Увеличить',
    linkPreviewFor: 'Превью ссылки: {host}',
    removeLinkPreview: 'Без превью ссылки',
    folders: 'Папки',
    foldersBack: 'Предыдущие папки',
    foldersMore: 'Ещё папки',
    folderAll: 'Все',
    folderPersonal: 'Личные',
    folderGroups: 'Группы',
    folderProjects: 'Проекты',
    folderClients: 'Клиенты',
    manageFolders: 'Папки',
    foldersLead:
      'Свои папки — вкладки над списком чатов. Системные («Все», «Личные», «Группы», «Проекты») есть всегда',
    foldersEmptyTitle: 'Своих папок пока нет',
    foldersEmptyText:
      'Соберите, например, «Работа» из групп и нужных личных чатов — она появится вкладкой над списком',
    newFolder: 'Новая папка',
    editFolder: 'Изменить папку',
    removeFolder: 'Удалить папку',
    folderRemoved: 'Папка «{title}» удалена',
    folderUp: 'Выше',
    folderDown: 'Ниже',
    folderTitle: 'Название',
    folderTitlePlaceholder: 'Например, «Работа»',
    folderKinds: 'Все чаты вида',
    folderKindsHint:
      'Папка сама собирает все чаты отмеченных видов, в том числе новые. Отдельные чаты можно добавить или исключить ниже',
    folderInclude: 'Добавить чаты',
    folderExclude: 'Исключить чаты',
    folderUnreadOnly: 'Только непрочитанные',
    folderUnreadOnlyHint:
      'Прочитанные чаты прячутся, пока в них не напишут. Добавленные вручную видны всегда',
    kindDirect: 'Личные',
    kindGroup: 'Группы',
    kindEntity: 'Чаты объектов',
    pickChats: 'Выбрать',
    done: 'Готово',
    removeFromFolder: 'Убрать из папки',
    chatsCount: {
      one: '{count} чат',
      few: '{count} чата',
      many: '{count} чатов',
      other: '{count} чата',
    },
    folderEmptyTitle: 'В папке пусто',
    folderEmptyText: 'Чаты этого вида появятся здесь сами',
    folderEmptyOwnText: 'Под правила папки пока ничего не подходит — добавьте чаты или виды чатов',
    archiveTitle: 'Архив',
    archiveEmptyTitle: 'Архив пуст',
    archiveEmptyText: 'Сюда уходят чаты, которые вы убрали в архив, и чаты завершённых объектов',
    archive: 'В архив',
    unarchive: 'Вернуть из архива',
    archivedToast: 'Чат в архиве — новое сообщение вернёт его в список',
    pinChat: 'Закрепить чат',
    unpinChat: 'Открепить чат',
    readAll: 'Прочитать всё',
    chatActions: 'Действия с чатом',
    notifications: 'Уведомления',
    notifyDefault: 'Умные',
    notifyAll: 'Все',
    notifyMentions: 'Упоминания',
    notifyMuted: 'Без звука',
    notifyHint:
      '«Умные»: личные, упоминания, ответы вам и новое в темах ваших задач — остальное только счётчиком. «Все» — каждое сообщение, «Упоминания» — только @вы и @все, «Без звука» — только счётчик',
    muteFor: 'Заглушить',
    muteHour: 'на 1 час',
    muteEightHours: 'на 8 часов',
    muteDay: 'на сутки',
    muteWeek: 'на неделю',
    unmute: 'Включить звук',
    mutedUntil: 'Без звука до {time}',
    topics: 'Темы',
    topicsHint:
      'Переписка разложена по темам, как в Telegram: «Общее» и отдельные темы. У проекта тема появляется на каждую задачу сама',
    topicGeneral: 'Общее',
    newTopic: 'Новая тема',
    newTopicHint: 'Новая тема — отдельный разговор внутри этого чата: по вопросу, макету или этапу',
    topicTitle: 'Название темы',
    topicTitlePlaceholder: 'Например, «Дизайн главной»',
    topicActions: 'Действия с темой',
    renameTopic: 'Переименовать тему',
    closeTopic: 'Закрыть тему',
    reopenTopic: 'Открыть тему',
    topicsToggle: 'Темы',
    topicsToggleHint:
      'Разделить переписку группы на темы. Выключите — останется только «Общее», сообщения в темах сохранятся',
    cannotWriteArchived: 'Объект в архиве — чат открыт только для чтения',
    entityChat: 'Чат объекта',
    entityCatalogItem: 'Услуга каталога',
    // Подпись вида в строке списка, шапке и поиске ⌘K: чат услуги не должен выглядеть как обычный.
    lookCatalogItem: 'Услуга',
    entityClient: 'Клиент',
    entityDeal: 'Сделка',
    eventClientMerged: 'Клиент объединён с «{into}» — переписка продолжается в чате основного клиента',
    // Папка «Клиенты» по клиентам: группа сворачивается стрелкой, внутри — лиды и сделки клиента.
    groupExpand: 'Развернуть: {title}',
    groupCollapse: 'Свернуть: {title}',
    groupCount: {
      one: '{count} чат',
      few: '{count} чата',
      many: '{count} чатов',
      other: '{count} чата',
    },
    openEntity: 'Открыть карточку',
    openInMessages: 'В «Сообщениях»',
    entityPlaceholder: 'Написать в обсуждение',
    entityNoAccess: 'Чат недоступен: нет доступа к мессенджеру',
    entityAssigned: 'Вы в этом чате по назначению',
    entityFollowing: 'Вы следите за чатом: он в списке, новые сообщения приходят',
    entityNotFollowing: 'Вы читаете чат без участия. «Следить» — чат появится в списке',
    eventEntityRenamed: 'Название изменилось: «{from}» → «{to}»',
    eventEntityArchived: 'Объект в архиве — чат открыт только для чтения',
    eventEntityRestored: 'Объект снова в работе',
    eventTopicCreated: '{by} создаёт тему «{title}»',
    eventTopicRenamed: '{by} меняет название темы: «{from}» → «{to}»',
    eventTopicClosed: '{by} закрывает тему',
    eventTopicReopened: '{by} снова открывает тему',
    eventTaskReview: '{by} отправляет задачу на проверку',
    eventTaskReturned: '{by} возвращает задачу на доработку',
    eventTaskReturnedComment: '{by} возвращает задачу на доработку: {comment}',
    eventTaskAccepted: '{by} принимает задачу, подтверждено {hours}',
    eventDealTaken: '{by} берёт лид из очереди',
    eventDealConverted: '{by} делает лид сделкой',
    eventDealStage: '{by} переводит сделку: «{from}» → «{to}»',
    eventDealClosed: '{by} закрывает: {outcome}',
    eventDealClosedReason: '{by} закрывает: {outcome} — {reason}',
    eventDealReopened: '{by} возвращает сделку в работу',
    eventDealResponsible: '{by} назначает ответственного: {user}',
    eventDealResponsibleCleared: '{by} снимает ответственного',
    /** Кто ответил на странице КП: сам клиент по ссылке. */
    proposalClient: 'Клиент через КП',
    eventProposalSentMail: '{by} отправляет {label} письмом',
    eventProposalSentLink: '{by} отправляет {label} ссылкой',
    eventProposalViewed: 'Клиент открыл {label} — {device}',
    eventProposalSelected: '{by}: выбран пакет «{package}» в {label}',
    eventProposalDeclined: '{by}: не подходит — {reason}',
    eventProposalQuestion: 'Клиент через КП: {text}',
    eventProposalQuestionStage: 'Клиент через КП, про этап «{stage}»: {text}',
    eventProposalRenew: 'Клиент через КП просит актуальное предложение вместо {label}',
    eventProposalLinkRevoked: '{by} отзывает ссылку на {label}',
    eventDocumentsSent: 'Ссылка на подпись «{title}» ушла клиенту — {name}',
    eventDocumentsViewed: 'Клиент открыл документы «{title}» — {device}',
    eventDocumentsStudioSigned: '{by} подписывает «{title}» за студию',
    eventDocumentsPartySigned: 'Клиент подписал «{title}» — {name}',
    eventDocumentsDeclined: 'Клиент отказался подписать «{title}»: {reason}',
    eventDocumentsRemarks: 'Замечания клиента к «{title}»: {reason}',
    eventDocumentsQuestion: 'Клиент по документам «{title}»: {text}',
    eventDocumentsRevoked: '{by} отзывает «{title}»',
    eventDocumentsScan: '{by} загружает скан подписанных документов «{title}»',
    eventDocumentsInvoice: '{by} выставляет «{title}» на {amount}',
  },
  settings: {
    sections: 'Разделы настроек',
    groupPersonal: 'Личное',
    groupStudio: 'Студия',
    groupFinance: 'Финансы',
    groupSystem: 'Система',
    studio: 'Реквизиты',
    specializations: 'Специализации',
    pricing: 'Цена',
    tax: 'Налог',
    coefficients: 'Коэффициенты',
    calendar: 'Календарь',
    sales: 'Продажи',
    proposals: 'Смета и КП',
    ai: 'ИИ',
    dadata: 'DaData',
    siteConfig: 'Конфигуратор сайта',
    notifications: 'Уведомления',
    mail: 'Почта',
  },
  webmail: {
    title: 'Почта',
    allInbox: 'Все входящие',
    allInboxHint: 'Входящие всех ваших ящиков в одном списке — личного и общих',
    accountsLabel: 'Ящики и папки',
    foldersLabel: 'Папки ящика {address}',
    folders: {
      inbox: 'Входящие',
      drafts: 'Черновики',
      sent: 'Отправленные',
      archive: 'Архив',
      junk: 'Спам',
      trash: 'Корзина',
    },
    kindPersonal: 'Личный ящик',
    kindShared: 'Общий ящик',
    readOnly: 'Только чтение',
    readOnlyHint:
      'Письма этого ящика можно читать, но не отвечать на них и не менять — попросите администратора выдать право отправки',
    readOnlyBanner: 'Общий ящик только для чтения: отвечать и менять письма нельзя',
    andMore: 'ещё {count}',
    unreadCount: 'Непрочитанных: {count}',
    collapseAccount: 'Свернуть ящик',
    expandAccount: 'Развернуть ящик',
    listLabel: 'Список писем',
    noSubject: '(без темы)',
    noSender: '(без отправителя)',
    toPrefix: 'Кому: {names}',
    noRecipients: '(нет получателей)',
    today: 'Сегодня',
    yesterday: 'Вчера',
    week: 'На этой неделе',
    earlier: 'Раньше',
    hasAttachment: 'Есть вложения',
    flagged: 'С флажком',
    draft: 'Черновик',
    answered: 'Вы уже ответили',
    threadSize: 'Писем в цепочке: {count}',
    selectThread: 'Выбрать письмо «{subject}»',
    attachmentsCount: {
      one: '{count} вложение',
      few: '{count} вложения',
      many: '{count} вложений',
      other: '{count} вложения',
    },
    loadMore: 'Показать ещё',
    loadingMore: 'Загружаем…',
    foundTotal: 'Найдено цепочек: {count}',
    listEmptyInbox: {
      title: 'Во входящих пусто',
      description: 'Новые письма появятся здесь сами — страницу обновлять не нужно',
    },
    listEmptyAll: {
      title: 'Во всех ящиках пусто',
      description: 'Новые письма появятся здесь сами — страницу обновлять не нужно',
    },
    listEmptyDrafts: {
      title: 'Черновиков нет',
      description: 'Начатые письма сохраняются здесь сами — можно вернуться к ним с любого устройства',
    },
    listEmptySent: {
      title: 'Отправленных нет',
      description: 'Письма, которые вы отправите, останутся здесь',
    },
    listEmptyArchive: {
      title: 'Архив пуст',
      description: 'Сюда уходят письма, с которыми вы закончили: кнопка «В архив» или клавиша E',
    },
    listEmptyJunk: {
      title: 'Спама нет',
      description: 'Сюда попадают нежелательные письма; через 30 дней сервер удаляет их сам',
    },
    listEmptyTrash: {
      title: 'Корзина пуста',
      description: 'Удалённые письма лежат здесь до окончательного удаления',
    },
    listEmptyFolder: {
      title: 'В папке пусто',
      description: 'Письма, перемещённые сюда, появятся в этом списке',
    },
    listEmptySearch: {
      title: 'Ничего не нашли',
      description: 'Попробуйте другие слова или уберите фильтры',
    },
    selectTitle: 'Выберите письмо',
    selectDescription: 'Оно откроется здесь, вместе со всей перепиской',
    back: 'Назад к списку',
    problems: {
      not_ready: {
        title: 'Ящик ещё не готов',
        description:
          'Почтовый сервер создаёт ящик — обычно это занимает меньше минуты. Письма появятся сами.',
      },
      disabled: {
        title: 'Ящик отключён',
        description:
          'Письма в отключённом ящике не принимаются и не показываются, но сохраняются на сервере.',
      },
      unavailable: {
        title: 'Почтовый сервер не отвечает',
        description: 'Повторим автоматически. Если так долго — сообщите администратору.',
      },
      forbidden: {
        title: 'Нет доступа к ящику',
        description: 'Доступ отозван или ещё не применился на сервере — попросите администратора проверить.',
      },
    },
    noMailboxTitle: 'У вас пока нет рабочего ящика',
    noMailboxDescription: 'Ящик создаётся вместе с приглашением. Попросите администратора создать его.',
    notConfiguredTitle: 'Почта ещё не настроена',
    notConfiguredDescription: 'Сервер почты не подключён к платформе — этим занимается администратор.',
    notConfiguredAdmin: 'Открыть настройки почты',
    loadError: 'Не удалось загрузить письма',
    loadErrorDescription: 'Проверьте соединение — попробуем ещё раз автоматически.',
    retry: 'Повторить',
    threadLoadError: 'Не удалось открыть письмо',
    threadGone: {
      title: 'Письма больше нет',
      description: 'Его удалили или переместили. Обновите список — он покажет актуальное.',
    },
    threadMessages: 'Писем в цепочке: {count}',
    expandMessage: 'Развернуть письмо',
    collapseMessage: 'Свернуть письмо',
    expandAll: 'Развернуть все',
    from: 'От',
    to: 'Кому',
    cc: 'Копия',
    bcc: 'Скрытая копия',
    replyTo: 'Ответы — на',
    sentAt: 'Отправлено',
    receivedAt: 'Получено',
    showDetails: 'Подробности',
    hideDetails: 'Скрыть подробности',
    me: 'я',
    imagesBlocked: 'Внешние картинки не загружены: так отправитель не узнает, что вы открыли письмо и откуда',
    imagesBlockedCount: {
      one: 'Не загружена {count} внешняя картинка — отправитель не узнает, что вы открыли письмо',
      few: 'Не загружено {count} внешние картинки — отправитель не узнает, что вы открыли письмо',
      many: 'Не загружено {count} внешних картинок — отправитель не узнает, что вы открыли письмо',
      other: 'Не загружено {count} внешних картинок — отправитель не узнает, что вы открыли письмо',
    },
    showImages: 'Показать картинки',
    alwaysShowImages: 'Всегда показывать от {sender}',
    imagesTrusted: 'Картинки от этого отправителя показываются всегда',
    stopTrusting: 'Не показывать сразу',
    imagesInfo: {
      title: 'Внешние картинки',
      text: 'Картинку в письме грузит наш сервер, а не ваш браузер: отправитель не видит ни ваш адрес, ни время прочтения. Пока вы не разрешите, картинки не загружаются вовсе.',
    },
    truncated: 'Письмо очень большое — показана только его часть',
    downloadOriginal: 'Скачать исходное письмо',
    attachments: 'Вложения',
    attachmentDownload: 'Скачать {name}',
    attachmentPreview: 'Посмотреть {name}',
    previewClose: 'Закрыть просмотр',
    previewFailed: 'Не удалось показать файл — скачайте его',
    unsubscribe: 'Отписаться',
    unsubscribeHint: 'Ссылка отписки из самого письма — откроется в новой вкладке',
    showQuote: 'Показать цитату',
    frameTitle: 'Тело письма «{subject}»',
    messageUnread: 'Непрочитанное',
    messageFlagged: 'С флажком',
    draftBadge: 'Черновик',
    forwardedBadge: 'Переслано',
    noBody: '(в письме нет текста)',
    actionFailed: {
      one: 'Не удалось изменить {count} письмо',
      few: 'Не удалось изменить {count} письма',
      many: 'Не удалось изменить {count} писем',
      other: 'Не удалось изменить {count} письма',
    },
    deletedForever: 'Удалено насовсем',
    commandSearch: 'Искать в почте «{query}»',
    settingsLink: 'Настройки почты',
    mailTo: 'Написать {email}',
    profile: {
      crumb: 'Профиль',
      title: 'Почта',
      lead: 'Подпись, картинки в письмах и уведомления. Сами письма — в разделе «Почта»',
      addressSection: 'Ваш адрес',
      noMailbox: 'Личного ящика у вас пока нет — его создаёт администратор в настройках почты',
      open: 'Открыть почту',
      signatureSection: 'Подпись',
      signatureLead: 'Ставится под каждое новое письмо и ответ; в самом письме её можно поменять или убрать',
      signatureLabel: 'Подпись под письмами',
      signaturePlaceholder: 'Например: С уважением, Анна, студия Glory',
      signatureSave: 'Сохранить подпись',
      signatureSaved: 'Подпись сохранена',
      imagesSection: 'Картинки в письмах',
      imagesLead:
        'Внешние картинки не загружаются, пока вы сами не нажмёте «Показать картинки»: так отправитель не узнает, что письмо прочитано. Здесь — те, от кого картинки показываются всегда',
      imagesEmpty: 'Пока никого — «Всегда показывать от этого отправителя» есть над письмом с картинками',
      imagesRemove: 'Убрать {email} из списка',
      imagesRemoved: '{email} убран из списка',
      alertsSection: 'Уведомления о письмах',
      alertsLead:
        'О письмах в личный ящик — в общей настройке уведомлений (в приложении и push). Общие ящики по умолчанию молчат, чтобы info@ не звенел у всех: включите нужные',
      alertsMatrix: 'Настроить уведомления',
      alertsSharedTitle: 'Общие ящики',
      alertsSharedEmpty: 'Общих ящиков, к которым у вас есть доступ, нет',
      alertsToggleHint: 'Новое письмо во «Входящих» этого ящика — уведомление вам',
      clientsSection: 'Почтовые программы',
      clientsLead:
        'Thunderbird, Apple Mail и телефон входят по паролю приложения — пароли создаются в разделе «Безопасность»',
      clientsOpen: 'Открыть «Безопасность»',
    },
    commandWrite: 'Написать {email}',
    movedToTrash: 'Перенесено в корзину',
    archived: 'Перенесено в архив',
    markedSpam: 'Отмечено как спам',
    unmarkedSpam: 'Возвращено во входящие',
    movedTo: 'Перемещено: {folder}',
    search: {
      placeholder: 'Поиск по почте',
      label: 'Поиск по письмам',
      filters: 'Фильтры поиска',
      from: 'От кого',
      to: 'Кому',
      subject: 'Тема',
      hasAttachment: 'Есть вложения',
      unread: 'Непрочитанные',
      flagged: 'С флажком',
      after: 'С даты',
      before: 'По дату',
      here: 'Только в этой папке',
      hereHint: 'Без этого поиск идёт по всему ящику, кроме корзины и спама',
      reset: 'Сбросить',
      apply: 'Найти',
      chipText: 'Текст: {value}',
      chipFrom: 'От: {value}',
      chipTo: 'Кому: {value}',
      chipSubject: 'Тема: {value}',
      chipAfter: 'с {value}',
      chipBefore: 'по {value}',
      chipPeople: 'Переписка с: {value}',
      chipRemove: 'Убрать условие «{name}»',
      results: 'Результаты поиска',
      hint: 'Слова ищутся в теме, тексте, отправителе и получателях; кириллица и латиница — без учёта регистра',
    },
    bulk: {
      selected: {
        one: 'Выбрана {count} цепочка',
        few: 'Выбрано {count} цепочки',
        many: 'Выбрано {count} цепочек',
        other: 'Выбрано {count} цепочки',
      },
      clear: 'Снять выбор',
      selectAll: 'Выбрать все загруженные',
      markRead: 'Прочитано',
      markUnread: 'Не прочитано',
      flag: 'Поставить флажок',
      unflag: 'Снять флажок',
      archive: 'В архив',
      spam: 'Это спам',
      notSpam: 'Не спам',
      delete: 'Удалить',
      deleteForever: 'Удалить насовсем',
      move: 'Переместить',
      moveTo: 'Переместить в…',
      nothingToMove: 'Нет других папок',
      readOnly: 'Только чтение — менять письма здесь нельзя',
    },
    hotkeys: {
      title: 'Горячие клавиши почты',
      compose: 'Написать',
      next: 'Следующее письмо',
      previous: 'Предыдущее письмо',
      open: 'Открыть',
      close: 'Закрыть письмо',
      archive: 'В архив',
      delete: 'Удалить',
      spam: 'Это спам',
      flag: 'Флажок',
      unread: 'Не прочитано',
      select: 'Выбрать',
      reply: 'Ответить',
      replyAll: 'Ответить всем',
      forward: 'Переслать',
      search: 'Поиск',
    },
    folderNew: 'Новая папка',
    folderName: 'Название папки',
    folderCreate: 'Создать',
    folderRename: 'Переименовать',
    folderDelete: 'Удалить папку',
    folderDeleteHint: 'Письма из папки уйдут в корзину',
    folderDeleted: 'Папка «{name}» удалена — письма в корзине',
    folderMenu: 'Действия с папкой',
    folderAdd: 'Добавить папку',
    compose: {
      newMessage: 'Новое письмо',
      underline: 'Подчёркнутый',
      quote: 'Цитата',
      write: 'Написать',
      writeTo: 'Написать {name}',
      from: 'От',
      to: 'Кому',
      cc: 'Копия',
      bcc: 'Скрытая',
      showCc: 'Копия',
      showBcc: 'Скрытая копия',
      subject: 'Тема',
      subjectPlaceholder: 'О чём письмо',
      bodyLabel: 'Текст письма',
      bodyPlaceholder: 'Напишите письмо…',
      recipientsPlaceholder: 'Имя или адрес',
      recipientInvalid: 'Адрес «{address}» написан с ошибкой',
      recipientsRequired: 'Добавьте хотя бы одного получателя',
      removeRecipient: 'Убрать {name}',
      suggestStaff: 'Сотрудник',
      suggestShared: 'Общий ящик',
      suggestHistory: 'Из переписки',
      send: 'Отправить',
      sendLater: 'Отправить позже',
      sendLaterHint: 'Письмо уйдёт в назначенное время — даже если платформа будет перезапущена',
      sendLaterHour: 'Через час',
      sendLaterTomorrow: 'Завтра в 9:00',
      sendLaterMonday: 'В понедельник в 9:00',
      sendLaterPick: 'Выбрать дату и время…',
      sendLaterConfirm: 'Запланировать',
      sendLaterAt: 'Отправить',
      sendLaterPast: 'Это время уже прошло — выберите момент в будущем',
      sent: 'Письмо отправлено',
      sentScheduled: 'Письмо уйдёт {time}',
      sentUndone: 'Отправка отменена — письмо вернулось в черновики',
      sending: 'Отправляем…',
      attach: 'Прикрепить файл',
      attachDrop: 'Отпустите файлы, чтобы прикрепить',
      attachUploading: 'Загружается…',
      attachFailed: 'Не удалось загрузить «{name}»',
      attachTooLarge: 'Вложения больше {limit} — отправьте файлы ссылкой',
      attachRemove: 'Убрать вложение {name}',
      saving: 'Сохраняем…',
      saved: 'Черновик сохранён',
      saveFailed: 'Не удалось сохранить черновик — попробуем снова',
      discard: 'Удалить черновик',
      discarded: 'Черновик удалён',
      minimize: 'Свернуть',
      restore: 'Развернуть',
      fullscreen: 'На весь экран',
      close: 'Закрыть',
      closeHint: 'Письмо сохранится в черновиках',
      shortcutSend: '⌘↵ — отправить',
      fromLabel: 'Отправитель',
      onlyFrom: 'Отправляется от имени {address}',
      formatting: 'Оформление письма',
      scheduledTitle: 'Запланированные письма',
      scheduledAt: 'Уйдёт {time}',
      scheduledCancel: 'Отменить отправку',
      scheduledCanceled: 'Отправка отменена — письмо в черновиках',
      scheduledCount: 'Запланировано: {count}',
      replyAll: 'Ответить всем',
      reply: 'Ответить',
      forward: 'Переслать',
      noSendRights: 'С этого ящика можно только читать — отправка не разрешена',
    },
  },
  mail: {
    defaultAdmin: 'Администрация студии',
    defaultInfo: 'Общий ящик студии',
    title: 'Почта',
    lead: 'Ящики студии на своём почтовом сервере: личные — у каждого сотрудника, общие — для заявок и переписки команды',
    domain: 'Домен',
    server: 'Сервер',
    serverOk: 'Отвечает',
    serverDown: 'Не отвечает',
    serverDownLead:
      'Почтовый сервер не отвечает: новые ящики не создаются, письма ждут в очереди. Ящики, которые не создались, повторятся сами, когда сервер ответит',
    notConfiguredTitle: 'Почта не подключена',
    notConfiguredText:
      'Платформа работает без почты: ящики не создаются, письма не уходят, ссылки-приглашения админ отправляет сам. Подключается при установке — адрес Stalwart и почтовый домен',
    statusProvisioning: 'Создаётся',
    statusActive: 'Работает',
    statusDisabled: 'Заблокирован',
    statusFailed: 'Не создан',
    statusDisabledHint:
      'Письма не принимаются, вход из почтовых программ закрыт; всё, что было в ящике, сохранено',
    failureAddressTaken: 'Адрес уже занят на почтовом сервере',
    failureRejected: 'Почтовый сервер отклонил адрес',
    failureUnavailable: 'Почтовый сервер не отвечал — повторим сами, как только ответит',
    failedTitle: 'Не создались',
    failedLead:
      'Поправьте адрес и повторите. Ящики, которые не создались из-за недоступного сервера, повторяются сами каждые 5 минут',
    retry: 'Повторить',
    retryTitle: 'Повторить создание ящика',
    retryLead: 'Ящика ещё нет на почтовом сервере — адрес можно поменять',
    retried: 'Ящик {address} создан',
    retryFailed: 'Ящик {address} снова не создался — причина на карточке',
    sharedTitle: 'Общие ящики',
    sharedLead: 'Письма видят те, кому выдан доступ: только чтение или чтение и отправка от имени ящика',
    sharedEmpty: 'Общих ящиков пока нет — например, hello@ для заявок с сайта',
    newShared: 'Общий ящик',
    newSharedTitle: 'Новый общий ящик',
    newSharedLead: 'Доступ сотрудникам выдаётся после создания',
    address: 'Адрес',
    addressHint: 'Буквы, цифры, точка, дефис. Можно по-русски — без латиницы в том же имени',
    addressPlaceholder: 'hello',
    purpose: 'Назначение',
    purposeHint: 'Видно в почтовых программах: «Заявки с сайта», «Бухгалтерия»',
    createMailbox: 'Создать ящик',
    created: 'Ящик {address} создан',
    personalTitle: 'Личные ящики',
    personalLead:
      'Создаются при приглашении. Отозвали приглашение или отключили сотрудника — ящик блокируется, письма сохраняются',
    personalEmpty: 'Личных ящиков пока нет — они появятся, когда вы пригласите сотрудников',
    invited: 'приглашён: {email}',
    inactivePerson: 'отключён',
    withoutMailbox: 'Без ящика',
    withoutMailboxLead: 'Сотрудники, которые пришли до почты или чей ящик не создавался',
    createFor: 'Ящик для {name}',
    access: 'Доступ',
    accessTitle: 'Доступ к {address}',
    accessLead: 'Ящик появится у сотрудника в почтовой программе рядом с личным',
    accessEmpty: 'Доступа пока нет ни у кого',
    accessNobody: 'Нет доступа',
    levelRead: 'Чтение',
    levelSend: 'Чтение и отправка',
    levelReadShort: 'чтение',
    levelSendShort: 'отправка',
    addPerson: 'Выдать доступ',
    person: 'Сотрудник',
    removeAccess: 'Забрать доступ',
    noMailbox: 'нет ящика',
    accessGranted: 'Доступ выдан',
    accessChanged: 'Доступ изменён',
    accessRevoked: 'Доступ забран',
    dnsTitle: 'Домен и DNS',
    dnsLead: 'Добавьте эти записи у регистратора домена — без них письма студии попадут в спам или не дойдут',
    dnsEmpty: 'Сервер не вернул записи — проверьте, что он отвечает',
    copyDns: 'Скопировать записи',
    dnsCopied: 'Записи скопированы',
    clientsTitle: 'Почтовые программы',
    clientsLead:
      'Одинаково для всех ящиков. Логин — адрес ящика, пароль — пароль приложения из раздела «Безопасность»',
    imap: 'Входящие (IMAP)',
    smtp: 'Отправка (SMTP)',
    port: 'порт {port}',
    encryption: 'Шифрование',
    encryptionValue: 'SSL/TLS',
    login: 'Логин',
    loginValue: 'адрес ящика',
  },
  letters: {
    greeting: '{name}, здравствуйте!',
    greetingAnonymous: 'Здравствуйте!',
    automatic: 'Письмо отправлено автоматически, отвечать на него не нужно.',
    linkFallback: 'Если кнопка не открывается, скопируйте ссылку в браузер:',
    invitationSubject: '{name} приглашает вас в Глори.Штат',
    invitationSubjectAnonymous: 'Приглашение в Глори.Штат',
    invitationPreheader: 'Задайте пароль — и сразу войдёте в команду',
    invitationLead:
      '{name} приглашает вас в команду в Глори.Штат — платформе студии, где заявки, расчёты, договоры и деньги в одном месте.',
    invitationLeadAnonymous:
      'Вас приглашают в команду в Глори.Штат — платформе студии, где заявки, расчёты, договоры и деньги в одном месте.',
    invitationRoles: 'Роль: {roles}',
    invitationPosition: 'Должность: {position}',
    invitationAddress: 'Рабочая почта: {address}',
    invitationAction: 'Принять приглашение',
    invitationExpires: 'Ссылка действует до {date} (по Москве) и срабатывает один раз.',
    resetSubject: 'Сброс пароля в Глори.Штат',
    resetPreheader: 'Ссылка, чтобы задать новый пароль',
    resetLead:
      'Вы попросили сбросить пароль для входа в Глори.Штат. Новый пароль можно задать по кнопке ниже.',
    resetAction: 'Задать новый пароль',
    resetExpires:
      'Ссылка действует до {date} (по Москве) и срабатывает один раз. После смены пароля сеансы на других устройствах завершатся.',
    resetIgnore: 'Если сброс просили не вы, ничего не делайте — пароль останется прежним.',
    notificationAction: 'Открыть в Глори.Штат',
    notificationFooter: 'Письмо пришло, потому что для этого уведомления включён email.',
    notificationSettings: 'Настроить уведомления',
    digestLead:
      'Пока вас не было в Глори.Штат, вам написали — личные сообщения и упоминания остались непрочитанными.',
    digestAction: 'Открыть сообщения',
    digestFooter: 'Письмо пришло вместо push: на ваших устройствах уведомления не включены.',
    signingCodeSubject: 'Код для подписи: {code}',
    signingCodePreheader: 'Подписание: {title}',
    signingCodeLead: 'Вы подписываете {title}. Введите код на странице подписания:',
    signingCodeLine: 'Код: {code}',
    signingCodeExpires: 'Код действует до {time} и подходит только к этим документам.',
    signingCodeIgnore:
      'Если вы ничего не подписываете, просто не вводите код и никому его не сообщайте — без него подпись не состоится.',
    signingLinkSubject: '{studio}: документы на подпись — {title}',
    signingLinkPreheader: 'Посмотрите документы и подпишите кодом из письма',
    signingLinkLead:
      '{studio} отправляет вам на подпись: {title}. Документы можно посмотреть и подписать кодом из письма — с телефона или компьютера.',
    signingLinkAction: 'Открыть документы',
    signingLinkExpires: 'Ссылка действует до {date} включительно.',
    signingLinkReply: 'Есть вопросы — ответьте на это письмо, его получит ваш менеджер.',
    signingLinkFooter: 'Письмо отправлено автоматически от имени {studio}.',
    signedCopySubject: 'Документы подписаны — {title}',
    signedCopyPreheader: 'Копии с листом подписания — во вложении',
    signedCopyLead:
      'Все стороны подписали документы простой электронной подписью. Копии с листом подписания — во вложении.',
    signedCopyLeadScan:
      'Документы подписаны на бумаге, скан подписанных экземпляров загружен в платформу. Копии документов — во вложении.',
    signedCopyKeep: 'Сохраните письмо: лист подписания с хэшем подтверждает, что документы не менялись.',
    cabinetCodeSubject: 'Код для входа: {code}',
    cabinetCodePreheader: 'Личный кабинет {studio}',
    cabinetCodeLead: 'Вы входите в личный кабинет {studio}. Введите код на странице входа:',
    cabinetCodeExpires: 'Код действует до {time} и срабатывает один раз.',
    cabinetCodeIgnore: 'Если вы не входили в кабинет, просто не вводите код и никому его не сообщайте.',
    cabinetInviteSubject: '{studio}: ваш личный кабинет',
    cabinetInvitePreheader: 'Проекты, документы и счета — в одном месте',
    cabinetInviteLead:
      '{studio} открывает вам личный кабинет: что нужно от вас, как идут проекты, документы, счета и переписка с командой — в одном месте.',
    cabinetInviteAction: 'Войти в кабинет',
    cabinetInviteHow: 'Пароль не нужен: введите эту почту на странице входа — придёт код из 6 цифр.',
    cabinetMessageSubject: '{studio}: новое сообщение в личном кабинете',
    cabinetMessagePreheader: 'Вам ответили — переписка в кабинете',
    cabinetMessageLead: '{studio} написали вам в личном кабинете. Ответить можно там же.',
    cabinetMessageAction: 'Открыть переписку',
    proposalChatSubject: '{studio}: ответ на ваш вопрос по предложению',
    proposalChatPreheader: 'Вам ответили — переписка на странице предложения',
    proposalChatLead:
      '{studio} ответили вам на странице коммерческого предложения. Продолжить переписку можно там же.',
    proposalChatAction: 'Открыть предложение',
    cabinetFooter: 'Всё по вашим проектам — в личном кабинете',
    cabinetItemTaskSubject: '{studio}: задание для вас — {title}',
    cabinetItemApprovalSubject: '{studio}: на согласование — {title}',
    cabinetItemPreheader: 'Проект «{project}» — ответить можно в личном кабинете',
    cabinetItemTaskLead:
      '{studio} просят вас: «{title}» (проект «{project}»). Ответить и приложить файлы можно в личном кабинете.',
    cabinetItemTaskAgain:
      '{studio} вернули задание «{title}» с комментарием (проект «{project}»). Подробности — в личном кабинете.',
    cabinetItemApprovalLead:
      '{studio} отправили вам на согласование «{title}» (проект «{project}»). Посмотреть, согласовать или написать замечания можно в личном кабинете.',
    cabinetItemApprovalAgain:
      '{studio} прислали новую версию «{title}» на согласование (проект «{project}»).',
    cabinetItemAction: 'Открыть в кабинете',
    ...ruProjectsSupportLetters,
  },
  today: {
    stepStudio: 'Реквизиты студии',
    stepStudioHint: 'ИНН — остальное подставится само; нужны для договоров и счетов',
    stepStudioAction: 'Заполнить',
    title: 'Сегодня',
    greetingMorning: 'Доброе утро, {name}',
    greetingDay: 'Добрый день, {name}',
    greetingEvening: 'Добрый вечер, {name}',
    greetingNight: 'Доброй ночи, {name}',
    setupTitle: 'Запуск студии',
    setupLead: 'Несколько шагов — и Глори.Штат готов к работе',
    setupProgress: '{done} из {total}',
    setupShowDone: 'Показать выполненные · {count}',
    setupHideDone: 'Скрыть выполненные',
    inbox: {
      label: 'Входящее',
      messages: 'Сообщения',
      chats: {
        one: '{count} чат с новым',
        few: '{count} чата с новым',
        many: '{count} чатов с новым',
        other: '{count} чата с новым',
      },
      mentions: {
        one: '{count} упоминание',
        few: '{count} упоминания',
        many: '{count} упоминаний',
        other: '{count} упоминания',
      },
      mail: 'Почта',
      letters: {
        one: '{count} новое письмо',
        few: '{count} новых письма',
        many: '{count} новых писем',
        other: '{count} нового письма',
      },
      nothing: 'Нет нового',
    },
    stepSpecializations: 'Специализации и ставки',
    stepSpecializationsHint: 'Дизайн, фронтенд, PM — и сколько стоит час каждой: по ним считаются цены',
    stepSpecializationsAction: 'Добавить',
    stepPricing: 'Накладные и наценка',
    stepPricingHint: 'Постоянные расходы студии, наценка, минимальная маржа — без них цену не посчитать',
    stepPricingAction: 'Настроить',
    stepTax: 'Налог',
    stepTaxHint: 'Режим налогообложения: налог закладывается в цену, чтобы студия не платила его из маржи',
    stepTaxAction: 'Указать',
    stepCatalog: 'Каталог услуг',
    stepCatalogHint: 'Шаблоны «Лендинг», «Логотип» — цена посчитается по задачам сама',
    stepCatalogAction: 'Собрать',
    stepTeam: 'Пригласите команду',
    stepTeamHint: 'Сотрудники получат ссылку и войдут с нужными ролями',
    stepTeamAction: 'Пригласить',
    stepPush: 'Включите push-уведомления',
    stepPushHint: 'Уведомления придут, даже когда Глори.Штат закрыт',
    stepPushAction: 'Настроить',
    notificationsTitle: 'Уведомления',
    notificationsOff: 'Включите push на этом устройстве — уведомления придут, даже когда Глори.Штат закрыт',
    notificationsOn: 'Push включён — уведомления приходят, даже когда Глори.Штат закрыт',
    notificationsAction: 'Настроить уведомления',
    // Блоки продаж на «Сегодня».
    sales: {
      title: 'Продажи',
      lead: 'Что требует вас сегодня: шаги, очередь лидов, сделки без шага и без ответственного. Показано только то, что вам доступно',
      toPipeline: 'Воронка',
      failed: 'Не удалось собрать продажи — проверьте связь и попробуйте ещё раз',
      more: 'Ещё {count} — открыть список',
      wait: { minutes: '{count} мин', hours: '{count} ч' },
      steps: {
        title: 'Мои шаги',
        hint: {
          text: 'Ваши открытые шаги на сегодня и просроченные — просроченные первыми. «Выполнено» записывает итог и сразу предлагает следующий шаг, «Перенести» двигает срок',
          example:
            'Позвонить в пекарню сегодня в 15:00: позвонили — «Выполнено», итог, следующий шаг «Завтра»',
        },
        emptyTitle: 'На сегодня шагов нет',
        emptyText:
          'Поставьте следующий шаг у своих сделок — в нужный день он появится здесь и напомнит о себе',
        emptyAction: 'Открыть воронку',
        otherDate: 'Другая дата…',
      },
      queue: {
        title: 'Очередь лидов',
        hint: {
          text: 'Лиды, которых ещё никто не взял. Кто первым нажмёт «Взять», тот и ответственный; если очередь стоит, менеджеры получают напоминание',
          example: 'Лид ждёт 25 минут, вы нажали «Взять» — он ваш и появился в «Сделках без шага»',
        },
        emptyTitle: 'Очередь пуста',
        emptyText:
          'Новые лиды без ответственного появятся здесь. Лид, заведённый вручную, сразу закреплён за автором',
        waits: 'ждёт {time}',
      },
      withoutStep: {
        title: 'Сделки без шага',
        hint: {
          text: 'Ваши открытые сделки и лиды, у которых не поставлен следующий шаг. Шаг не обязателен, но без него запись легко забыть — поэтому она здесь и в утренней сводке',
          example: 'Отправили КП — поставьте шаг «Позвонить через 3 дня», и сделка уйдёт отсюда',
        },
        emptyTitle: 'У всех ваших сделок есть шаг',
        emptyText: 'Ничего не забыто: у каждой открытой сделки есть следующий шаг',
      },
      returned: {
        title: 'Вернулись из отложенных',
        hint: {
          text: 'Сделки, которые вы откладывали до даты и которые сегодня вернулись на доску. Самое время вернуться к разговору',
        },
        open: 'Вернуться к сделке',
      },
      unassigned: {
        title: 'Без ответственного',
        hint: {
          text: 'Открытые сделки, у которых нет ответственного: например, сотрудника отключили. Возьмите сделку себе или откройте её и назначьте другого',
          example: 'Сотрудника отключили — его сделки появились здесь, а вы получили уведомление',
        },
        emptyTitle: 'Все сделки закреплены',
        emptyText:
          'У каждой открытой сделки есть ответственный. Если сотрудника отключат, его сделки появятся здесь',
        takeOver: 'Взять себе',
      },
      toast: { takenOver: 'Сделка «{title}» теперь ваша' },
    },
  },
  authErrors: {
    INVALID_EMAIL_OR_PASSWORD: 'Неверный email или пароль',
    INVALID_PASSWORD: 'Неверный пароль',
    INVALID_EMAIL: 'Проверьте email — в нём ошибка',
    INVALID_CODE: 'Код не подошёл — проверьте цифры и время на телефоне',
    INVALID_BACKUP_CODE: 'Резервный код не подошёл или уже использован',
    INVALID_TWO_FACTOR_COOKIE: 'Время на ввод кода вышло — войдите заново',
    OTP_HAS_EXPIRED: 'Код устарел — введите новый из приложения',
    TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE: 'Слишком много попыток — подождите и попробуйте снова',
    ACCOUNT_TEMPORARILY_LOCKED: 'Слишком много неверных кодов — вход временно заблокирован, попробуйте позже',
    PASSWORD_TOO_SHORT: 'Пароль слишком короткий — нужно не меньше 10 символов',
    PASSWORD_TOO_LONG: 'Пароль слишком длинный — не больше 128 символов',
    SESSION_EXPIRED: 'Для этого действия войдите заново — сеанс слишком старый',
    SESSION_NOT_FRESH: 'Для этого действия войдите заново — сеанс слишком старый',
    TOTP_ALREADY_ENABLED: 'Двухфакторная проверка уже включена',
    TWO_FACTOR_NOT_ENABLED: 'Двухфакторная проверка не включена',
    PASSKEY_NOT_FOUND: 'Этот ключ доступа не найден — возможно, его удалили',
    AUTHENTICATION_FAILED: 'Не удалось войти с ключом доступа — попробуйте ещё раз или войдите паролем',
    AUTH_CANCELLED: 'Вход с ключом доступа отменён',
    REGISTRATION_CANCELLED: 'Добавление ключа отменено',
    PREVIOUSLY_REGISTERED: 'Этот ключ уже добавлен',
    FAILED_TO_VERIFY_REGISTRATION: 'Не удалось добавить ключ — попробуйте ещё раз',
    CREDENTIAL_ACCOUNT_NOT_FOUND: 'У этой учётной записи нет пароля',
    USER_NOT_FOUND: 'Пользователь не найден',
    INVALID_ORIGIN: 'Запрос пришёл не с адреса платформы — откройте Глори.Штат по основному адресу',
    MISSING_OR_NULL_ORIGIN: 'Запрос пришёл не с адреса платформы — откройте Глори.Штат по основному адресу',
    TOO_MANY_REQUESTS: 'Слишком много попыток — подождите немного и попробуйте снова',
    INVALID_TOKEN: 'Ссылка для сброса пароля недействительна или устарела — запросите новую',
    UNKNOWN: 'Не получилось — проверьте соединение и попробуйте ещё раз',
  },
  news: {
    title: 'Что нового',
    lead: 'Коротко о том, что добавили и исправили. Записи появляются с каждой новой версией приложения — от новой к старой.',
    version: 'Версия',
    current: 'Текущая версия',
    added: 'Добавлено',
    fixed: 'Исправлено',
    changed: 'Изменено',
    removed: 'Убрано',
  },
  shell: {
    search: 'Поиск и команды',
    notifications: 'Уведомления',
    noNotifications: 'Новых уведомлений нет',
    markAllRead: 'Прочитать все',
    notificationsTimes: '×{count}',
    collapseMenu: 'Свернуть меню',
    expandMenu: 'Развернуть меню',
    mainMenu: 'Главное меню',
    more: 'Ещё',
    profile: 'Профиль',
    security: 'Безопасность',
    theme: 'Тема',
    themeSystem: 'Как в системе',
    themeLight: 'Светлая',
    themeDark: 'Тёмная',
    logout: 'Выйти',
    navToday: 'Сегодня',
    navMessages: 'Сообщения',
    navMail: 'Почта',
    navTeam: 'Команда',
    navCatalog: 'Каталог',
    navClients: 'Клиенты',
    navSales: 'Продажи',
    navAudit: 'Журнал',
    navNews: 'Новости',
    navSettings: 'Настройки',
    commandTheme: 'Переключить тему',
    commandSecurity: 'Безопасность входа',
    expandCard: 'Развернуть',
    closeCard: 'Закрыть карточку',
    previous: 'Предыдущая',
    next: 'Следующая',
    backToList: 'К списку',
    personalNotifications: 'Уведомления',
    personalMail: 'Почта: подпись и картинки',
    commandPlaceholder: 'Найти или выполнить…',
    commandEmpty: 'Ничего не нашли — попробуйте другое слово',
    commandSearching: 'Ищем…',
    groupPages: 'Страницы',
    groupCommands: 'Команды',
    groupResults: 'Найдено',
    groupChats: 'Чаты',
    groupPeople: 'Люди',
    hotkeyHint: 'Клавиши: {keys}',
  },
  units: {
    hours: { one: '{count} час', few: '{count} часа', many: '{count} часов', other: '{count} часа' },
    minutes: { one: '{count} минута', few: '{count} минуты', many: '{count} минут', other: '{count} минуты' },
    days: { one: '{count} день', few: '{count} дня', many: '{count} дней', other: '{count} дня' },
    weeks: { one: '{count} неделя', few: '{count} недели', many: '{count} недель', other: '{count} недели' },
    workDays: {
      one: '{count} рабочий день',
      few: '{count} рабочих дня',
      many: '{count} рабочих дней',
      other: '{count} рабочего дня',
    },
    employees: {
      one: '{count} сотрудник',
      few: '{count} сотрудника',
      many: '{count} сотрудников',
      other: '{count} сотрудника',
    },
    hoursShort: '{value} ч',
    minutesShort: '{value} мин',
    perHour: '{value}/ч',
    justNow: 'сейчас',
    minutesAgo: '{value} мин',
    hoursAgo: '{value} ч',
    yesterday: 'вчера',
    bytes: '{value} Б',
    kilobytes: '{value} КБ',
    megabytes: '{value} МБ',
    gigabytes: '{value} ГБ',
    rub: '₽',
    percent: '%',
    hour: 'ч',
    times: '×',
    daysShort: 'дн.',
    workDaysShort: 'раб. дн.',
    monthsShort: 'мес.',
    hoursPerMonth: 'ч/мес',
  },
  audit: {
    title: 'Журнал',
    lead: 'Все изменения: кто, что и когда. Записи журнала нельзя изменить или удалить',
    filterActor: 'Кто',
    filterEntity: 'Объект',
    filterAction: 'Действие',
    filterPeriod: 'Период',
    anyone: 'Все',
    resetFilters: 'Сбросить фильтры',
    columnAt: 'Когда',
    columnActor: 'Кто',
    columnAction: 'Действие',
    columnEntity: 'Объект',
    columnChanges: 'Изменения',
    system: 'Система',
    empty: 'Записей пока нет',
    emptyFiltered: 'Под фильтры ничего не подходит',
    loadMore: 'Показать ещё',
    history: 'История',
    historyEmpty: 'Изменений пока не было',
    historyShow: 'Показать',
    historyHide: 'Скрыть',
    requestId: 'Запрос {id}',
    ip: 'IP {ip}',
    emptyValue: '—',
    yes: 'да',
    no: 'нет',
    moreChanges: 'и ещё {count}',
    actions: {
      user: {
        created: 'Создан пользователь',
        roles_changed: 'Изменены роли',
        two_factor_enabled: 'Включён код из приложения (2FA)',
        two_factor_disabled: 'Отключён код из приложения (2FA)',
        passkey_removed: 'Удалён ключ входа (passkey)',
        deactivated: 'Пользователь отключён',
        reactivated: 'Пользователь снова включён',
      },
      security_settings: {
        updated: 'Изменена защита входа',
      },
      invitation: {
        created: 'Создано приглашение',
        revoked: 'Приглашение отозвано',
        accepted: 'Приглашение принято',
      },
      file: {
        uploaded: 'Загружен файл',
      },
      studio: {
        updated: 'Изменены реквизиты студии',
      },
      employment: {
        form_changed: 'Изменена форма работы',
        changed: 'Изменены личные данные',
      },
      employee: {
        updated: 'Изменён профиль сотрудника',
        specializations_changed: 'Изменены специализации',
        rate_added: 'Новая личная ставка',
        rate_changed: 'Изменена будущая ставка',
        rate_removed: 'Удалена будущая ставка',
        avatar_changed: 'Изменено фото',
        absence_added: 'Добавлено отсутствие',
        absence_changed: 'Изменено отсутствие',
        absence_removed: 'Удалено отсутствие',
      },
      specialization: {
        created: 'Добавлена специализация',
        renamed: 'Специализация переименована',
        archived: 'Специализация в архиве',
        restored: 'Специализация возвращена из архива',
        rate_added: 'Новая плановая ставка',
        rate_changed: 'Изменена будущая ставка',
        rate_removed: 'Удалена будущая ставка',
      },
      calendar: {
        day_changed: 'Изменён день календаря',
      },
      tax: {
        profile_published: 'Новый налоговый профиль',
        profile_replaced: 'Заменён запланированный налоговый профиль',
        profile_removed: 'Отменён запланированный налоговый профиль',
      },
      catalog_item: {
        created: 'Создана услуга',
        changed: 'Изменена услуга',
        archived: 'Услуга в архиве',
        restored: 'Услуга возвращена из архива',
        cabinet_shown: 'Услуга показана в кабинете клиента',
        cabinet_hidden: 'Услуга скрыта из кабинета клиента',
        site_code_changed: 'Изменён код на сайте',
      },
      catalog_case: {
        created: 'Создан кейс',
        changed: 'Изменён кейс',
        published: 'Кейс опубликован',
        unpublished: 'Кейс снят с публикации',
        archived: 'Кейс в архиве',
        restored: 'Кейс возвращён из архива',
      },
      catalog_category: {
        created: 'Добавлена категория каталога',
        renamed: 'Категория каталога переименована',
        removed: 'Удалена категория каталога',
        cabinet_shown: 'Категория показана в кабинете клиента',
        cabinet_hidden: 'Категория скрыта из кабинета клиента',
      },
      deal: {
        created: 'Создан лид',
        changed: 'Изменена запись продаж',
        taken: 'Лид взят из очереди',
        converted: 'Лид стал сделкой',
        stage_changed: 'Изменён этап сделки',
        won: 'Сделка выиграна',
        lost: 'Сделка проиграна',
        rejected: 'Лид отклонён',
        reopened: 'Возвращена в работу',
        postponed: 'Отложена',
        resumed: 'Снята отложенность',
        responsible_changed: 'Назначен ответственный',
        participant_added: 'Позвали в сделку',
        participant_removed: 'Убрали из сделки',
        deleted: 'Удалена запись продаж',
        undeleted: 'Удаление записи продаж отменено',
        step_set: 'Поставлен следующий шаг',
        step_changed: 'Изменён следующий шаг',
        step_rescheduled: 'Перенесён следующий шаг',
        step_done: 'Шаг выполнен',
        step_removed: 'Удалён следующий шаг',
      },
      touch: {
        recorded: 'Записано касание',
        changed: 'Изменено касание',
        deleted: 'Удалено касание',
        undeleted: 'Удаление касания отменено',
      },
      sales_settings: {
        changed: 'Изменены настройки продаж',
        stage_renamed: 'Переименован этап',
        reason_added: 'Добавлена причина',
        reason_renamed: 'Переименована причина',
        reason_reordered: 'Переставлены причины',
        reason_archived: 'Причина в архиве',
        reason_restored: 'Причина возвращена из архива',
      },
      estimate: {
        created: 'Заведена смета',
        reset: 'Смета вернулась в черновик после правки',
        stage_added: 'Добавлен этап',
        stage_changed: 'Изменён этап',
        stage_removed: 'Удалён этап',
        stages_reordered: 'Переставлены этапы',
        task_added: 'Добавлена работа',
        task_changed: 'Изменена работа',
        task_removed: 'Удалена работа',
        catalog_added: 'Добавлена услуга из каталога',
        packages_changed: 'Изменены пакеты',
        coefficients_changed: 'Изменены коэффициенты сметы',
        price_set: 'Изменена цена пакета',
        submitted: 'Смета отправлена на проверку',
        approved: 'Смета утверждена',
        returned: 'Смета возвращена с замечаниями',
        stage_requested: 'Попросили оценить этап',
        stage_estimated: 'Этап оценён сотрудником',
        understanding_changed: 'Изменено «Понимание задачи»',
        stage_client_changed: 'Изменён текст этапа для клиента',
        task_client_changed: 'Изменён пункт «что входит»',
        discount_changed: 'Изменена скидка выгодой',
        ai_draft: 'Черновик сметы от ИИ записан',
        ai_draft_undone: 'Черновик ИИ отменён',
        plan_converted: 'Гант этапов переведён в план по задачам',
      },
      proposal: {
        composition_changed: 'Изменён состав КП',
        sent: 'КП отправлено',
        link_created: 'Создана ссылка на КП',
        link_revoked: 'Ссылка на КП отозвана',
        below_floor_requested: 'Запрошено одобрение КП в минус',
        below_floor_approved: 'Одобрена отправка КП в минус',
        response_recorded: 'Ответ клиента по КП',
      },
      proposal_settings: {
        changed: 'Изменены настройки КП',
      },
      proposal_tariff: {
        created: 'Добавлен тариф поддержки',
        changed: 'Изменён тариф поддержки',
        archived: 'Тариф поддержки в архиве',
        restored: 'Тариф поддержки возвращён из архива',
      },
      proposal_payment_template: {
        created: 'Добавлен шаблон графика оплат',
        changed: 'Изменён шаблон графика оплат',
        archived: 'Шаблон графика оплат в архиве',
        restored: 'Шаблон графика оплат возвращён из архива',
      },
      estimate_settings: {
        changed: 'Изменены настройки сметы',
      },
      ...ruAiAudit.actions,
      ...ruDocumentsAudit.actions,
      ...ruFinanceAudit.actions,
      ...ruFinanceBankAudit.actions,
      ...ruFinanceAcquiringAudit.actions,
      ...ruDadataAudit.actions,
      ...ruSiteConfigAudit.actions,
      ...ruHiringAudit.actions,
      ...ruEdoAudit.actions,
      ...ruProjectsAudit.actions,
      ...ruProjectsWorkAudit.actions,
      project: {
        ...ruProjectsAudit.actions.project,
        ...ruProjectsWorkAudit.actions.project,
        ...ruProjectsDeliveryAudit.actions.project,
        ...ruProjectsPaymentAudit.actions.project,
        ...ruProjectsSupportAudit.actions.project,
        ...ruProjectsClientAudit.actions.project,
      },
      client: {
        created: 'Создан клиент',
        changed: 'Изменён клиент',
        kind_changed: 'Изменён вид клиента',
        status_changed: 'Изменён статус клиента',
        responsible_changed: 'Назначен ответственный',
        docflow_changed: 'Изменён канал документов',
        ...ruEdoClientAudit,
        ...ruCabinetClientAudit,
        archived: 'Клиент в архиве',
        restored: 'Клиент возвращён из архива',
        deleted: 'Клиент удалён',
        undeleted: 'Удаление клиента отменено',
        contact_added: 'Добавлен контакт',
        contact_changed: 'Изменён контакт',
        contact_archived: 'Контакт в архиве',
        contact_restored: 'Контакт возвращён из архива',
        merged_in: 'К клиенту присоединён дубль',
        merged: 'Клиент объединён с другим',
      },
      coefficient: {
        created: 'Добавлен коэффициент',
        changed: 'Изменён коэффициент',
        archived: 'Коэффициент в архиве',
        restored: 'Коэффициент возвращён из архива',
      },
      pricing: {
        policy_published: 'Новая версия политики цены',
        policy_replaced: 'Заменена запланированная версия политики',
        policy_removed: 'Отменена запланированная версия политики',
        expense_added: 'Добавлен постоянный расход',
        expense_changed: 'Изменён постоянный расход',
        expense_deleted: 'Удалён постоянный расход',
        expense_restored: 'Возвращён постоянный расход',
      },
    },
    entities: {
      user: 'Пользователь',
      invitation: 'Приглашение',
      file: 'Файл',
      studio: 'Реквизиты студии',
      specialization: 'Специализация',
      employee: 'Сотрудник',
      employment: 'Форма работы и личные данные',
      calendar: 'Производственный календарь',
      pricing: 'Цена и накладные',
      tax: 'Налог',
      coefficient: 'Коэффициент',
      catalog_item: 'Услуга каталога',
      catalog_category: 'Категория каталога',
      catalog_case: 'Кейс',
      client: 'Клиент',
      deal: 'Сделка',
      touch: 'Касание',
      estimate: 'Смета',
      estimate_settings: 'Настройки сметы',
      proposal: 'КП',
      proposal_settings: 'Настройки КП',
      proposal_tariff: 'Тариф поддержки',
      proposal_payment_template: 'Шаблон графика оплат',
      ...ruAiAudit.entities,
      ...ruDocumentsAudit.entities,
      ...ruFinanceAudit.entities,
      ...ruFinanceBankAudit.entities,
      ...ruFinanceAcquiringAudit.entities,
      ...ruDadataAudit.entities,
      ...ruSiteConfigAudit.entities,
      ...ruHiringAudit.entities,
      ...ruEdoAudit.entities,
      ...ruProjectsAudit.entities,
      ...ruProjectsWorkAudit.entities,
      sales_settings: 'Настройки продаж',
      security_settings: 'Защита входа',
    },
    fields: {
      requireAdminTwoFactor: 'Обязательная 2FA для админов',
      brandColor: 'Фирменный цвет',
      label: 'Номер КП',
      sentVia: 'Как отправлено',
      validUntil: 'Действует до',
      marginReason: 'Причина низкой маржи',
      paymentEnabled: 'График оплат в КП',
      paymentTemplate: 'Шаблон оплат',
      supportTariffs: 'Тарифы поддержки в КП',
      supportPrices: 'Цены поддержки в КП',
      cases: 'Кейсы в КП',
      responseKind: 'Ответ клиента',
      responsePackage: 'Выбранный пакет',
      responseTotal: 'Итог выбора',
      responseNote: 'Что сказал клиент',
      responseStage: 'К этапу',
      markedBy: 'Отметил со слов клиента',
      validDays: 'Срок действия КП, дней',
      tmRangeLow: '«От» для почасовых',
      tmRangeHigh: '«До» для почасовых',
      yearlyDiscount: 'Скидка за год',
      supportSpecialization: 'Ставка поддержки по специализации',
      burnMonths: 'Часы сгорают, месяцев',
      followupWorkingDays: '«Созвониться по КП», раб. дней',
      aboutStudio: 'О студии',
      defaultTemplate: 'График оплат по умолчанию',
      tariffHours: 'Часов в месяц',
      paymentParts: 'Доли оплаты',
      understanding: 'Понимание задачи',
      clientTitle: 'Название для клиента',
      clientResult: 'Что получите',
      clientDescription: 'Описание для клиента',
      clientVisible: 'Показать в «что входит»',
      clientLabel: 'Подпись для клиента',
      discountLabel: 'Название скидки',
      roles: 'Роли',
      active: 'Активен',
      name: 'Имя',
      email: 'Email',
      position: 'Должность',
      status: 'Статус',
      expiresAt: 'Действует до',
      mime: 'Тип',
      size: 'Размер',
      sha256: 'Контрольная сумма',
      ratePerHour: 'Ставка в час',
      weeklyCapacity: 'Часов в неделю',
      billableShare: 'Оплачиваемое время',
      hiredAt: 'Работает с',
      specializations: 'Специализации',
      avatar: 'Фото',
      comment: 'Комментарий',
      effectiveFrom: 'С даты',
      legalForm: 'Форма',
      fullName: 'Полное наименование',
      shortName: 'Краткое наименование',
      inn: 'ИНН',
      kpp: 'КПП',
      ogrn: 'ОГРН',
      legalAddress: 'Юридический адрес',
      bankBik: 'БИК',
      bankName: 'Банк',
      bankCorrespondentAccount: 'Корр. счёт',
      bankAccount: 'Расчётный счёт',
      signerName: 'Подписант',
      signerPosition: 'Должность подписанта',
      signerBasis: 'Основание',
      signerUserId: 'Подписант в платформе',
      phone: 'Телефон',
      website: 'Сайт',
      timezone: 'Часовой пояс',
      logoFileId: 'Логотип',
      date: 'День',
      dayKind: 'Вид дня',
      overheadPerHour: 'Накладные в час',
      markup: 'Наценка',
      minMargin: 'Мин. маржа',
      roundingStep: 'Шаг округления',
      category: 'Статья',
      amount: 'Сумма',
      period: 'Сумма за',
      activeFrom: 'Действует с',
      activeTo: 'Последний день',
      incomeKind: 'Режим',
      incomeRate: 'Ставка налога',
      incomeMinRate: 'Минимальный налог',
      vatKind: 'НДС',
      vatRate: 'Ставка НДС',
      multiplier: 'Множитель',
      catalogCategory: 'Категория',
      caseClient: 'Клиент кейса',
      clientNameHidden: 'Название клиента скрыто',
      caseUrl: 'Ссылка на проект',
      caseYear: 'Год',
      caseFiles: 'Картинок',
      caseItems: 'Услуг',
      summary: 'Кратко',
      kind: 'Цена',
      fixedPrice: 'Фиксированная цена',
      tasks: 'Задачи',
      description: 'Описание',
      note: 'Подпись',
      clientKind: 'Вид',
      clientStatus: 'Статус',
      docflow: 'Документы',
      legalName: 'Юридическое название',
      address: 'Адрес',
      directorName: 'Руководитель',
      directorPost: 'Должность руководителя',
      directorBasis: 'Основание полномочий',
      source: 'Откуда пришёл',
      sourceNote: 'Уточнение',
      referredBy: 'Кто привёл',
      about: 'О клиенте',
      responsible: 'Ответственный',
      contact: 'Контакт',
      contactPosition: 'Должность контакта',
      contactChannels: 'Способы связи',
      contactRoles: 'Роли контакта',
      title: 'Название',
      phase: 'Фаза',
      stage: 'Этап',
      outcome: 'Итог',
      reason: 'Причина',
      outcomeNote: 'Комментарий к итогу',
      workKind: 'Вид работы',
      budget: 'Примерный бюджет',
      postponedUntil: 'Отложена до',
      repeat: 'Вторичное обращение',
      dealClient: 'Клиент',
      participant: 'Участник',
      mergedFrom: 'Присоединён дубль',
      mergedInto: 'Объединён с',
      moved: 'Перенесено',
      stepKind: 'Вид шага',
      stepTitle: 'Что сделать',
      stepDate: 'Срок шага',
      stepTime: 'Время шага',
      stepAssignee: 'Исполнитель шага',
      stepResult: 'Итог шага',
      touchKind: 'Вид касания',
      direction: 'Направление',
      touchAt: 'Когда',
      touchClient: 'Клиент',
      author: 'Кто записал',
      touchSummary: 'Сводка',
      queueReminderMinutes: 'Напоминать о лиде в очереди через, минут',
      workStart: 'Начало рабочего дня',
      workEnd: 'Конец рабочего дня',
      stageTitle: 'Название этапа',
      reasonKind: 'Список причин',
      reasonOrder: 'Порядок причин',
      taskMinutes: 'Часы',
      taskKind: 'Вид работы в смете',
      taskSpecialization: 'Специализация',
      taskPackages: 'Пакеты',
      stageDays: 'Срок этапа, дней',
      stageStart: 'Начало этапа',
      stagePeople: 'Людей на этапе',
      taskAfter: 'После задач',
      taskLag: 'Сдвиг, рабочих дней',
      taskDays: 'Длительность, дней',
      estimatePackages: 'Пакеты сметы',
      estimateCoefficients: 'Коэффициенты сметы',
      packageName: 'Пакет',
      packagePrice: 'Цена пакета',
      returnNote: 'Замечания',
      assignee: 'Исполнитель',
      reviewRequired: 'Проверка админом обязательна',
      ceiling: 'Потолок цены (над оптимумом)',
      productiveMinutes: 'Продуктивный день',
      employmentForm: 'Форма работы',
      employmentChanged: 'Изменены поля',
      ...ruAiAudit.fields,
      ...ruDocumentsAudit.fields,
      ...ruFinanceAudit.fields,
      ...ruFinanceBankAudit.fields,
      ...ruFinanceAcquiringAudit.fields,
      ...ruDadataAudit.fields,
      ...ruSiteConfigAudit.fields,
      ...ruHiringAudit.fields,
      ...ruEdoAudit.fields,
      ...ruProjectsAudit.fields,
      ...ruProjectsWorkAudit.fields,
      ...ruProjectsDeliveryAudit.fields,
      ...ruProjectsPaymentAudit.fields,
      ...ruProjectsSupportAudit.fields,
      ...ruProjectsClientAudit.fields,
    },
    dayKinds: {
      holiday: 'выходной',
      workday: 'рабочий выходной',
      short: 'на час короче',
    },
    statuses: {
      pending: 'ждёт ответа',
      accepted: 'принято',
      revoked: 'отозвано',
      expired: 'истекло',
      draft: 'черновик',
      review: 'на проверке',
      approved: 'утверждена',
    },
  },
  roles: {
    admin: 'Администратор',
    manager: 'Менеджер',
    member: 'Сотрудник',
  },
  system: {
    healthy: 'Система работает',
    pageNotFound: 'Такой страницы нет',
    toHome: 'На главную',
    crashed: 'Что-то пошло не так',
    crashedLead:
      'Обновите страницу. Если ошибка повторится, напишите администратору, что вы делали перед этим',
    reload: 'Обновить страницу',
  },
  errors: {
    common: {
      forbidden: 'Недостаточно прав для этого действия',
      not_found: 'Не нашли — возможно, объект удалён или перенесён в архив',
      conflict: 'Данные изменились, пока вы редактировали. Показываем актуальную версию',
      validation: 'Проверьте поле {field}',
      invalid_transition: 'Это действие недоступно в текущем состоянии',
      unauthorized: 'Войдите, чтобы продолжить',
      rate_limited: 'Слишком много запросов — подождите немного и попробуйте снова',
      unexpected: 'Что-то пошло не так. Код: {requestId}',
    },
    vault: {
      title_required: 'Укажите название записи',
      title_too_long: 'Название записи — не длиннее {max} знаков',
      url_invalid: 'Адрес входа — ссылка вида https://…',
      epoch_conflict: 'Ключ сейфа только что сменился — повторите',
      envelopes_mismatch: 'Состав доступа изменился — повторите',
      entries_mismatch: 'Записи сейфа изменились — повторите',
    },
    secret_chat: {
      device_required:
        'Не у всех есть подтверждённое устройство для секретных чатов: {names}. Им нужно открыть «Настройки → Безопасность → Устройства»',
      epoch_conflict: 'Ключ чата только что сменился — сообщение отправится заново',
      envelopes_mismatch: 'Состав участников изменился — повторите',
      not_secret: 'Это не секретный чат',
      unsupported: 'В секретном чате так нельзя: сервер не видит текста сообщений',
      file_not_encrypted: 'Файл не зашифрован — отправьте его заново',
    },
    calls: {
      recording_e2ee: 'Сквозной звонок не записывается: ключа нет даже у сервера',
    },
    e2ee: {
      device_unknown: 'Это устройство не найдено — обновите страницу',
      device_revoked: 'Это устройство отключено: ключи секретных чатов на нём стёрты',
      device_pending: 'Сначала подтвердите это устройство фразой восстановления или с другого устройства',
      signature_invalid: 'Подпись ключа не сошлась — проверьте фразу восстановления',
      key_exists: 'Ключ шифрования уже создан — подтвердите устройство фразой восстановления',
      key_missing: 'Ключ шифрования ещё не создан',
      backup_conflict: 'Ключи изменились на другом устройстве — повторите',
    },
    crypto: {
      key_unavailable:
        'Данные зашифрованы ключом, которого сейчас нет на сервере, — обратитесь к администратору. Изменения не сохранены, чтобы не затереть данные',
    },
    org: {
      requisite_invalid: 'Реквизиты не сохранены: {problem}',
      signer_inactive: 'Подписантом в платформе может быть только действующий сотрудник',
      specialization_exists: 'Специализация «{name}» уже есть',
      specialization_name_required: 'Назовите специализацию — например, «Дизайн» или «Фронтенд»',
      specialization_name_too_long: 'Название специализации длиннее 100 символов — сократите',
      rate_date_in_past: 'Ставку задним числом не задать — выберите сегодня или дату позже',
      absence_kind_invalid: 'Выберите вид: отпуск, больничный или отгул',
      absence_dates_invalid: 'Укажите даты: начало не позже конца, не дольше года',
      absence_note_too_long: 'Заметка длиннее 200 знаков — сократите',
      absence_overlaps: 'На эти даты у сотрудника уже есть отсутствие — поправьте его',
      capacity_invalid: 'Ёмкость — от 0 до 168 часов в неделю',
      billable_share_invalid: 'Доля оплачиваемого времени — от 0 до 100%',
      rate_date_taken: 'На эту дату ставка уже есть — поменяйте её или выберите другую дату',
      rate_in_effect_immutable:
        'Ставку, которая уже действует, изменить нельзя — добавьте новую с нужной даты',
      avatar_invalid: 'Фото не сохранено: нужна картинка JPEG, PNG или WebP до 5 МБ — загрузите её заново',
      employment_invalid: 'Данные не сохранены: {field} — {problem}',
      employment_form_required: 'Сначала администратор выбирает форму работы сотрудника',
    },
    pricing: {
      policy_in_effect_immutable: 'Действующую политику изменить нельзя — создайте новую версию с даты',
      policy_date_in_past: 'Политику задним числом не задать — выберите сегодня или дату позже',
      policy_unchanged: 'Значения те же, что в предыдущей версии, — цены не изменятся, новая версия не нужна',
      policy_overhead_invalid: 'Накладные — от 0 до 100 000 ₽ в час',
      policy_markup_invalid: 'Наценка — от 0 до 1 000%',
      policy_min_margin_invalid: 'Минимальная маржа — от 0 до 99%',
      policy_rounding_step_invalid: 'Шаг округления — 1, 10, 100 или 1 000 ₽',
      expense_name_required: 'Назовите расход — например, «Аренда офиса» (до 200 символов)',
      expense_amount_invalid: 'Сумма расхода — больше нуля',
      expense_dates_invalid: 'Последний день расхода — не раньше первого',
      tax_date_in_past: 'Налоговый профиль задним числом не задать — выберите сегодня или дату позже',
      tax_in_effect_immutable: 'Действующий налоговый профиль изменить нельзя — создайте новый с даты',
      tax_unchanged: 'Значения те же, что в предыдущем профиле, — новый профиль не нужен',
      tax_income_rate_invalid: 'Ставка налога — от 0 до 30%',
      tax_min_rate_invalid: 'Минимальный налог — от 0 до 30%, только для УСН «доходы минус расходы»',
      tax_vat_rate_invalid: 'Ставка НДС — от 1 до 30%; без НДС ставка не указывается',
      coefficient_name_required: 'Назовите коэффициент — например, «Срочный запуск» (до 100 символов)',
      coefficient_multiplier_invalid: 'Множитель — от ×0,1 до ×10',
      coefficient_exists: 'Коэффициент «{name}» уже есть',
      margin_below_min: 'Маржа {marginRate} ниже минимальной {minMargin} — нужно подтверждение админа',
    },
    documents: ruDocumentsErrors,
    edo: ruEdoErrors,
    cabinet: ruCabinetErrors,
    finance: { ...ruFinanceErrors, ...ruFinanceBankErrors, ...ruFinanceAcquiringErrors },
    projects: {
      ...ruProjectsErrors,
      ...ruProjectsWorkErrors,
      ...ruProjectsDeliveryErrors,
      ...ruProjectsPaymentErrors,
      ...ruProjectsSupportErrors,
      ...ruProjectsClientErrors,
    },
    catalog: {
      card_without_price: 'Карточку услуги не собрать, пока не посчитана цена — посмотрите вкладку «Цена»',
      category_name_required: 'Назовите категорию — например, «Сайты» (до 100 символов)',
      category_exists: 'Категория «{name}» уже есть',
      category_not_empty: 'В категории «{name}» есть услуги — перенесите их, прежде чем удалять',
      category_missing: 'Такой категории нет — выберите другую',
      item_name_required: 'Назовите услугу — например, «Лендинг» (до 200 символов)',
      item_summary_too_long: 'Краткое описание — до 300 символов',
      item_fixed_price_required: 'Укажите фиксированную цену больше нуля',
      item_too_many_tasks: 'В шаблоне больше 200 задач — объедините мелкие',
      task_title_required: 'Назовите задачу № {number}',
      task_minutes_invalid: 'Часы задачи № {number} — от 1 минуты до 1 000 часов',
      task_specialization_missing: 'У задачи указана специализация, которой нет, — выберите другую',
      case_title_required: 'Назовите кейс — например, «Интернет-магазин для «Севера»» (до 200 символов)',
      case_client_too_long: 'Название клиента длиннее 200 символов — сократите',
      case_summary_too_long: 'Краткое описание кейса — до 500 символов',
      case_summary_required: 'Чтобы опубликовать кейс, напишите краткое описание — его увидит клиент',
      case_archived: 'Кейс в архиве — верните его, чтобы опубликовать',
      case_url_invalid: 'Ссылка на проект написана с ошибкой — например, example.ru',
      case_year_invalid: 'Год — от 1990 до 2100',
      case_gallery_too_many: 'В галерее не больше {max} картинок',
      case_items_too_many: 'К кейсу привязано слишком много услуг — оставьте самые близкие',
      case_item_missing: 'Одной из услуг кейса нет в каталоге — выберите другую',
      case_file_not_image: 'Обложка и галерея — только картинки',
    },
    clients: {
      inn_taken: 'Клиент с этим ИНН уже есть: {name}',
      email_taken: 'Эта почта уже у {holder}',
      name_required: 'Назовите клиента — так его увидят коллеги',
      name_too_long: 'Название длиннее {max} символов — сократите',
      requisite_invalid: 'Реквизиты не сохранены: {problem}',
      website_invalid: 'Адрес сайта написан с ошибкой — например, glory.studio',
      contact_required: 'Для физлица укажите телефон или почту — иначе с ним не связаться',
      contact_name_required: 'Назовите контакт — например, «Анна Смирнова»',
      contact_too_many_channels: 'У контакта больше {max} способов связи — оставьте нужные',
      channel_invalid: 'Не разобрать: {kind} — проверьте значение',
      person_name_on_client: 'У физлица имя меняется в карточке клиента',
      person_contact_fixed: 'У физлица контакт — сам клиент: чтобы убрать его, отправьте клиента в архив',
      kind_change_forbidden:
        'Вид меняется между организацией и ИП, а физлицо можно сделать организацией или ИП; обратно в физлицо — нельзя',
      delete_has_history: 'У клиента есть сделки или касания — его можно только отправить в архив',
      archived: 'Клиент в архиве — верните его, чтобы продолжить',
      docflow_person: 'У физлица нет ЭДО — документы уходят ссылкой на подписание',
      responsible_unavailable: 'Этот сотрудник отключён — выберите другого ответственного',
      merge_same: 'Выберите двух разных клиентов',
      merge_already: 'Этот клиент уже объединён с другим — откройте основного',
      merge_primary_merged: 'Основной клиент уже объединён с другим — выберите того, с кем он объединён',
      merge_primary_archived:
        'Основной клиент в архиве — верните его из архива или поменяйте клиентов местами',
      merge_inn_conflict: 'У клиентов разные ИНН — объединить нельзя',
      merged: 'Клиент объединён с другим — откройте основного',
    },
    sales: {
      lead_already_taken: 'Лид уже взял {name}',
      convert_incomplete: 'Чтобы сделать сделку, заполните: {fields}',
      reason_required: 'Выберите причину',
      reason_invalid: 'Такой причины нет — выберите из списка',
      postpone_date_past: 'Отложить можно только на будущую дату',
      postpone_date_invalid: 'Дата написана с ошибкой — выберите её в календаре',
      reopen_won_forbidden: 'Вернуть выигранную сделку может только админ',
      reopen_forbidden: 'Вернуть в работу может ответственный или менеджер',
      client_archived: 'Клиент в архиве — верните его, чтобы завести лид',
      client_deleted: 'Клиент удалён — верните его, чтобы вернуть и сделку',
      not_a_lead: 'Это уже сделка — действие доступно только лиду',
      not_a_deal: 'Это ещё лид — сначала сделайте его сделкой',
      deal_closed: 'Запись закрыта — верните её в работу, чтобы продолжить',
      not_closed: 'Запись и так в работе',
      name_required: 'Введите имя — так коллеги узнают, кто обратился',
      name_too_long: 'Имя длиннее {max} символов — сократите',
      title_required: 'Назовите сделку — например, «Сайт для пекарни»',
      title_too_long: 'Название длиннее {max} символов — сократите',
      contact_required: 'Укажите телефон или почту — иначе с человеком не связаться',
      budget_invalid: 'Бюджет — сумма от 0 до 1 000 000 000 ₽',
      note_too_long: 'Комментарий длиннее {max} символов — сократите',
      participant_unavailable: 'Этот сотрудник отключён или не работает с продажами — выберите другого',
      participant_is_responsible: 'Ответственный и так в сделке — звать его не нужно',
      step_done: 'Шаг выполнен — выполненные шаги не правят. Поставьте новый',
      step_exists: 'У записи уже есть следующий шаг — измените его или отметьте выполненным',
      step_title_required: 'Напишите, что нужно сделать — например, «Позвонить»',
      step_title_too_long: 'Описание шага длиннее {max} символов — сократите',
      step_date_invalid: 'Дата шага написана с ошибкой — выберите её в календаре',
      step_time_invalid: 'Время шага написано с ошибкой — выберите его в списке',
      step_result_too_long: 'Итог длиннее {max} символов — сократите',
      step_assignee_unavailable:
        'Исполнителем может быть ответственный, участник сделки или менеджер, который работает с продажами',
      touch_summary_required: 'Напишите, о чём договорились, — так звонок не потеряется',
      touch_summary_too_long: 'Сводка длиннее {max} символов — сократите',
      touch_at_future: 'Касание ещё не случилось — выберите время не позже текущего',
      call_step_needs_deal: 'Следующий шаг ставится у сделки — выберите сделку клиента',
      touch_client_required: 'Выберите клиента или контакт, которому звонили',
      queue_timer_invalid: 'Время ожидания — от {min} до {max} минут',
      work_hours_invalid: 'Начало рабочего дня должно быть раньше конца',
      stage_title_required: 'Назовите этап — или нажмите «Сбросить», чтобы вернуть прежнее название',
      stage_title_too_long: 'Название этапа длиннее {max} символов — сократите',
      stage_title_taken: 'Этап «{title}» уже есть — названия этапов не повторяются',
      reason_title_required: 'Назовите причину — например, «Дорого»',
      reason_title_too_long: 'Причина длиннее {max} символов — сократите',
      reason_exists: 'Причина «{title}» уже есть в этом списке',
      reason_last:
        'Это последняя причина списка — без неё нечем будет закрывать записи. Сначала добавьте другую',
      month_invalid: 'Месяц указан неверно — выберите его в списке',
    },
    ai: ruAiErrors,
    estimates: {
      ...ruBriefErrors,
      deal_required: 'Смету можно завести только у сделки — переведите лид в сделку',
      deal_closed: 'Сделка закрыта — смета не правится. Верните сделку в работу',
      edit_forbidden: 'Смету правит ответственный за сделку или менеджер с доступом ко всем продажам',
      exists: 'У этой сделки уже есть смета',
      package_empty: 'В пакете «{package}» нет ни одной работы',
      packages_invalid: 'Выберите от одного до трёх пакетов, у каждого — своё название (до {max} символов)',
      stage_title_required: 'Назовите этап — например, «Дизайн»',
      stage_title_too_long: 'Название этапа длиннее {max} символов — сократите',
      stages_too_many: 'В смете не больше {max} этапов',
      task_title_required: 'Назовите работу — например, «Макет главной страницы»',
      task_title_too_long: 'Название работы длиннее {max} символов — сократите',
      task_specialization_required: 'Выберите специализацию — по ней считается ставка',
      task_specialization_unavailable: 'Такой специализации нет или она в архиве — выберите из списка',
      task_minutes_invalid: 'Время работы — до 1 000 часов; у работы по часам — хотя бы минута',
      task_price_invalid: 'Цена работы — сумма от 1 ₽ до 1 000 000 000 ₽',
      task_packages_invalid: 'Отметки пакетов — «Б», «О» и «М»',
      tasks_too_many: 'В смете не больше {max} работ',
      schedule_invalid:
        'Срок этапа написан с ошибкой: сдвиг — до года рабочих дней, срок — от 1 дня, людей — от 1, «вместе с» — один из этапов выше',
      link_cycle: 'Связь создаёт круг: задача зависела бы сама от себя',
      link_invalid: 'Связать можно только задачи этой сметы',
      assignee_inactive: 'Сотрудник отключён — выберите другого',
      plan_invalid: 'Сдвиг — от 0 до 365 рабочих дней, длительность — от 1 до 1 000 дней',
      correction_invalid: 'Цена пакета вне допустимых пределов — от десятой доли до десятикратного оптимума',
      price_unavailable:
        'Цену не посчитать: нужны политика цены, налог и плановые ставки специализаций работ',
      package_not_in_estimate: 'Такого пакета в смете нет — включите его в «Пакетах»',
      catalog_item_unavailable: 'Услуга в архиве или удалена — выберите другую',
      catalog_item_empty: 'В услуге нет работ — добавьте задачи в каталоге',
      coefficient_unavailable: 'Такого коэффициента нет или он в архиве — выберите из списка',
      not_draft: 'Смета уже на проверке или утверждена — внесите правку, и она вернётся в черновик',
      not_in_review: 'Смета не на проверке',
      already_approved: 'Смета уже утверждена',
      return_note_required: 'Напишите, что поправить, — автор увидит замечания',
      note_too_long: 'Текст длиннее {max} символов — сократите',
      request_exists: 'Этого сотрудника уже попросили оценить этот этап',
      request_assignee_unavailable: 'Сотрудник отключён или не работает с продажами — выберите другого',
      request_closed: 'Оценка уже сдана — запрос закрыт',
      settings_ceiling_invalid: 'Потолок цены — доля от 0 до 1 000 %',
      settings_productive_invalid: 'Продуктивный день — от 1 до 12 часов',
      client_text_too_long: 'Текст длиннее {max} символов — сократите',
      discount_without_correction:
        'Скидка показывается у пакета с «Корректировкой» — сначала поменяйте цену пакета',
      document_invalid: 'Текст не сохранился: формат документа не распознан — обновите страницу и повторите',
    },
    proposals: {
      deal_closed: 'Сделка закрыта — КП не правится. Верните сделку в работу',
      edit_forbidden: 'КП правит ответственный за сделку или менеджер с доступом ко всем продажам',
      not_ready: 'КП пока не собрать: {problem}',
      review_required: 'КП можно отправить после проверки админом',
      margin_reason_required: 'Маржа ниже минимальной — напишите причину',
      margin_reason_too_long: 'Причина длиннее {max} символов — сократите',
      below_floor: 'Цена ниже себестоимости — нужно одобрение админа',
      below_floor_not_needed: 'Цена не ниже себестоимости — одобрение не нужно',
      link_expired: 'Предложение истекло',
      link_revoked: 'Предложение отозвано',
      version_superseded: 'Есть обновлённое предложение',
      proposal_accepted: 'Предложение уже принято — чтобы что-то поменять, напишите менеджеру',
      version_not_found: 'Такой версии КП нет',
      link_not_found: 'Ссылка не найдена — проверьте адрес или попросите менеджера прислать её ещё раз',
      question_empty: 'Напишите вопрос — хотя бы пару слов',
      preview_expired: 'Предпросмотр устарел — откройте его заново со страницы КП',
      selection_invalid: 'Выбор не подходит к этому КП — выберите пакет и тариф из предложенных',
      decline_reason_invalid: 'Выберите причину из списка',
      response_text_too_long: 'Текст длиннее {max} символов — сократите',
      tariff_unavailable: 'Тарифа поддержки нет или он в архиве — выберите из списка',
      case_unavailable: 'Кейс не опубликован или в архиве — выберите другой',
      cases_too_many: 'В КП не больше {max} кейсов — оставьте самые близкие',
      valid_until_invalid: '«Действует до» — не раньше сегодняшнего дня',
      support_price_invalid: 'Цена поддержки — сумма от 1 ₽ до 1 000 000 000 ₽',
      template_unavailable: 'Такого шаблона графика оплат нет или он в архиве — выберите другой',
      template_is_default: 'Этот шаблон выбран по умолчанию — сначала выберите другой',
      template_name_required: 'Назовите шаблон — например, «50 / 50» (до 60 символов)',
      template_parts_invalid: 'В шаблоне от одной до восьми долей',
      template_label_invalid: 'У каждой доли должна быть подпись — например, «Предоплата» (до 80 символов)',
      template_share_invalid: 'Доля — больше нуля и не больше 100 %',
      template_sum_invalid: 'Доли вместе должны давать ровно 100 %',
      template_trigger_invalid: 'Выберите, когда платится доля',
      template_stage_invalid: 'Номер этапа — от 1',
      tariff_name_required: 'Назовите тариф — например, «10 ч» (до 60 символов)',
      tariff_hours_invalid: 'Часы в месяц — целое число от 1 до 744',
      settings_valid_days_invalid: 'Срок действия КП — от 1 до 365 дней',
      settings_tm_range_invalid:
        '«От–до» для почасовых: нижняя граница не выше верхней, обе — от ×0,0001 до ×10',
      settings_yearly_discount_invalid: 'Скидка за год — от 0 до 90 %',
      settings_burn_months_invalid: 'Часы сгорают через 0–24 месяца (0 — не сгорают)',
      settings_followup_invalid: 'Шаг «Созвониться по КП» — через 0–30 рабочих дней',
      settings_about_too_long: 'Текст «О студии» — до 2 000 символов',
      settings_specialization_unavailable: 'Такой специализации нет или она в архиве — выберите из списка',
    },
    messenger: {
      not_member: 'Вы не участник этого чата',
      direct_members_fixed: 'В личный чат нельзя добавить участников — создайте группу',
      direct_self: 'Заметки себе — в «Избранном»',
      user_unavailable: 'Сотрудник отключён — начать с ним переписку нельзя',
      studio_members_auto: 'Состав «Студии» ведёт платформа: сотрудники попадают в неё после приглашения',
      title_required: 'Назовите чат — например, «Дизайн»',
      title_too_long: 'Название длиннее {max} символов — сократите',
      not_group_admin: 'Это может сделать владелец или администратор группы',
      edit_not_author: 'Изменить можно только своё сообщение',
      delete_forbidden: 'Удалить это сообщение может только автор',
      system_not_editable: 'Системные сообщения не изменяются',
      message_deleted: 'Сообщение уже удалено',
      message_empty: 'Пустое сообщение не отправить — напишите текст или прикрепите файл',
      message_too_long: 'Сообщение длиннее {limit} символов — разделите его',
      body_invalid: 'Сообщение не разобрать — обновите страницу и попробуйте снова',
      too_many_attachments: 'В сообщении до {max} вложений — остальные отправьте следующим',
      message_id_taken: 'Не удалось отправить: обновите страницу и отправьте снова',
      reply_other_topic: 'Ответить можно только на сообщение из этой же темы',
      topic_closed: 'Тема закрыта — откройте её или напишите в «Общее»',
      scheduled_in_past: 'Время отправки уже прошло — выберите время позже',
      scheduled_too_far: 'Отложить можно не дальше чем на год — выберите ближайшую дату',
      scheduled_done: 'Это сообщение уже отправлено или отменено — обновите список',
      remind_in_past: 'Время напоминания уже прошло — выберите время позже',
      chat_archived: 'Объект в архиве — писать в этот чат нельзя',
      search_too_broad: 'Уточните поиск: добавьте слово, выберите чат или автора',
      rate_limited: 'Слишком много сообщений подряд — подождите несколько секунд',
      too_many_reactions: 'На сообщении уже {max} разных реакций — выберите одну из них',
      pin_thread_reply: 'Закрепить можно сообщение ленты, а не ответ в треде',
      attachment_used: 'Этот файл уже отправлен — загрузите его ещё раз',
      voice_too_long: 'Голосовое длиннее 30 минут — разделите запись',
      folder_title_required: 'Назовите папку — например, «Работа»',
      folder_empty: 'В папке ничего нет — выберите виды чатов или добавьте чаты',
      folder_too_many_chats: 'В папке больше {max} отдельных чатов — выберите вид чатов целиком',
      folders_limit: 'Своих папок может быть до {max} — удалите ненужную',
      pin_limit: 'Закрепить можно до {max} чатов — открепите какой-нибудь',
      topic_general_fixed: 'Тему «Общее» нельзя переименовать или закрыть',
      topic_entity_managed: 'Эта тема следует за задачей — изменить её можно в самой задаче',
      topics_unavailable: 'В личных чатах и «Избранном» тем нет — создайте группу',
      entity_member_auto: 'Вы в этом чате по назначению — отключите уведомления вместо выхода',
      calls_unavailable: 'Звонки не настроены: не задан сервер связи. Обратитесь к администратору платформы',
      call_unavailable_here: 'В «Избранном» звонить некому — откройте личный чат или группу',
    },
    identity: {
      employment_form_invalid: 'Выберите форму работы из списка',
      invite_expired: 'Приглашение истекло — попросите администратора отправить новое',
      invite_used: 'Приглашение уже принято — войдите со своим паролем',
      invite_revoked: 'Приглашение отозвано — попросите администратора отправить новое',
      invite_not_found: 'Приглашение не найдено — проверьте ссылку целиком',
      email_taken: 'Пользователь с адресом {email} уже есть',
      last_admin: 'Нельзя оставить платформу без администратора',
      two_factor_required:
        'Включите вход с кодом из приложения или ключом (passkey) — без этого работа в платформе закрыта',
      cannot_deactivate_self: 'Нельзя отключить собственную учётную запись',
      account_deactivated: 'Учётная запись отключена — обратитесь к администратору',
      bootstrap_not_empty: 'Первого администратора можно создать только в пустой базе',
      roles_required: 'Выберите хотя бы одну роль',
      password_too_short: 'Пароль слишком короткий — нужно не меньше {min} символов',
      password_too_long: 'Пароль слишком длинный — не больше {max} символов',
      name_required: 'Укажите имя — так вас увидят коллеги',
    },
    mail: {
      address_taken: 'Адрес {address} уже занят',
      address_empty: 'Укажите имя ящика — часть адреса до @',
      address_too_long: 'Имя ящика слишком длинное — не больше 64 латинских или 32 русских букв',
      address_invalid:
        'В имени ящика только буквы, цифры, точка, дефис и подчёркивание — без пробелов, без точки в начале и в конце',
      address_mixed_scripts: 'В имени ящика смешаны латиница и кириллица — оставьте один алфавит',
      address_reserved: 'Адрес {address} служебный — выберите другой',
      not_configured: 'Почтовый сервер для платформы пока не настроен',
      server_unavailable: 'Почтовый сервер не отвечает — попробуйте через минуту',
      server_rejected: 'Почтовый сервер не выполнил запрос — попробуйте ещё раз',
      mailbox_required: 'У вас пока нет рабочего ящика — попросите администратора его создать',
      mailbox_not_ready: 'Рабочий ящик ещё не готов — подождите, пока почтовый сервер его создаст',
      not_shared: 'Доступ выдаётся только к общим ящикам',
      user_has_no_mailbox: 'У сотрудника {name} нет рабочего ящика — сначала создайте его',
      person_has_mailbox: 'У сотрудника уже есть ящик {address}',
      app_password_name_required: 'Назовите пароль — например, «Thunderbird на ноутбуке»',
      mailbox_forbidden: 'Нет доступа к этому ящику — попросите администратора',
      mailbox_disabled: 'Ящик {address} отключён — письма в нём недоступны',
      mailbox_read_only: 'Этот ящик только для чтения — менять письма здесь нельзя',
      message_not_found: 'Письмо не найдено — возможно, его уже удалили',
      thread_not_found: 'Цепочка писем не найдена — возможно, её уже удалили',
      recipient_invalid: 'Адрес {address} написан с ошибкой',
      recipient_rejected: 'Почтовый сервер не принял один из адресов — проверьте получателей',
      recipients_required: 'Укажите хотя бы одного получателя',
      send_forbidden: 'С этого ящика можно только читать — отправка не разрешена',
      message_too_large: 'Письмо больше {limit} — отправьте файлы ссылкой',
      over_quota: 'Ящик переполнен — освободите место, удалив ненужные письма',
      cannot_unsend: 'Письмо уже ушло — отменить отправку нельзя',
      attachment_missing: 'Вложение не найдено — загрузите файл ещё раз',
      folder_not_empty: 'В папке есть вложенные папки — сначала удалите или переместите их',
      folder_exists: 'Папка с таким названием уже есть',
      folder_forbidden: 'В этом ящике нельзя менять папки',
      folder_system: 'Системную папку нельзя изменить',
      draft_not_found: 'Черновик не найден — возможно, его уже отправили или удалили',
    },
    files: {
      too_large: 'Файл больше {limit} — сожмите его или загрузите по частям',
      empty: 'Файл пустой — выберите другой',
      upload_incomplete: 'Файл загрузился не полностью — попробуйте ещё раз',
      not_ready: 'Файл ещё загружается — подождите несколько секунд',
    },
    requisites: {
      suggestions_unavailable: 'Подсказки реквизитов сейчас недоступны — введите вручную',
      key_format: 'Ключ DaData — 40 латинских букв и цифр. Скопируйте его целиком из личного кабинета DaData',
      key_rejected:
        'DaData не приняла ключ. Проверьте API-ключ в личном кабинете DaData и подтверждена ли почта',
      secret_rejected: 'DaData не приняла секретный ключ — баланс и статистика DaData недоступны',
      limit_invalid: 'Лимит в сутки — целое число от 1 до 10 000 000',
      not_connected: 'Сначала сохраните ключ DaData',
    },
  },
  validation: {
    required: 'Обязательное поле',
    inn_format: 'ИНН — 10 цифр у организации или 12 у ИП и физлица',
    inn_checksum: 'Неверный ИНН: не сходится контрольное число',
    kpp_format: 'КПП — 9 символов: 4 цифры, 2 цифры или буквы, 3 цифры',
    ogrn_format: 'ОГРН — 13 цифр, ОГРНИП — 15 цифр',
    ogrn_checksum: 'Неверный ОГРН: не сходится контрольное число',
    bik_format: 'БИК — 9 цифр, начинается с 04',
    account_format: 'Счёт — 20 цифр',
    account_checksum: 'Счёт не сходится с БИК — проверьте цифры',
    brand_color: 'Цвет — «#» и шесть символов 0–9, A–F, например #E30613',
    inn_not_individual: 'У ИП ИНН из 12 цифр — это ИНН организации; смените форму на «Организация»',
    inn_not_legal: 'У организации ИНН из 10 цифр — это ИНН предпринимателя; смените форму на «ИП»',
    ogrn_not_individual: 'У ИП — ОГРНИП из 15 цифр',
    ogrn_not_legal: 'У организации — ОГРН из 13 цифр',
  },
} as const;

export type Dictionary = typeof ru;
